"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// node_modules/lodash/lodash.js
var require_lodash = __commonJS({
  "node_modules/lodash/lodash.js"(exports2, module2) {
    "use strict";
    (function() {
      var undefined2;
      var VERSION2 = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        [
          "ary",
          WRAP_ARY_FLAG
        ],
        [
          "bind",
          WRAP_BIND_FLAG
        ],
        [
          "bindKey",
          WRAP_BIND_KEY_FLAG
        ],
        [
          "curry",
          WRAP_CURRY_FLAG
        ],
        [
          "curryRight",
          WRAP_CURRY_RIGHT_FLAG
        ],
        [
          "flip",
          WRAP_FLIP_FLAG
        ],
        [
          "partial",
          WRAP_PARTIAL_FLAG
        ],
        [
          "partialRight",
          WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
          "rearg",
          WRAP_REARG_FLAG
        ]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
      ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
      ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
      ].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
          rsBreak,
          rsUpper,
          "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
          rsBreak,
          rsUpper + rsMiscLower,
          "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "\xC0": "A",
        "\xC1": "A",
        "\xC2": "A",
        "\xC3": "A",
        "\xC4": "A",
        "\xC5": "A",
        "\xE0": "a",
        "\xE1": "a",
        "\xE2": "a",
        "\xE3": "a",
        "\xE4": "a",
        "\xE5": "a",
        "\xC7": "C",
        "\xE7": "c",
        "\xD0": "D",
        "\xF0": "d",
        "\xC8": "E",
        "\xC9": "E",
        "\xCA": "E",
        "\xCB": "E",
        "\xE8": "e",
        "\xE9": "e",
        "\xEA": "e",
        "\xEB": "e",
        "\xCC": "I",
        "\xCD": "I",
        "\xCE": "I",
        "\xCF": "I",
        "\xEC": "i",
        "\xED": "i",
        "\xEE": "i",
        "\xEF": "i",
        "\xD1": "N",
        "\xF1": "n",
        "\xD2": "O",
        "\xD3": "O",
        "\xD4": "O",
        "\xD5": "O",
        "\xD6": "O",
        "\xD8": "O",
        "\xF2": "o",
        "\xF3": "o",
        "\xF4": "o",
        "\xF5": "o",
        "\xF6": "o",
        "\xF8": "o",
        "\xD9": "U",
        "\xDA": "U",
        "\xDB": "U",
        "\xDC": "U",
        "\xF9": "u",
        "\xFA": "u",
        "\xFB": "u",
        "\xFC": "u",
        "\xDD": "Y",
        "\xFD": "y",
        "\xFF": "y",
        "\xC6": "Ae",
        "\xE6": "ae",
        "\xDE": "Th",
        "\xFE": "th",
        "\xDF": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      var freeExports = typeof exports2 == "object" && exports2 && !exports2.nodeType && exports2;
      var freeModule = freeExports && typeof module2 == "object" && module2 && !module2.nodeType && module2;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      __name(apply, "apply");
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      __name(arrayAggregator, "arrayAggregator");
      function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }
      __name(arrayEach, "arrayEach");
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      __name(arrayEachRight, "arrayEachRight");
      function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (!predicate(array[index], index, array)) {
            return false;
          }
        }
        return true;
      }
      __name(arrayEvery, "arrayEvery");
      function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      __name(arrayFilter, "arrayFilter");
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      __name(arrayIncludes, "arrayIncludes");
      function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }
        return false;
      }
      __name(arrayIncludesWith, "arrayIncludesWith");
      function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }
        return result;
      }
      __name(arrayMap, "arrayMap");
      function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while (++index < length) {
          array[offset + index] = values[index];
        }
        return array;
      }
      __name(arrayPush, "arrayPush");
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index];
        }
        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }
      __name(arrayReduce, "arrayReduce");
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      __name(arrayReduceRight, "arrayReduceRight");
      function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }
        return false;
      }
      __name(arraySome, "arraySome");
      var asciiSize = baseProperty("length");
      function asciiToArray(string) {
        return string.split("");
      }
      __name(asciiToArray, "asciiToArray");
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      __name(asciiWords, "asciiWords");
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      __name(baseFindKey, "baseFindKey");
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }
      __name(baseFindIndex, "baseFindIndex");
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      __name(baseIndexOf, "baseIndexOf");
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (comparator(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      __name(baseIndexOfWith, "baseIndexOfWith");
      function baseIsNaN(value) {
        return value !== value;
      }
      __name(baseIsNaN, "baseIsNaN");
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
      }
      __name(baseMean, "baseMean");
      function baseProperty(key) {
        return function(object) {
          return object == null ? undefined2 : object[key];
        };
      }
      __name(baseProperty, "baseProperty");
      function basePropertyOf(object) {
        return function(key) {
          return object == null ? undefined2 : object[key];
        };
      }
      __name(basePropertyOf, "basePropertyOf");
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
        });
        return accumulator;
      }
      __name(baseReduce, "baseReduce");
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      __name(baseSortBy, "baseSortBy");
      function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while (++index < length) {
          var current = iteratee(array[index]);
          if (current !== undefined2) {
            result = result === undefined2 ? current : result + current;
          }
        }
        return result;
      }
      __name(baseSum, "baseSum");
      function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while (++index < n) {
          result[index] = iteratee(index);
        }
        return result;
      }
      __name(baseTimes, "baseTimes");
      function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
          return [
            key,
            object[key]
          ];
        });
      }
      __name(baseToPairs, "baseToPairs");
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      __name(baseTrim, "baseTrim");
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      __name(baseUnary, "baseUnary");
      function baseValues(object, props) {
        return arrayMap(props, function(key) {
          return object[key];
        });
      }
      __name(baseValues, "baseValues");
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      __name(cacheHas, "cacheHas");
      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      __name(charsStartIndex, "charsStartIndex");
      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      __name(charsEndIndex, "charsEndIndex");
      function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result;
          }
        }
        return result;
      }
      __name(countHolders, "countHolders");
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      __name(escapeStringChar, "escapeStringChar");
      function getValue(object, key) {
        return object == null ? undefined2 : object[key];
      }
      __name(getValue, "getValue");
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      __name(hasUnicode, "hasUnicode");
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      __name(hasUnicodeWord, "hasUnicodeWord");
      function iteratorToArray(iterator) {
        var data, result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }
      __name(iteratorToArray, "iteratorToArray");
      function mapToArray(map2) {
        var index = -1, result = Array(map2.size);
        map2.forEach(function(value, key) {
          result[++index] = [
            key,
            value
          ];
        });
        return result;
      }
      __name(mapToArray, "mapToArray");
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      __name(overArg, "overArg");
      function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result[resIndex++] = index;
          }
        }
        return result;
      }
      __name(replaceHolders, "replaceHolders");
      function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = value;
        });
        return result;
      }
      __name(setToArray, "setToArray");
      function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = [
            value,
            value
          ];
        });
        return result;
      }
      __name(setToPairs, "setToPairs");
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }
      __name(strictIndexOf, "strictIndexOf");
      function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while (index--) {
          if (array[index] === value) {
            return index;
          }
        }
        return index;
      }
      __name(strictLastIndexOf, "strictLastIndexOf");
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      __name(stringSize, "stringSize");
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      __name(stringToArray, "stringToArray");
      function trimmedEndIndex(string) {
        var index = string.length;
        while (index-- && reWhitespace.test(string.charAt(index))) {
        }
        return index;
      }
      __name(trimmedEndIndex, "trimmedEndIndex");
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result;
        }
        return result;
      }
      __name(unicodeSize, "unicodeSize");
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      __name(unicodeToArray, "unicodeToArray");
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      __name(unicodeWords, "unicodeWords");
      var runInContext = /* @__PURE__ */ __name(function runInContext2(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        var Array1 = context.Array, Date2 = context.Date, Error2 = context.Error, Function1 = context.Function, Math2 = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString = funcToString.call(Object1);
        var oldDash = root._;
        var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        var Buffer2 = moduleExports ? context.Buffer : undefined2, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined2, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined2, symIterator = Symbol2 ? Symbol2.iterator : undefined2, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined2;
        var defineProperty = function() {
          try {
            var func = getNative(Object1, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        var metaMap = WeakMap && new WeakMap();
        var realNames = {};
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
        function lodash(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        __name(lodash, "lodash");
        var baseCreate = /* @__PURE__ */ function() {
          function object() {
          }
          __name(object, "object");
          return function(proto) {
            if (!isObject(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object.prototype = proto;
            var result2 = new object();
            object.prototype = undefined2;
            return result2;
          };
        }();
        function baseLodash() {
        }
        __name(baseLodash, "baseLodash");
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined2;
        }
        __name(LodashWrapper, "LodashWrapper");
        lodash.templateSettings = {
          /**
          * Used to detect `data` property values to be HTML-escaped.
          *
          * @memberOf _.templateSettings
          * @type {RegExp}
          */
          "escape": reEscape,
          /**
          * Used to detect code to be evaluated.
          *
          * @memberOf _.templateSettings
          * @type {RegExp}
          */
          "evaluate": reEvaluate,
          /**
          * Used to detect `data` property values to inject.
          *
          * @memberOf _.templateSettings
          * @type {RegExp}
          */
          "interpolate": reInterpolate,
          /**
          * Used to reference the data object in the template text.
          *
          * @memberOf _.templateSettings
          * @type {string}
          */
          "variable": "",
          /**
          * Used to import variables into the compiled template.
          *
          * @memberOf _.templateSettings
          * @type {Object}
          */
          "imports": {
            /**
            * A reference to the `lodash` function.
            *
            * @memberOf _.templateSettings.imports
            * @type {Function}
            */
            "_": lodash
          }
        };
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        __name(LazyWrapper, "LazyWrapper");
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        __name(lazyClone, "lazyClone");
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        __name(lazyReverse, "lazyReverse");
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result2 = [];
          outer: while (length-- && resIndex < takeCount) {
            index += dir;
            var iterIndex = -1, value = array[index];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result2[resIndex++] = value;
          }
          return result2;
        }
        __name(lazyValue, "lazyValue");
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries2) {
          var index = -1, length = entries2 == null ? 0 : entries2.length;
          this.clear();
          while (++index < length) {
            var entry = entries2[index];
            this.set(entry[0], entry[1]);
          }
        }
        __name(Hash, "Hash");
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        __name(hashClear, "hashClear");
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        __name(hashDelete, "hashDelete");
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result2 = data[key];
            return result2 === HASH_UNDEFINED ? undefined2 : result2;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined2;
        }
        __name(hashGet, "hashGet");
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined2 : hasOwnProperty.call(data, key);
        }
        __name(hashHas, "hashHas");
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
          return this;
        }
        __name(hashSet, "hashSet");
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries2) {
          var index = -1, length = entries2 == null ? 0 : entries2.length;
          this.clear();
          while (++index < length) {
            var entry = entries2[index];
            this.set(entry[0], entry[1]);
          }
        }
        __name(ListCache, "ListCache");
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        __name(listCacheClear, "listCacheClear");
        function listCacheDelete(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }
          --this.size;
          return true;
        }
        __name(listCacheDelete, "listCacheDelete");
        function listCacheGet(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          return index < 0 ? undefined2 : data[index][1];
        }
        __name(listCacheGet, "listCacheGet");
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        __name(listCacheHas, "listCacheHas");
        function listCacheSet(key, value) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            ++this.size;
            data.push([
              key,
              value
            ]);
          } else {
            data[index][1] = value;
          }
          return this;
        }
        __name(listCacheSet, "listCacheSet");
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries2) {
          var index = -1, length = entries2 == null ? 0 : entries2.length;
          this.clear();
          while (++index < length) {
            var entry = entries2[index];
            this.set(entry[0], entry[1]);
          }
        }
        __name(MapCache, "MapCache");
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map2 || ListCache)(),
            "string": new Hash()
          };
        }
        __name(mapCacheClear, "mapCacheClear");
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        __name(mapCacheDelete, "mapCacheDelete");
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        __name(mapCacheGet, "mapCacheGet");
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        __name(mapCacheHas, "mapCacheHas");
        function mapCacheSet(key, value) {
          var data = getMapData(this, key), size2 = data.size;
          data.set(key, value);
          this.size += data.size == size2 ? 0 : 1;
          return this;
        }
        __name(mapCacheSet, "mapCacheSet");
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index = -1, length = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index < length) {
            this.add(values2[index]);
          }
        }
        __name(SetCache, "SetCache");
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        __name(setCacheAdd, "setCacheAdd");
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        __name(setCacheHas, "setCacheHas");
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries2) {
          var data = this.__data__ = new ListCache(entries2);
          this.size = data.size;
        }
        __name(Stack, "Stack");
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        __name(stackClear, "stackClear");
        function stackDelete(key) {
          var data = this.__data__, result2 = data["delete"](key);
          this.size = data.size;
          return result2;
        }
        __name(stackDelete, "stackDelete");
        function stackGet(key) {
          return this.__data__.get(key);
        }
        __name(stackGet, "stackGet");
        function stackHas(key) {
          return this.__data__.has(key);
        }
        __name(stackHas, "stackHas");
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([
                key,
                value
              ]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        __name(stackSet, "stackSet");
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String) : [], length = result2.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        __name(arrayLikeKeys, "arrayLikeKeys");
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined2;
        }
        __name(arraySample, "arraySample");
        function arraySampleSize(array, n) {
          return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        __name(arraySampleSize, "arraySampleSize");
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        __name(arrayShuffle, "arrayShuffle");
        function assignMergeValue(object, key, value) {
          if (value !== undefined2 && !eq(object[key], value) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        __name(assignMergeValue, "assignMergeValue");
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        __name(assignValue, "assignValue");
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        __name(assocIndexOf, "assocIndexOf");
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        __name(baseAggregator, "baseAggregator");
        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }
        __name(baseAssign, "baseAssign");
        function baseAssignIn(object, source) {
          return object && copyObject(source, keysIn(source), object);
        }
        __name(baseAssignIn, "baseAssignIn");
        function baseAssignValue(object, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object[key] = value;
          }
        }
        __name(baseAssignValue, "baseAssignValue");
        function baseAt(object, paths) {
          var index = -1, length = paths.length, result2 = Array1(length), skip = object == null;
          while (++index < length) {
            result2[index] = skip ? undefined2 : get3(object, paths[index]);
          }
          return result2;
        }
        __name(baseAt, "baseAt");
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined2) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined2) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        __name(baseClamp, "baseClamp");
        function baseClone(value, bitmask, customizer, key, object, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result2 = object ? customizer(value, key, object, stack) : customizer(value);
          }
          if (result2 !== undefined2) {
            return result2;
          }
          if (!isObject(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result2 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result2);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object ? value : {};
              }
              result2 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result2);
          if (isSet(value)) {
            value.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined2 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result2;
        }
        __name(baseClone, "baseClone");
        function baseConforms(source) {
          var props = keys(source);
          return function(object) {
            return baseConformsTo(object, source, props);
          };
        }
        __name(baseConforms, "baseConforms");
        function baseConformsTo(object, source, props) {
          var length = props.length;
          if (object == null) {
            return !length;
          }
          object = Object1(object);
          while (length--) {
            var key = props[length], predicate = source[key], value = object[key];
            if (value === undefined2 && !(key in object) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        __name(baseConformsTo, "baseConformsTo");
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout2(function() {
            func.apply(undefined2, args);
          }, wait);
        }
        __name(baseDelay, "baseDelay");
        function baseDifference(array, values2, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
          if (!length) {
            return result2;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer: while (++index < length) {
            var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values2[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result2.push(value);
            } else if (!includes2(values2, computed, comparator)) {
              result2.push(value);
            }
          }
          return result2;
        }
        __name(baseDifference, "baseDifference");
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value, index, collection2) {
            result2 = !!predicate(value, index, collection2);
            return result2;
          });
          return result2;
        }
        __name(baseEvery, "baseEvery");
        function baseExtremum(array, iteratee2, comparator) {
          var index = -1, length = array.length;
          while (++index < length) {
            var value = array[index], current = iteratee2(value);
            if (current != null && (computed === undefined2 ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current, result2 = value;
            }
          }
          return result2;
        }
        __name(baseExtremum, "baseExtremum");
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined2 || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        __name(baseFill, "baseFill");
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value, index, collection2) {
            if (predicate(value, index, collection2)) {
              result2.push(value);
            }
          });
          return result2;
        }
        __name(baseFilter, "baseFilter");
        function baseFlatten(array, depth, predicate, isStrict, result2) {
          var index = -1, length = array.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index < length) {
            var value = array[index];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush(result2, value);
              }
            } else if (!isStrict) {
              result2[result2.length] = value;
            }
          }
          return result2;
        }
        __name(baseFlatten, "baseFlatten");
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object, iteratee2) {
          return object && baseFor(object, iteratee2, keys);
        }
        __name(baseForOwn, "baseForOwn");
        function baseForOwnRight(object, iteratee2) {
          return object && baseForRight(object, iteratee2, keys);
        }
        __name(baseForOwnRight, "baseForOwnRight");
        function baseFunctions(object, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object[key]);
          });
        }
        __name(baseFunctions, "baseFunctions");
        function baseGet(object, path) {
          path = castPath(path, object);
          var index = 0, length = path.length;
          while (object != null && index < length) {
            object = object[toKey(path[index++])];
          }
          return index && index == length ? object : undefined2;
        }
        __name(baseGet, "baseGet");
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object);
          return isArray(object) ? result2 : arrayPush(result2, symbolsFunc(object));
        }
        __name(baseGetAllKeys, "baseGetAllKeys");
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined2 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        __name(baseGetTag, "baseGetTag");
        function baseGt(value, other) {
          return value > other;
        }
        __name(baseGt, "baseGt");
        function baseHas(object, key) {
          return object != null && hasOwnProperty.call(object, key);
        }
        __name(baseHas, "baseHas");
        function baseHasIn(object, key) {
          return object != null && key in Object1(object);
        }
        __name(baseHasIn, "baseHasIn");
        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        __name(baseInRange, "baseInRange");
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined2;
          }
          array = arrays[0];
          var index = -1, seen = caches[0];
          outer: while (++index < length && result2.length < maxLength) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
          return result2;
        }
        __name(baseIntersection, "baseIntersection");
        function baseInverter(object, setter, iteratee2, accumulator) {
          baseForOwn(object, function(value, key, object2) {
            setter(accumulator, iteratee2(value), key, object2);
          });
          return accumulator;
        }
        __name(baseInverter, "baseInverter");
        function baseInvoke(object, path, args) {
          path = castPath(path, object);
          object = parent(object, path);
          var func = object == null ? object : object[toKey(last(path))];
          return func == null ? undefined2 : apply(func, object, args);
        }
        __name(baseInvoke, "baseInvoke");
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        __name(baseIsArguments, "baseIsArguments");
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        __name(baseIsArrayBuffer, "baseIsArrayBuffer");
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        __name(baseIsDate, "baseIsDate");
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        __name(baseIsEqual, "baseIsEqual");
        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        __name(baseIsEqualDeep, "baseIsEqualDeep");
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        __name(baseIsMap, "baseIsMap");
        function baseIsMatch(object, source, matchData, customizer) {
          var index = matchData.length, length = index, noCustomizer = !customizer;
          if (object == null) {
            return !length;
          }
          object = Object1(object);
          while (index--) {
            var data = matchData[index];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }
          while (++index < length) {
            data = matchData[index];
            var key = data[0], objValue = object[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined2 && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result2 = customizer(objValue, srcValue, key, object, source, stack);
              }
              if (!(result2 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        __name(baseIsMatch, "baseIsMatch");
        function baseIsNative(value) {
          if (!isObject(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        __name(baseIsNative, "baseIsNative");
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        __name(baseIsRegExp, "baseIsRegExp");
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        __name(baseIsSet, "baseIsSet");
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        __name(baseIsTypedArray, "baseIsTypedArray");
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        __name(baseIteratee, "baseIteratee");
        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }
          var result2 = [];
          for (var key in Object1(object)) {
            if (hasOwnProperty.call(object, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        __name(baseKeys, "baseKeys");
        function baseKeysIn(object) {
          if (!isObject(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object), result2 = [];
          for (var key in object) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        __name(baseKeysIn, "baseKeysIn");
        function baseLt(value, other) {
          return value < other;
        }
        __name(baseLt, "baseLt");
        function baseMap(collection, iteratee2) {
          var index = -1, result2 = isArrayLike(collection) ? Array1(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result2[++index] = iteratee2(value, key, collection2);
          });
          return result2;
        }
        __name(baseMap, "baseMap");
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        __name(baseMatches, "baseMatches");
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object) {
            var objValue = get3(object, path);
            return objValue === undefined2 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        __name(baseMatchesProperty, "baseMatchesProperty");
        function baseMerge(object, source, srcIndex, customizer, stack) {
          if (object === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined2;
              if (newValue === undefined2) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }
        __name(baseMerge, "baseMerge");
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined2;
          var isCommon = newValue === undefined2;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object, key, newValue);
        }
        __name(baseMergeDeep, "baseMergeDeep");
        function baseNth(array, n) {
          var length = array.length;
          if (!length) {
            return;
          }
          n += n < 0 ? length : 0;
          return isIndex(n, length) ? array[n] : undefined2;
        }
        __name(baseNth, "baseNth");
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [
              identity
            ];
          }
          var index = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return {
              "criteria": criteria,
              "index": ++index,
              "value": value
            };
          });
          return baseSortBy(result2, function(object, other) {
            return compareMultiple(object, other, orders);
          });
        }
        __name(baseOrderBy, "baseOrderBy");
        function basePick(object, paths) {
          return basePickBy(object, paths, function(value, path) {
            return hasIn(object, path);
          });
        }
        __name(basePick, "basePick");
        function basePickBy(object, paths, predicate) {
          var index = -1, length = paths.length, result2 = {};
          while (++index < length) {
            var path = paths[index], value = baseGet(object, path);
            if (predicate(value, path)) {
              baseSet(result2, castPath(path, object), value);
            }
          }
          return result2;
        }
        __name(basePickBy, "basePickBy");
        function basePropertyDeep(path) {
          return function(object) {
            return baseGet(object, path);
          };
        }
        __name(basePropertyDeep, "basePropertyDeep");
        function basePullAll(array, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values2.length, seen = array;
          if (array === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index < length) {
            var fromIndex = 0, value = values2[index], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        __name(basePullAll, "basePullAll");
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index = indexes[length];
            if (length == lastIndex || index !== previous) {
              var previous = index;
              if (isIndex(index)) {
                splice.call(array, index, 1);
              } else {
                baseUnset(array, index);
              }
            }
          }
          return array;
        }
        __name(basePullAt, "basePullAt");
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        __name(baseRandom, "baseRandom");
        function baseRange(start, end, step, fromRight) {
          var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array1(length);
          while (length--) {
            result2[fromRight ? length : ++index] = start;
            start += step;
          }
          return result2;
        }
        __name(baseRange, "baseRange");
        function baseRepeat(string, n) {
          var result2 = "";
          if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n % 2) {
              result2 += string;
            }
            n = nativeFloor(n / 2);
            if (n) {
              string += string;
            }
          } while (n);
          return result2;
        }
        __name(baseRepeat, "baseRepeat");
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + "");
        }
        __name(baseRest, "baseRest");
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        __name(baseSample, "baseSample");
        function baseSampleSize(collection, n) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        __name(baseSampleSize, "baseSampleSize");
        function baseSet(object, path, value, customizer) {
          if (!isObject(object)) {
            return object;
          }
          path = castPath(path, object);
          var index = -1, length = path.length, lastIndex = length - 1, nested = object;
          while (nested != null && ++index < length) {
            var key = toKey(path[index]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object;
            }
            if (index != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined2;
              if (newValue === undefined2) {
                newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object;
        }
        __name(baseSet, "baseSet");
        var baseSetData = !metaMap ? identity : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        __name(baseShuffle, "baseShuffle");
        function baseSlice(array, start, end) {
          var index = -1, length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result2 = Array1(length);
          while (++index < length) {
            result2[index] = array[index + start];
          }
          return result2;
        }
        __name(baseSlice, "baseSlice");
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value, index, collection2) {
            result2 = predicate(value, index, collection2);
            return !result2;
          });
          return !!result2;
        }
        __name(baseSome, "baseSome");
        function baseSortedIndex(array, value, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        __name(baseSortedIndex, "baseSortedIndex");
        function baseSortedIndexBy(array, value, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined2;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined2, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        __name(baseSortedIndexBy, "baseSortedIndexBy");
        function baseSortedUniq(array, iteratee2) {
          var index = -1, length = array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            if (!index || !eq(computed, seen)) {
              var seen = computed;
              result2[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result2;
        }
        __name(baseSortedUniq, "baseSortedUniq");
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }
        __name(baseToNumber, "baseToNumber");
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        __name(baseToString, "baseToString");
        function baseUniq(array, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set2 = iteratee2 ? null : createSet(array);
            if (set2) {
              return setToArray(set2);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer: while (++index < length) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed);
              }
              result2.push(value);
            } else if (!includes2(seen, computed, comparator)) {
              if (seen !== result2) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
          return result2;
        }
        __name(baseUniq, "baseUniq");
        function baseUnset(object, path) {
          path = castPath(path, object);
          object = parent(object, path);
          return object == null || delete object[toKey(last(path))];
        }
        __name(baseUnset, "baseUnset");
        function baseUpdate(object, path, updater, customizer) {
          return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        __name(baseUpdate, "baseUpdate");
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length, index = fromRight ? length : -1;
          while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        __name(baseWhile, "baseWhile");
        function baseWrapperValue(value, actions) {
          var result2 = value;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions, function(result3, action) {
            return action.func.apply(action.thisArg, arrayPush([
              result3
            ], action.args));
          }, result2);
        }
        __name(baseWrapperValue, "baseWrapperValue");
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index = -1, result2 = Array1(length);
          while (++index < length) {
            var array = arrays[index], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index) {
                result2[index] = baseDifference(result2[index] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        __name(baseXor, "baseXor");
        function baseZipObject(props, values2, assignFunc) {
          var index = -1, length = props.length, valsLength = values2.length, result2 = {};
          while (++index < length) {
            var value = index < valsLength ? values2[index] : undefined2;
            assignFunc(result2, props[index], value);
          }
          return result2;
        }
        __name(baseZipObject, "baseZipObject");
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        __name(castArrayLikeObject, "castArrayLikeObject");
        function castFunction(value) {
          return typeof value == "function" ? value : identity;
        }
        __name(castFunction, "castFunction");
        function castPath(value, object) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object) ? [
            value
          ] : stringToPath(toString(value));
        }
        __name(castPath, "castPath");
        var castRest = baseRest;
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined2 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        __name(castSlice, "castSlice");
        var clearTimeout2 = ctxClearTimeout || function(id) {
          return root.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result2);
          return result2;
        }
        __name(cloneBuffer, "cloneBuffer");
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        __name(cloneArrayBuffer, "cloneArrayBuffer");
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        __name(cloneDataView, "cloneDataView");
        function cloneRegExp(regexp) {
          var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result2.lastIndex = regexp.lastIndex;
          return result2;
        }
        __name(cloneRegExp, "cloneRegExp");
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        __name(cloneSymbol, "cloneSymbol");
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        __name(cloneTypedArray, "cloneTypedArray");
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        __name(compareAscending, "compareAscending");
        function compareMultiple(object, other, orders) {
          var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index < length) {
            var result2 = compareAscending(objCriteria[index], othCriteria[index]);
            if (result2) {
              if (index >= ordersLength) {
                return result2;
              }
              var order = orders[index];
              return result2 * (order == "desc" ? -1 : 1);
            }
          }
          return object.index - other.index;
        }
        __name(compareMultiple, "compareMultiple");
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array1(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        __name(composeArgs, "composeArgs");
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array1(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        __name(composeArgsRight, "composeArgsRight");
        function copyArray(source, array) {
          var index = -1, length = source.length;
          array || (array = Array1(length));
          while (++index < length) {
            array[index] = source[index];
          }
          return array;
        }
        __name(copyArray, "copyArray");
        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index = -1, length = props.length;
          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined2;
            if (newValue === undefined2) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }
        __name(copyObject, "copyObject");
        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }
        __name(copySymbols, "copySymbols");
        function copySymbolsIn(source, object) {
          return copyObject(source, getSymbolsIn(source), object);
        }
        __name(copySymbolsIn, "copySymbolsIn");
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        __name(createAggregator, "createAggregator");
        function createAssigner(assigner) {
          return baseRest(function(object, sources) {
            var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined2, guard = length > 2 ? sources[2] : undefined2;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined2 : customizer;
              length = 1;
            }
            object = Object1(object);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object, source, index, customizer);
              }
            }
            return object;
          });
        }
        __name(createAssigner, "createAssigner");
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
            while (fromRight ? index-- : ++index < length) {
              if (iteratee2(iterable[index], index, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        __name(createBaseEach, "createBaseEach");
        function createBaseFor(fromRight) {
          return function(object, iteratee2, keysFunc) {
            var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }
        __name(createBaseFor, "createBaseFor");
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          __name(wrapper, "wrapper");
          return wrapper;
        }
        __name(createBind, "createBind");
        function createCaseFirst(methodName) {
          return function(string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined2;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        __name(createCaseFirst, "createCaseFirst");
        function createCompounder(callback) {
          return function(string) {
            return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
          };
        }
        __name(createCompounder, "createCompounder");
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject(result2) ? result2 : thisBinding;
          };
        }
        __name(createCtor, "createCtor");
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
            while (index--) {
              args[index] = arguments[index];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined2, args, holders, undefined2, undefined2, arity - length);
            }
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          __name(wrapper, "wrapper");
          return wrapper;
        }
        __name(createCurry, "createCurry");
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object1(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = /* @__PURE__ */ __name(function(key) {
                return iteratee2(iterable[key], key, iterable);
              }, "predicate");
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined2;
          };
        }
        __name(createFind, "createFind");
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index--) {
              var func = funcs[index];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index = wrapper ? index : length;
            while (++index < length) {
              func = funcs[index];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined2;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index2 = 0, result2 = length ? funcs[index2].apply(this, args) : value;
              while (++index2 < length) {
                result2 = funcs[index2].call(this, result2);
              }
              return result2;
            };
          });
        }
        __name(createFlow, "createFlow");
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array1(length), index = length;
            while (index--) {
              args[index] = arguments[index];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary2, arity - length);
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          __name(wrapper, "wrapper");
          return wrapper;
        }
        __name(createHybrid, "createHybrid");
        function createInverter(setter, toIteratee) {
          return function(object, iteratee2) {
            return baseInverter(object, setter, toIteratee(iteratee2), {});
          };
        }
        __name(createInverter, "createInverter");
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result2;
            if (value === undefined2 && other === undefined2) {
              return defaultValue;
            }
            if (value !== undefined2) {
              result2 = value;
            }
            if (other !== undefined2) {
              if (result2 === undefined2) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result2 = operator(value, other);
            }
            return result2;
          };
        }
        __name(createMathOperation, "createMathOperation");
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        __name(createOver, "createOver");
        function createPadding(length, chars) {
          chars = chars === undefined2 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
        }
        __name(createPadding, "createPadding");
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          __name(wrapper, "wrapper");
          return wrapper;
        }
        __name(createPartial, "createPartial");
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined2;
            }
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        __name(createRange, "createRange");
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        __name(createRelationalOperation, "createRelationalOperation");
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined2, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder;
          return setWrapToString(result2, func, bitmask);
        }
        __name(createRecurry, "createRecurry");
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number)) {
              var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        __name(createRound, "createRound");
        var createSet = !(Set && 1 / setToArray(new Set([
          ,
          -0
        ]))[1] == INFINITY) ? noop : function(values2) {
          return new Set(values2);
        };
        function createToPairs(keysFunc) {
          return function(object) {
            var tag = getTag(object);
            if (tag == mapTag) {
              return mapToArray(object);
            }
            if (tag == setTag) {
              return setToPairs(object);
            }
            return baseToPairs(object, keysFunc(object));
          };
        }
        __name(createToPairs, "createToPairs");
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined2;
          }
          ary2 = ary2 === undefined2 ? ary2 : nativeMax(toInteger(ary2), 0);
          arity = arity === undefined2 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined2;
          }
          var data = isBindKey ? undefined2 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined2, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result2, newData), func, bitmask);
        }
        __name(createWrap, "createWrap");
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined2 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }
        __name(customDefaultsAssignIn, "customDefaultsAssignIn");
        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
          if (isObject(objValue) && isObject(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        __name(customDefaultsMerge, "customDefaultsMerge");
        function customOmitClone(value) {
          return isPlainObject(value) ? undefined2 : value;
        }
        __name(customOmitClone, "customOmitClone");
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
          stack.set(array, other);
          stack.set(other, array);
          while (++index < arrLength) {
            var arrValue = array[index], othValue = other[index];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }
            if (compared !== undefined2) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result2;
        }
        __name(equalArrays, "equalArrays");
        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }
              object = object.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object, +other);
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
              return object == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object, other);
              var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object);
              return result2;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        __name(equalByTag, "equalByTag");
        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index = objLength;
          while (index--) {
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object;
          }
          var result2 = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;
          while (++index < objLength) {
            key = objProps[index];
            var objValue = object[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            }
            if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object);
          stack["delete"](other);
          return result2;
        }
        __name(equalObjects, "equalObjects");
        function flatRest(func) {
          return setToString(overRest(func, undefined2, flatten), func + "");
        }
        __name(flatRest, "flatRest");
        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }
        __name(getAllKeys, "getAllKeys");
        function getAllKeysIn(object) {
          return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        __name(getAllKeysIn, "getAllKeysIn");
        var getData = !metaMap ? noop : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty.call(realNames, result2) ? array.length : 0;
          while (length--) {
            var data = array[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result2;
        }
        __name(getFuncName, "getFuncName");
        function getHolder(func) {
          var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
          return object.placeholder;
        }
        __name(getHolder, "getHolder");
        function getIteratee() {
          var result2 = lodash.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        __name(getIteratee, "getIteratee");
        function getMapData(map3, key) {
          var data = map3.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        __name(getMapData, "getMapData");
        function getMatchData(object) {
          var result2 = keys(object), length = result2.length;
          while (length--) {
            var key = result2[length], value = object[key];
            result2[length] = [
              key,
              value,
              isStrictComparable(value)
            ];
          }
          return result2;
        }
        __name(getMatchData, "getMatchData");
        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined2;
        }
        __name(getNative, "getNative");
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined2;
            var unmasked = true;
          } catch (e) {
          }
          var result2 = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result2;
        }
        __name(getRawTag, "getRawTag");
        var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
          if (object == null) {
            return [];
          }
          object = Object1(object);
          return arrayFilter(nativeGetSymbols(object), function(symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
          var result2 = [];
          while (object) {
            arrayPush(result2, getSymbols(object));
            object = getPrototype(object);
          }
          return result2;
        };
        var getTag = baseGetTag;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
          getTag = /* @__PURE__ */ __name(function(value) {
            var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          }, "getTag");
        }
        function getView(start, end, transforms) {
          var index = -1, length = transforms.length;
          while (++index < length) {
            var data = transforms[index], size2 = data.size;
            switch (data.type) {
              case "drop":
                start += size2;
                break;
              case "dropRight":
                end -= size2;
                break;
              case "take":
                end = nativeMin(end, start + size2);
                break;
              case "takeRight":
                start = nativeMax(start, end - size2);
                break;
            }
          }
          return {
            "start": start,
            "end": end
          };
        }
        __name(getView, "getView");
        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }
        __name(getWrapDetails, "getWrapDetails");
        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index = -1, length = path.length, result2 = false;
          while (++index < length) {
            var key = toKey(path[index]);
            if (!(result2 = object != null && hasFunc(object, key))) {
              break;
            }
            object = object[key];
          }
          if (result2 || ++index != length) {
            return result2;
          }
          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        __name(hasPath, "hasPath");
        function initCloneArray(array) {
          var length = array.length, result2 = new array.constructor(length);
          if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
            result2.index = array.index;
            result2.input = array.input;
          }
          return result2;
        }
        __name(initCloneArray, "initCloneArray");
        function initCloneObject(object) {
          return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        __name(initCloneObject, "initCloneObject");
        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object);
            case boolTag:
            case dateTag:
              return new Ctor(+object);
            case dataViewTag:
              return cloneDataView(object, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object);
            case regexpTag:
              return cloneRegExp(object);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object);
          }
        }
        __name(initCloneByTag, "initCloneByTag");
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        __name(insertWrapDetails, "insertWrapDetails");
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        __name(isFlattenable, "isFlattenable");
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        __name(isIndex, "isIndex");
        function isIterateeCall(value, index, object) {
          if (!isObject(object)) {
            return false;
          }
          var type = typeof index;
          if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
            return eq(object[index], value);
          }
          return false;
        }
        __name(isIterateeCall, "isIterateeCall");
        function isKey(value, object) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        __name(isKey, "isKey");
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        __name(isKeyable, "isKeyable");
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        __name(isLaziable, "isLaziable");
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        __name(isMasked, "isMasked");
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value === proto;
        }
        __name(isPrototype, "isPrototype");
        function isStrictComparable(value) {
          return value === value && !isObject(value);
        }
        __name(isStrictComparable, "isStrictComparable");
        function matchesStrictComparable(key, srcValue) {
          return function(object) {
            if (object == null) {
              return false;
            }
            return object[key] === srcValue && (srcValue !== undefined2 || key in Object1(object));
          };
        }
        __name(matchesStrictComparable, "matchesStrictComparable");
        function memoizeCapped(func) {
          var result2 = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result2.cache;
          return result2;
        }
        __name(memoizeCapped, "memoizeCapped");
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        __name(mergeData, "mergeData");
        function nativeKeysIn(object) {
          var result2 = [];
          if (object != null) {
            for (var key in Object1(object)) {
              result2.push(key);
            }
          }
          return result2;
        }
        __name(nativeKeysIn, "nativeKeysIn");
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        __name(objectToString, "objectToString");
        function overRest(func, start, transform2) {
          start = nativeMax(start === undefined2 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array1(start + 1);
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = transform2(array);
            return apply(func, this, otherArgs);
          };
        }
        __name(overRest, "overRest");
        function parent(object, path) {
          return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        __name(parent, "parent");
        function reorder(array, indexes) {
          var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
          while (length--) {
            var index = indexes[length];
            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined2;
          }
          return array;
        }
        __name(reorder, "reorder");
        function safeGet(object, key) {
          if (key === "constructor" && typeof object[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object[key];
        }
        __name(safeGet, "safeGet");
        var setData = shortOut(baseSetData);
        var setTimeout2 = ctxSetTimeout || function(func, wait) {
          return root.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        __name(setWrapToString, "setWrapToString");
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined2, arguments);
          };
        }
        __name(shortOut, "shortOut");
        function shuffleSelf(array, size2) {
          var index = -1, length = array.length, lastIndex = length - 1;
          size2 = size2 === undefined2 ? length : size2;
          while (++index < size2) {
            var rand = baseRandom(index, lastIndex), value = array[rand];
            array[rand] = array[index];
            array[index] = value;
          }
          array.length = size2;
          return array;
        }
        __name(shuffleSelf, "shuffleSelf");
        var stringToPath = memoizeCapped(function(string) {
          var result2 = [];
          if (string.charCodeAt(0) === 46) {
            result2.push("");
          }
          string.replace(rePropName, function(match, number, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
          });
          return result2;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        __name(toKey, "toKey");
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {
            }
            try {
              return func + "";
            } catch (e) {
            }
          }
          return "";
        }
        __name(toSource, "toSource");
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        __name(updateWrapDetails, "updateWrapDetails");
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result2.__actions__ = copyArray(wrapper.__actions__);
          result2.__index__ = wrapper.__index__;
          result2.__values__ = wrapper.__values__;
          return result2;
        }
        __name(wrapperClone, "wrapperClone");
        function chunk(array, size2, guard) {
          if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined2) {
            size2 = 1;
          } else {
            size2 = nativeMax(toInteger(size2), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size2 < 1) {
            return [];
          }
          var index = 0, resIndex = 0, result2 = Array1(nativeCeil(length / size2));
          while (index < length) {
            result2[resIndex++] = baseSlice(array, index, index += size2);
          }
          return result2;
        }
        __name(chunk, "chunk");
        function compact3(array) {
          var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index];
            if (value) {
              result2[resIndex++] = value;
            }
          }
          return result2;
        }
        __name(compact3, "compact");
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array1(length - 1), array = arguments[0], index = length;
          while (index--) {
            args[index - 1] = arguments[index];
          }
          return arrayPush(isArray(array) ? copyArray(array) : [
            array
          ], baseFlatten(args, 1));
        }
        __name(concat, "concat");
        var difference = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined2, comparator) : [];
        });
        function drop(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        __name(drop, "drop");
        function dropRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        __name(dropRight, "dropRight");
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        __name(dropRightWhile, "dropRightWhile");
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        __name(dropWhile, "dropWhile");
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        __name(fill, "fill");
        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        __name(findIndex, "findIndex");
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length - 1;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        __name(findLastIndex, "findLastIndex");
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        __name(flatten, "flatten");
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        __name(flattenDeep, "flattenDeep");
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }
        __name(flattenDepth, "flattenDepth");
        function fromPairs(pairs) {
          var index = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index < length) {
            var pair = pairs[index];
            result2[pair[0]] = pair[1];
          }
          return result2;
        }
        __name(fromPairs, "fromPairs");
        function head(array) {
          return array && array.length ? array[0] : undefined2;
        }
        __name(head, "head");
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseIndexOf(array, value, index);
        }
        __name(indexOf, "indexOf");
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        __name(initial, "initial");
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined2;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
        });
        function join(array, separator) {
          return array == null ? "" : nativeJoin.call(array, separator);
        }
        __name(join, "join");
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined2;
        }
        __name(last, "last");
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        __name(lastIndexOf, "lastIndexOf");
        function nth(array, n) {
          return array && array.length ? baseNth(array, toInteger(n)) : undefined2;
        }
        __name(nth, "nth");
        var pull = baseRest(pullAll);
        function pullAll(array, values2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
        }
        __name(pullAll, "pullAll");
        function pullAllBy(array, values2, iteratee2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
        }
        __name(pullAllBy, "pullAllBy");
        function pullAllWith(array, values2, comparator) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined2, comparator) : array;
        }
        __name(pullAllWith, "pullAllWith");
        var pullAt = flatRest(function(array, indexes) {
          var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index) {
            return isIndex(index, length) ? +index : index;
          }).sort(compareAscending));
          return result2;
        });
        function remove(array, predicate) {
          var result2 = [];
          if (!(array && array.length)) {
            return result2;
          }
          var index = -1, indexes = [], length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result2.push(value);
              indexes.push(index);
            }
          }
          basePullAt(array, indexes);
          return result2;
        }
        __name(remove, "remove");
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        __name(reverse, "reverse");
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined2 ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }
        __name(slice, "slice");
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        __name(sortedIndex, "sortedIndex");
        function sortedIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
        }
        __name(sortedIndexBy, "sortedIndexBy");
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value);
            if (index < length && eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        __name(sortedIndexOf, "sortedIndexOf");
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        __name(sortedLastIndex, "sortedLastIndex");
        function sortedLastIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
        }
        __name(sortedLastIndexBy, "sortedLastIndexBy");
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        __name(sortedLastIndexOf, "sortedLastIndexOf");
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        __name(sortedUniq, "sortedUniq");
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        __name(sortedUniqBy, "sortedUniqBy");
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        __name(tail, "tail");
        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        __name(take, "take");
        function takeRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        __name(takeRight, "takeRight");
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        __name(takeRightWhile, "takeRightWhile");
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        __name(takeWhile, "takeWhile");
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
        });
        function uniq2(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        __name(uniq2, "uniq");
        function uniqBy3(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        __name(uniqBy3, "uniqBy");
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return array && array.length ? baseUniq(array, undefined2, comparator) : [];
        }
        __name(uniqWith, "uniqWith");
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index) {
            return arrayMap(array, baseProperty(index));
          });
        }
        __name(unzip, "unzip");
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result2 = unzip(array);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group) {
            return apply(iteratee2, undefined2, group);
          });
        }
        __name(unzipWith, "unzipWith");
        var without = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        __name(zipObject, "zipObject");
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        __name(zipObjectDeep, "zipObjectDeep");
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined2;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result2 = lodash(value);
          result2.__chain__ = true;
          return result2;
        }
        __name(chain, "chain");
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        __name(tap, "tap");
        function thru(value, interceptor) {
          return interceptor(value);
        }
        __name(thru, "thru");
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = /* @__PURE__ */ __name(function(object) {
            return baseAt(object, paths);
          }, "interceptor");
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [
              interceptor
            ],
            "thisArg": undefined2
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array) {
            if (length && !array.length) {
              array.push(undefined2);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        __name(wrapperChain, "wrapperChain");
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        __name(wrapperCommit, "wrapperCommit");
        function wrapperNext() {
          if (this.__values__ === undefined2) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
          return {
            "done": done,
            "value": value
          };
        }
        __name(wrapperNext, "wrapperNext");
        function wrapperToIterator() {
          return this;
        }
        __name(wrapperToIterator, "wrapperToIterator");
        function wrapperPlant(value) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined2;
            if (result2) {
              previous.__wrapped__ = clone2;
            } else {
              result2 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result2;
        }
        __name(wrapperPlant, "wrapperPlant");
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [
                reverse
              ],
              "thisArg": undefined2
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        __name(wrapperReverse, "wrapperReverse");
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        __name(wrapperValue, "wrapperValue");
        var countBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        __name(every, "every");
        function filter2(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        __name(filter2, "filter");
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map2(collection, iteratee2), 1);
        }
        __name(flatMap, "flatMap");
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map2(collection, iteratee2), INFINITY);
        }
        __name(flatMapDeep, "flatMapDeep");
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(map2(collection, iteratee2), depth);
        }
        __name(flatMapDepth, "flatMapDepth");
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        __name(forEach, "forEach");
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        __name(forEachRight, "forEachRight");
        var groupBy2 = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            result2[key].push(value);
          } else {
            baseAssignValue(result2, key, [
              value
            ]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        __name(includes, "includes");
        var invokeMap = baseRest(function(collection, path, args) {
          var index = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array1(collection.length) : [];
          baseEach(collection, function(value) {
            result2[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result2;
        });
        var keyBy2 = createAggregator(function(result2, value, key) {
          baseAssignValue(result2, key, value);
        });
        function map2(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        __name(map2, "map");
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [
              iteratees
            ];
          }
          orders = guard ? undefined2 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [
              orders
            ];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        __name(orderBy, "orderBy");
        var partition = createAggregator(function(result2, value, key) {
          result2[key ? 0 : 1].push(value);
        }, function() {
          return [
            [],
            []
          ];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        __name(reduce, "reduce");
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        __name(reduceRight, "reduceRight");
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        __name(reject, "reject");
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        __name(sample, "sample");
        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }
        __name(sampleSize, "sampleSize");
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        __name(shuffle, "shuffle");
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        __name(size, "size");
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        __name(some, "some");
        var sortBy2 = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [
              iteratees[0]
            ];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now = ctxNow || function() {
          return root.Date.now();
        };
        function after(n, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        __name(after, "after");
        function ary(func, n, guard) {
          n = guard ? undefined2 : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n);
        }
        __name(ary, "ary");
        function before(n, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined2;
            }
            return result2;
          };
        }
        __name(before, "before");
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curry.placeholder;
          return result2;
        }
        __name(curry, "curry");
        function curryRight(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        __name(curryRight, "curryRight");
        function debounce(func, wait, options) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined2;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          __name(invokeFunc, "invokeFunc");
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout2(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          __name(leadingEdge, "leadingEdge");
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          __name(remainingWait, "remainingWait");
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          __name(shouldInvoke, "shouldInvoke");
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout2(timerExpired, remainingWait(time));
          }
          __name(timerExpired, "timerExpired");
          function trailingEdge(time) {
            timerId = undefined2;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined2;
            return result2;
          }
          __name(trailingEdge, "trailingEdge");
          function cancel() {
            if (timerId !== undefined2) {
              clearTimeout2(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined2;
          }
          __name(cancel, "cancel");
          function flush() {
            return timerId === undefined2 ? result2 : trailingEdge(now());
          }
          __name(flush, "flush");
          function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined2) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout2(timerId);
                timerId = setTimeout2(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined2) {
              timerId = setTimeout2(timerExpired, wait);
            }
            return result2;
          }
          __name(debounced, "debounced");
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        __name(debounce, "debounce");
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        __name(flip, "flip");
        function memoize(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = /* @__PURE__ */ __name(function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result2 = func.apply(this, args);
            memoized.cache = cache.set(key, result2) || cache;
            return result2;
          }, "memoized");
          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        }
        __name(memoize, "memoize");
        memoize.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        __name(negate, "negate");
        function once(func) {
          return before(2, func);
        }
        __name(once, "once");
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index = -1, length = nativeMin(args.length, funcsLength);
            while (++index < length) {
              args[index] = transforms[index].call(this, args[index]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start === undefined2 ? start : toInteger(start);
          return baseRest(func, start);
        }
        __name(rest, "rest");
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function(args) {
            var array = args[start], otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }
        __name(spread, "spread");
        function throttle(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        __name(throttle, "throttle");
        function unary(func) {
          return ary(func, 1);
        }
        __name(unary, "unary");
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        __name(wrap, "wrap");
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [
            value
          ];
        }
        __name(castArray, "castArray");
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        __name(clone, "clone");
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        __name(cloneWith, "cloneWith");
        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        __name(cloneDeep, "cloneDeep");
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        __name(cloneDeepWith, "cloneDeepWith");
        function conformsTo(object, source) {
          return source == null || baseConformsTo(object, source, keys(source));
        }
        __name(conformsTo, "conformsTo");
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        __name(eq, "eq");
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(/* @__PURE__ */ function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array1.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        __name(isArrayLike, "isArrayLike");
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        __name(isArrayLikeObject, "isArrayLikeObject");
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        __name(isBoolean, "isBoolean");
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        __name(isElement, "isElement");
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        __name(isEmpty, "isEmpty");
        function isEqual4(value, other) {
          return baseIsEqual(value, other);
        }
        __name(isEqual4, "isEqual");
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          var result2 = customizer ? customizer(value, other) : undefined2;
          return result2 === undefined2 ? baseIsEqual(value, other, undefined2, customizer) : !!result2;
        }
        __name(isEqualWith, "isEqualWith");
        function isError(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        __name(isError, "isError");
        function isFinite(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        __name(isFinite, "isFinite");
        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        __name(isFunction, "isFunction");
        function isInteger(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        __name(isInteger, "isInteger");
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        __name(isLength, "isLength");
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        __name(isObject, "isObject");
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        __name(isObjectLike, "isObjectLike");
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        __name(isMatch, "isMatch");
        function isMatchWith(object, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        __name(isMatchWith, "isMatchWith");
        function isNaN(value) {
          return isNumber(value) && value != +value;
        }
        __name(isNaN, "isNaN");
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        __name(isNative, "isNative");
        function isNull(value) {
          return value === null;
        }
        __name(isNull, "isNull");
        function isNil(value) {
          return value == null;
        }
        __name(isNil, "isNil");
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        __name(isNumber, "isNumber");
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        __name(isPlainObject, "isPlainObject");
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        __name(isSafeInteger, "isSafeInteger");
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        __name(isString, "isString");
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        __name(isSymbol, "isSymbol");
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value) {
          return value === undefined2;
        }
        __name(isUndefined, "isUndefined");
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        __name(isWeakMap, "isWeakMap");
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        __name(isWeakSet, "isWeakSet");
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        __name(toArray, "toArray");
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        __name(toFinite, "toFinite");
        function toInteger(value) {
          var result2 = toFinite(value), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        __name(toInteger, "toInteger");
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        __name(toLength, "toLength");
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        __name(toNumber, "toNumber");
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        __name(toPlainObject, "toPlainObject");
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        __name(toSafeInteger, "toSafeInteger");
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        __name(toString, "toString");
        var assign = createAssigner(function(object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object, source) {
          copyObject(source, keysIn(source), object);
        });
        var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object, customizer);
        });
        var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keys(source), object, customizer);
        });
        var at = flatRest(baseAt);
        function create(prototype, properties) {
          var result2 = baseCreate(prototype);
          return properties == null ? result2 : baseAssign(result2, properties);
        }
        __name(create, "create");
        var defaults = baseRest(function(object, sources) {
          object = Object1(object);
          var index = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined2;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index < length) {
            var source = sources[index];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object[key];
              if (value === undefined2 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                object[key] = source[key];
              }
            }
          }
          return object;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined2, customDefaultsMerge);
          return apply(mergeWith, undefined2, args);
        });
        function findKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        __name(findKey, "findKey");
        function findLastKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        __name(findLastKey, "findLastKey");
        function forIn(object, iteratee2) {
          return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
        }
        __name(forIn, "forIn");
        function forInRight(object, iteratee2) {
          return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
        }
        __name(forInRight, "forInRight");
        function forOwn(object, iteratee2) {
          return object && baseForOwn(object, getIteratee(iteratee2, 3));
        }
        __name(forOwn, "forOwn");
        function forOwnRight(object, iteratee2) {
          return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
        }
        __name(forOwnRight, "forOwnRight");
        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }
        __name(functions, "functions");
        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        __name(functionsIn, "functionsIn");
        function get3(object, path, defaultValue) {
          var result2 = object == null ? undefined2 : baseGet(object, path);
          return result2 === undefined2 ? defaultValue : result2;
        }
        __name(get3, "get");
        function has(object, path) {
          return object != null && hasPath(object, path, baseHas);
        }
        __name(has, "has");
        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }
        __name(hasIn, "hasIn");
        var invert = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          result2[value] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty.call(result2, value)) {
            result2[value].push(key);
          } else {
            result2[value] = [
              key
            ];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        __name(keys, "keys");
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        __name(keysIn, "keysIn");
        function mapKeys(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, iteratee2(value, key, object2), value);
          });
          return result2;
        }
        __name(mapKeys, "mapKeys");
        function mapValues(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, key, iteratee2(value, key, object2));
          });
          return result2;
        }
        __name(mapValues, "mapValues");
        var merge = createAssigner(function(object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
          baseMerge(object, source, srcIndex, customizer);
        });
        var omit = flatRest(function(object, paths) {
          var result2 = {};
          if (object == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object, getAllKeysIn(object), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result2, paths[length]);
          }
          return result2;
        });
        function omitBy(object, predicate) {
          return pickBy(object, negate(getIteratee(predicate)));
        }
        __name(omitBy, "omitBy");
        var pick = flatRest(function(object, paths) {
          return object == null ? {} : basePick(object, paths);
        });
        function pickBy(object, predicate) {
          if (object == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object), function(prop) {
            return [
              prop
            ];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        __name(pickBy, "pickBy");
        function result(object, path, defaultValue) {
          path = castPath(path, object);
          var index = -1, length = path.length;
          if (!length) {
            length = 1;
            object = undefined2;
          }
          while (++index < length) {
            var value = object == null ? undefined2 : object[toKey(path[index])];
            if (value === undefined2) {
              index = length;
              value = defaultValue;
            }
            object = isFunction(value) ? value.call(object) : value;
          }
          return object;
        }
        __name(result, "result");
        function set(object, path, value) {
          return object == null ? object : baseSet(object, path, value);
        }
        __name(set, "set");
        function setWith(object, path, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseSet(object, path, value, customizer);
        }
        __name(setWith, "setWith");
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object, iteratee2, accumulator) {
          var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object && object.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject(object)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object2) {
            return iteratee2(accumulator, value, index, object2);
          });
          return accumulator;
        }
        __name(transform, "transform");
        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }
        __name(unset, "unset");
        function update(object, path, updater) {
          return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        __name(update, "update");
        function updateWith(object, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        __name(updateWith, "updateWith");
        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }
        __name(values, "values");
        function valuesIn(object) {
          return object == null ? [] : baseValues(object, keysIn(object));
        }
        __name(valuesIn, "valuesIn");
        function clamp(number, lower, upper) {
          if (upper === undefined2) {
            upper = lower;
            lower = undefined2;
          }
          if (upper !== undefined2) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined2) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }
        __name(clamp, "clamp");
        function inRange(number, start, end) {
          start = toFinite(start);
          if (end === undefined2) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number = toNumber(number);
          return baseInRange(number, start, end);
        }
        __name(inRange, "inRange");
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined2;
          }
          if (floating === undefined2) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined2;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined2;
            }
          }
          if (lower === undefined2 && upper === undefined2) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined2) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        __name(random, "random");
        var camelCase = createCompounder(function(result2, word, index) {
          word = word.toLowerCase();
          return result2 + (index ? capitalize(word) : word);
        });
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        __name(capitalize, "capitalize");
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        __name(deburr, "deburr");
        function endsWith(string, target, position) {
          string = toString(string);
          target = baseToString(target);
          var length = string.length;
          position = position === undefined2 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string.slice(position, end) == target;
        }
        __name(endsWith, "endsWith");
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        __name(escape, "escape");
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        __name(escapeRegExp, "escapeRegExp");
        var kebabCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          if (!length || strLength >= length) {
            return string;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        __name(pad, "pad");
        function padEnd(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        __name(padEnd, "padEnd");
        function padStart(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        __name(padStart, "padStart");
        function parseInt1(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        __name(parseInt1, "parseInt1");
        function repeat(string, n, guard) {
          if (guard ? isIterateeCall(string, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          return baseRepeat(toString(string), n);
        }
        __name(repeat, "repeat");
        function replace() {
          var args = arguments, string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        __name(replace, "replace");
        var snakeCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "_" : "") + word.toLowerCase();
        });
        function split(string, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
            separator = limit = undefined2;
          }
          limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string = toString(string);
          if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }
          return string.split(separator, limit);
        }
        __name(split, "split");
        var startCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + upperFirst(word);
        });
        function startsWith(string, target, position) {
          string = toString(string);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
          target = baseToString(target);
          return string.slice(position, position + target.length) == target;
        }
        __name(startsWith, "startsWith");
        function template(string, options, guard) {
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined2;
          }
          string = toString(string);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
          var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index = offset + match.length;
            return match;
          });
          source += "';\n";
          var variable = hasOwnProperty.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function1(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
          });
          result2.source = source;
          if (isError(result2)) {
            throw result2;
          }
          return result2;
        }
        __name(template, "template");
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        __name(toLower, "toLower");
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        __name(toUpper, "toUpper");
        function trim(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return baseTrim(string);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        __name(trim, "trim");
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.slice(0, trimmedEndIndex(string) + 1);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        __name(trimEnd, "trimEnd");
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.replace(reTrimStart, "");
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        __name(trimStart, "trimStart");
        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length = "length" in options ? toInteger(options.length) : length;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
          if (separator === undefined2) {
            return result2 + omission;
          }
          if (strSymbols) {
            end += result2.length - end;
          }
          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match, substring = result2;
              if (!separator.global) {
                separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }
              result2 = result2.slice(0, newEnd === undefined2 ? end : newEnd);
            }
          } else if (string.indexOf(baseToString(separator), end) != end) {
            var index = result2.lastIndexOf(separator);
            if (index > -1) {
              result2 = result2.slice(0, index);
            }
          }
          return result2 + omission;
        }
        __name(truncate, "truncate");
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        __name(unescape, "unescape");
        var upperCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined2 : pattern;
          if (pattern === undefined2) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }
        __name(words, "words");
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined2, args);
          } catch (e) {
            return isError(e) ? e : new Error2(e);
          }
        });
        var bindAll = flatRest(function(object, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object, key, bind(object[key], object));
          });
          return object;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [
              toIteratee(pair[0]),
              pair[1]
            ];
          });
          return baseRest(function(args) {
            var index = -1;
            while (++index < length) {
              var pair = pairs[index];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        __name(cond, "cond");
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        __name(conforms, "conforms");
        function constant(value) {
          return function() {
            return value;
          };
        }
        __name(constant, "constant");
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        __name(defaultTo, "defaultTo");
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        __name(identity, "identity");
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        __name(iteratee, "iteratee");
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        __name(matches, "matches");
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        __name(matchesProperty, "matchesProperty");
        var method = baseRest(function(path, args) {
          return function(object) {
            return baseInvoke(object, path, args);
          };
        });
        var methodOf = baseRest(function(object, args) {
          return function(path) {
            return baseInvoke(object, path, args);
          };
        });
        function mixin(object, source, options) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object[methodName] = func;
            if (isFunc) {
              object.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                  actions.push({
                    "func": func,
                    "args": arguments,
                    "thisArg": object
                  });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object, arrayPush([
                  this.value()
                ], arguments));
              };
            }
          });
          return object;
        }
        __name(mixin, "mixin");
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }
        __name(noConflict, "noConflict");
        function noop() {
        }
        __name(noop, "noop");
        function nthArg(n) {
          n = toInteger(n);
          return baseRest(function(args) {
            return baseNth(args, n);
          });
        }
        __name(nthArg, "nthArg");
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        __name(property, "property");
        function propertyOf(object) {
          return function(path) {
            return object == null ? undefined2 : baseGet(object, path);
          };
        }
        __name(propertyOf, "propertyOf");
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        __name(stubArray, "stubArray");
        function stubFalse() {
          return false;
        }
        __name(stubFalse, "stubFalse");
        function stubObject() {
          return {};
        }
        __name(stubObject, "stubObject");
        function stubString() {
          return "";
        }
        __name(stubString, "stubString");
        function stubTrue() {
          return true;
        }
        __name(stubTrue, "stubTrue");
        function times(n, iteratee2) {
          n = toInteger(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length, iteratee2);
          while (++index < n) {
            iteratee2(index);
          }
          return result2;
        }
        __name(times, "times");
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [
            value
          ] : copyArray(stringToPath(toString(value)));
        }
        __name(toPath, "toPath");
        function uniqueId(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        __name(uniqueId, "uniqueId");
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor = createRound("floor");
        function max2(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined2;
        }
        __name(max2, "max");
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined2;
        }
        __name(maxBy, "maxBy");
        function mean(array) {
          return baseMean(array, identity);
        }
        __name(mean, "mean");
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        __name(meanBy, "meanBy");
        function min2(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined2;
        }
        __name(min2, "min");
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined2;
        }
        __name(minBy, "minBy");
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round2 = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum3(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        __name(sum3, "sum");
        function sumBy2(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        __name(sumBy2, "sumBy");
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact3;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter2;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy2;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy2;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map2;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy2;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq2;
        lodash.uniqBy = uniqBy3;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        mixin(lodash, lodash);
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get3;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual4;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max2;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min2;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round2;
        lodash.runInContext = runInContext2;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum3;
        lodash.sumBy = sumBy2;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
          var source = {};
          baseForOwn(lodash, function(func, methodName) {
            if (!hasOwnProperty.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), {
          "chain": false
        });
        lodash.VERSION = VERSION2;
        arrayEach([
          "bind",
          "bindKey",
          "curry",
          "curryRight",
          "partial",
          "partialRight"
        ], function(methodName) {
          lodash[methodName].placeholder = lodash;
        });
        arrayEach([
          "drop",
          "take"
        ], function(methodName, index) {
          LazyWrapper.prototype[methodName] = function(n) {
            n = n === undefined2 ? 1 : nativeMax(toInteger(n), 0);
            var result2 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin(n, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n) {
            return this.reverse()[methodName](n).reverse();
          };
        });
        arrayEach([
          "filter",
          "map",
          "takeWhile"
        ], function(methodName, index) {
          var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach([
          "head",
          "last"
        ], function(methodName, index) {
          var takeName = "take" + (index ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach([
          "initial",
          "tail"
        ], function(methodName, index) {
          var dropName = "drop" + (index ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger(start);
          var result2 = this;
          if (result2.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result2);
          }
          if (start < 0) {
            result2 = result2.takeRight(-start);
          } else if (start) {
            result2 = result2.drop(start);
          }
          if (end !== undefined2) {
            end = toInteger(end);
            result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [
              1
            ] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = /* @__PURE__ */ __name(function(value2) {
              var result3 = lodashFunc.apply(lodash, arrayPush([
                value2
              ], args));
              return isTaker && chainAll ? result3[0] : result3;
            }, "interceptor");
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result2 = func.apply(value, args);
              result2.__actions__.push({
                "func": thru,
                "args": [
                  interceptor
                ],
                "thisArg": undefined2
              });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach([
          "pop",
          "push",
          "shift",
          "sort",
          "splice",
          "unshift"
        ], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({
              "name": methodName,
              "func": lodashFunc
            });
          }
        });
        realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [
          {
            "name": "wrapper",
            "func": undefined2
          }
        ];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
      }, "runInContext");
      var _ = runInContext();
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        root._ = _;
        define(function() {
          return _;
        });
      } else if (freeModule) {
        (freeModule.exports = _)._ = _;
        freeExports._ = _;
      } else {
        root._ = _;
      }
    }).call(exports2);
  }
});

// src/shared-configs/eslintConfig.js
var require_eslintConfig = __commonJS({
  "src/shared-configs/eslintConfig.js"(exports2, module2) {
    "use strict";
    module2.exports = {
      rules: {
        "deprecate/import": [
          "warn",
          {
            message: "Use getTzDayjs from @m7-health/shared-utils instead",
            module: "@/common/packages/dayjs",
            name: "localDayJs"
          },
          {
            message: "Use getTzDayjs from @m7-health/shared-utils instead",
            module: "src/modules/dayjs",
            name: "localDayJs"
          },
          {
            message: "Use getTzDayjs from @m7-health/shared-utils instead",
            module: "@m7-health/shared-utils",
            name: "m7DayJs"
          },
          {
            module: "date-fns",
            name: "format",
            use: "use `getTzFormattedDate` instead"
          },
          {
            module: "dayjs",
            name: "dayjs",
            use: "use `m7DayJs` instead"
          }
        ],
        "id-length": [
          "error",
          {
            // We never want to add:
            // - e
            // - el
            exceptions: [
              "_",
              "id",
              "a",
              "b",
              "x",
              "y",
              "i",
              "sx",
              "fn",
              "up",
              "to",
              "ms",
              "px"
            ],
            min: 3,
            properties: "never"
          }
        ],
        "no-console": "error",
        "no-debugger": "error",
        "no-restricted-properties": [
          "error",
          {
            message: "Use getTzDayjs from @m7-health/shared-utils instead of .tz()",
            object: "dayjs",
            property: "tz"
          },
          {
            message: "Use getTzDayjs from @m7-health/shared-utils instead of .tz()",
            object: "localDayJs",
            property: "tz"
          },
          {
            message: "Use getTzDayjs from @m7-health/shared-utils instead of .tz()",
            object: "m7DayJs",
            property: "tz"
          },
          {
            message: "it.only should not be committed - use it() instead.",
            object: "it",
            property: "only"
          }
        ],
        "no-unreachable": "error",
        "no-var": "error"
      }
    };
  }
});

// src/index.ts
var index_exports = {};
__export(index_exports, {
  DateCmp: () => DateCmp,
  DateTime: () => import_luxon8.DateTime,
  DateTimeMaybeValid: () => import_luxon8.DateTimeMaybeValid,
  ECommunicationMethod: () => ECommunicationMethod,
  ELoginCommunicationType: () => ELoginCommunicationType,
  EPermissionVerbs: () => EPermissionVerbs,
  EUnitPermissionAreas: () => EUnitPermissionAreas,
  EWeekDay: () => EWeekDay,
  Facility: () => Facility,
  FeatureFlags: () => FeatureFlags,
  M7ESlintConfig: () => M7ESlintConfig,
  PreferenceRequirementRuleSet: () => PreferenceRequirementRuleSet,
  PreferenceRequirementRuleSetEngine: () => PreferenceRequirementRuleSetEngine,
  Role: () => Role,
  RuleSetChecks: () => RuleSetChecks,
  Schedule: () => Schedule,
  ShiftType: () => ShiftType,
  StaffDetails: () => StaffDetails,
  StaffShift: () => StaffShift,
  SystemEvents: () => SystemEvents,
  TIMEZONES: () => TIMEZONES,
  US_MAJOR_CITY_TIMEZONES: () => US_MAJOR_CITY_TIMEZONES,
  Unit: () => Unit,
  User: () => User,
  VERSION: () => VERSION,
  _dayjsAdvancedFormat: () => import_advancedFormat2.default,
  _dayjsCalendar: () => import_calendar2.default,
  _dayjsCustomParseFormat: () => import_customParseFormat2.default,
  _dayjsDuration: () => import_duration2.default,
  _dayjsIsBetween: () => import_isBetween2.default,
  _dayjsIsSameOrAfter: () => import_isSameOrAfter2.default,
  _dayjsIsSameOrBefore: () => import_isSameOrBefore2.default,
  _dayjsIsoWeek: () => import_isoWeek2.default,
  _dayjsLocaleData: () => import_localeData2.default,
  _dayjsLocalizedFormat: () => import_localizedFormat2.default,
  _dayjsMinMax: () => import_minMax2.default,
  _dayjsRelativeTime: () => import_relativeTime2.default,
  _dayjsTimezone: () => import_timezone.default,
  _dayjsUtc: () => import_utc2.default,
  _dayjsWeekOfYear: () => import_weekOfYear2.default,
  buildOverlapItem: () => buildOverlapItem,
  closeDateCache: () => closeDateCache,
  dateAndTimeStringsToDateTime: () => dateAndTimeStringsToDateTime,
  dateTimeAndTimeStringToDateTime: () => dateTimeAndTimeStringToDateTime,
  dateToTimeString: () => dateToTimeString,
  dayjsMax: () => import_dayjs2.max,
  dayjsMin: () => import_dayjs2.min,
  diffDateTimeRange: () => diffDateTimeRange,
  enableDateCacheTimeout: () => enableDateCacheTimeout,
  endOfWeek: () => endOfWeek,
  findScheduleDateGaps: () => findScheduleDateGaps,
  findScheduleGaps: () => findScheduleGaps,
  getDatesInRange: () => getDatesInRange,
  getScheduleCoverage: () => getScheduleCoverage,
  getScheduleDateCoverage: () => getScheduleDateCoverage,
  getShiftRange: () => getShiftRange,
  getTotalOverlapTimeInSeconds: () => getTotalOverlapTimeInSeconds,
  getTzDate: () => getTzDate,
  getTzDayjs: () => getTzDayjs,
  getTzFormattedDate: () => getTzFormattedDate,
  getTzFormattedTime: () => getTzFormattedTime,
  getWeekDay: () => getWeekDay,
  isWeekendShift: () => isWeekendShift,
  isWeekendTime: () => isWeekendTime,
  legacyGetDatesInRange: () => legacyGetDatesInRange,
  m7DayJs: () => m7DayJs,
  mergeDateTimeRanges: () => mergeDateTimeRanges,
  nextWeekday: () => nextWeekday,
  prevWeekday: () => prevWeekday,
  setupLuxon: () => setupLuxon,
  startOfWeek: () => startOfWeek,
  testZodV4: () => testZodV4,
  testZodV4JsonSchema: () => testZodV4JsonSchema,
  timeAdd: () => timeAdd,
  timeInTzToDayjs: () => timeInTzToDayjs,
  timeOverlap: () => timeOverlap,
  timeStringToDate: () => timeStringToDate,
  timeStringToDateTime: () => timeStringToDateTime,
  timeStringToDayjs: () => timeStringToDayjs,
  toISO: () => toISO,
  trimMs: () => trimMs,
  tzAddPlugin: () => tzAddPlugin
});
module.exports = __toCommonJS(index_exports);

// src/date/timezones.ts
var import_lodash = __toESM(require_lodash());
var TIMEZONES = [
  {
    label: "America/Adak",
    value: "America/Adak"
  },
  {
    label: "America/Anchorage",
    value: "America/Anchorage"
  },
  {
    label: "America/Boise",
    value: "America/Boise"
  },
  {
    label: "America/Chicago",
    value: "America/Chicago"
  },
  {
    label: "America/Denver",
    value: "America/Denver"
  },
  {
    label: "America/Detroit",
    value: "America/Detroit"
  },
  {
    label: "America/Indiana/Indianapolis",
    value: "America/Indiana/Indianapolis"
  },
  {
    label: "America/Indiana/Knox",
    value: "America/Indiana/Knox"
  },
  {
    label: "America/Indiana/Marengo",
    value: "America/Indiana/Marengo"
  },
  {
    label: "America/Indiana/Petersburg",
    value: "America/Indiana/Petersburg"
  },
  {
    label: "America/Indiana/Tell City",
    value: "America/Indiana/Tell_City"
  },
  {
    label: "America/Indiana/Vevay",
    value: "America/Indiana/Vevay"
  },
  {
    label: "America/Indiana/Vincennes",
    value: "America/Indiana/Vincennes"
  },
  {
    label: "America/Indiana/Winamac",
    value: "America/Indiana/Winamac"
  },
  {
    label: "America/Juneau",
    value: "America/Juneau"
  },
  {
    label: "America/Kentucky/Louisville",
    value: "America/Kentucky/Louisville"
  },
  {
    label: "America/Kentucky/Monticello",
    value: "America/Kentucky/Monticello"
  },
  {
    label: "America/Los Angeles",
    value: "America/Los_Angeles"
  },
  {
    label: "America/Menominee",
    value: "America/Menominee"
  },
  {
    label: "America/Metlakatla",
    value: "America/Metlakatla"
  },
  {
    label: "America/New York",
    value: "America/New_York"
  },
  {
    label: "America/Nome",
    value: "America/Nome"
  },
  {
    label: "America/North Dakota/Beulah",
    value: "America/North_Dakota/Beulah"
  },
  {
    label: "America/North Dakota/Center",
    value: "America/North_Dakota/Center"
  },
  {
    label: "America/North Dakota/New Salem",
    value: "America/North_Dakota/New_Salem"
  },
  {
    label: "America/Phoenix",
    value: "America/Phoenix"
  },
  {
    label: "America/Sitka",
    value: "America/Sitka"
  },
  {
    label: "America/Yakutat",
    value: "America/Yakutat"
  },
  {
    label: "Pacific/Honolulu",
    value: "Pacific/Honolulu"
  }
];
var MAJOR_CITIES_TIMEZONES = [
  // Eastern Time Zone
  {
    city: "New York City",
    state: "New York",
    timezone: "America/New_York"
  },
  {
    city: "Jacksonville",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Columbus",
    state: "Ohio",
    timezone: "America/New_York"
  },
  {
    city: "Charlotte",
    state: "North Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Boston",
    state: "Massachusetts",
    timezone: "America/New_York"
  },
  {
    city: "Cleveland",
    state: "Ohio",
    timezone: "America/New_York"
  },
  {
    city: "Pittsburgh",
    state: "Pennsylvania",
    timezone: "America/New_York"
  },
  {
    city: "Cincinnati",
    state: "Ohio",
    timezone: "America/New_York"
  },
  {
    city: "Orlando",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Baltimore",
    state: "Maryland",
    timezone: "America/New_York"
  },
  {
    city: "Washington",
    state: "District of Columbia",
    timezone: "America/New_York"
  },
  {
    city: "Virginia Beach",
    state: "Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Atlanta",
    state: "Georgia",
    timezone: "America/New_York"
  },
  {
    city: "Miami",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Tampa",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Buffalo",
    state: "New York",
    timezone: "America/New_York"
  },
  {
    city: "Newark",
    state: "New Jersey",
    timezone: "America/New_York"
  },
  {
    city: "Worcester",
    state: "Massachusetts",
    timezone: "America/New_York"
  },
  {
    city: "Providence",
    state: "Rhode Island",
    timezone: "America/New_York"
  },
  {
    city: "Richmond",
    state: "Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Greensboro",
    state: "North Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Rochester",
    state: "New York",
    timezone: "America/New_York"
  },
  {
    city: "Raleigh",
    state: "North Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Norfolk",
    state: "Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Winston-Salem",
    state: "North Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Durham",
    state: "North Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Chesapeake",
    state: "Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Hialeah",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Port St. Lucie",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Tallahassee",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Cape Coral",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Fort Lauderdale",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Newport News",
    state: "Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Alexandria",
    state: "Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Knoxville",
    state: "Tennessee",
    timezone: "America/New_York"
  },
  {
    city: "Chattanooga",
    state: "Tennessee",
    timezone: "America/New_York"
  },
  {
    city: "Savannah",
    state: "Georgia",
    timezone: "America/New_York"
  },
  {
    city: "Columbia",
    state: "South Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Charleston",
    state: "South Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Augusta",
    state: "Georgia",
    timezone: "America/New_York"
  },
  {
    city: "Syracuse",
    state: "New York",
    timezone: "America/New_York"
  },
  {
    city: "Cary",
    state: "North Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Wilmington",
    state: "North Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Manchester",
    state: "New Hampshire",
    timezone: "America/New_York"
  },
  {
    city: "Hartford",
    state: "Connecticut",
    timezone: "America/New_York"
  },
  {
    city: "Stamford",
    state: "Connecticut",
    timezone: "America/New_York"
  },
  {
    city: "New Haven",
    state: "Connecticut",
    timezone: "America/New_York"
  },
  {
    city: "Elizabeth",
    state: "New Jersey",
    timezone: "America/New_York"
  },
  {
    city: "Allentown",
    state: "Pennsylvania",
    timezone: "America/New_York"
  },
  {
    city: "Reading",
    state: "Pennsylvania",
    timezone: "America/New_York"
  },
  // Indiana cities
  {
    city: "Indianapolis",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Fort Wayne",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "South Bend",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Carmel",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Fishers",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Bloomington",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Hammond",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Gary",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Lafayette",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Muncie",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  // Michigan (Detroit timezone)
  {
    city: "Detroit",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Grand Rapids",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Warren",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Sterling Heights",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Ann Arbor",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Lansing",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Flint",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Dearborn",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Livonia",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Westland",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Troy",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Farmington Hills",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Kalamazoo",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Wyoming",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Southfield",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Rochester Hills",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  // Kentucky cities
  {
    city: "Louisville",
    state: "Kentucky",
    timezone: "America/Kentucky/Louisville"
  },
  {
    city: "Lexington",
    state: "Kentucky",
    timezone: "America/New_York"
  },
  {
    city: "Bowling Green",
    state: "Kentucky",
    timezone: "America/Chicago"
  },
  {
    city: "Owensboro",
    state: "Kentucky",
    timezone: "America/Chicago"
  },
  // Central Time Zone
  {
    city: "Chicago",
    state: "Illinois",
    timezone: "America/Chicago"
  },
  {
    city: "Houston",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "San Antonio",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Dallas",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Austin",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Fort Worth",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Memphis",
    state: "Tennessee",
    timezone: "America/Chicago"
  },
  {
    city: "Milwaukee",
    state: "Wisconsin",
    timezone: "America/Chicago"
  },
  {
    city: "Oklahoma City",
    state: "Oklahoma",
    timezone: "America/Chicago"
  },
  {
    city: "Nashville",
    state: "Tennessee",
    timezone: "America/Chicago"
  },
  {
    city: "El Paso",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Wichita",
    state: "Kansas",
    timezone: "America/Chicago"
  },
  {
    city: "New Orleans",
    state: "Louisiana",
    timezone: "America/Chicago"
  },
  {
    city: "Arlington",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Irving",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Tulsa",
    state: "Oklahoma",
    timezone: "America/Chicago"
  },
  {
    city: "Madison",
    state: "Wisconsin",
    timezone: "America/Chicago"
  },
  {
    city: "Lubbock",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Plano",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Garland",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "St. Paul",
    state: "Minnesota",
    timezone: "America/Chicago"
  },
  {
    city: "Lincoln",
    state: "Nebraska",
    timezone: "America/Chicago"
  },
  {
    city: "Omaha",
    state: "Nebraska",
    timezone: "America/Chicago"
  },
  {
    city: "Minneapolis",
    state: "Minnesota",
    timezone: "America/Chicago"
  },
  {
    city: "Waco",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Shreveport",
    state: "Louisiana",
    timezone: "America/Chicago"
  },
  {
    city: "Des Moines",
    state: "Iowa",
    timezone: "America/Chicago"
  },
  {
    city: "Baton Rouge",
    state: "Louisiana",
    timezone: "America/Chicago"
  },
  {
    city: "Little Rock",
    state: "Arkansas",
    timezone: "America/Chicago"
  },
  {
    city: "Sioux Falls",
    state: "South Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Jackson",
    state: "Mississippi",
    timezone: "America/Chicago"
  },
  {
    city: "Springfield",
    state: "Illinois",
    timezone: "America/Chicago"
  },
  {
    city: "Peoria",
    state: "Illinois",
    timezone: "America/Chicago"
  },
  {
    city: "Rockford",
    state: "Illinois",
    timezone: "America/Chicago"
  },
  {
    city: "Joliet",
    state: "Illinois",
    timezone: "America/Chicago"
  },
  {
    city: "Naperville",
    state: "Illinois",
    timezone: "America/Chicago"
  },
  {
    city: "Springfield",
    state: "Missouri",
    timezone: "America/Chicago"
  },
  {
    city: "Kansas City",
    state: "Missouri",
    timezone: "America/Chicago"
  },
  {
    city: "St. Louis",
    state: "Missouri",
    timezone: "America/Chicago"
  },
  {
    city: "Columbia",
    state: "Missouri",
    timezone: "America/Chicago"
  },
  // Mountain Time Zone
  {
    city: "Phoenix",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Denver",
    state: "Colorado",
    timezone: "America/Denver"
  },
  {
    city: "Albuquerque",
    state: "New Mexico",
    timezone: "America/Denver"
  },
  {
    city: "Tucson",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Mesa",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Colorado Springs",
    state: "Colorado",
    timezone: "America/Denver"
  },
  {
    city: "Aurora",
    state: "Colorado",
    timezone: "America/Denver"
  },
  {
    city: "Boise",
    state: "Idaho",
    timezone: "America/Boise"
  },
  {
    city: "Scottsdale",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Fort Collins",
    state: "Colorado",
    timezone: "America/Denver"
  },
  {
    city: "Chandler",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Glendale",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Gilbert",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Tempe",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Peoria",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Surprise",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Salt Lake City",
    state: "Utah",
    timezone: "America/Denver"
  },
  {
    city: "West Valley City",
    state: "Utah",
    timezone: "America/Denver"
  },
  {
    city: "West Jordan",
    state: "Utah",
    timezone: "America/Denver"
  },
  {
    city: "Provo",
    state: "Utah",
    timezone: "America/Denver"
  },
  {
    city: "Henderson",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Paradise",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Reno",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  // Pacific Time Zone
  {
    city: "Los Angeles",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "San Diego",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "San Jose",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "San Francisco",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Seattle",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Portland",
    state: "Oregon",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Las Vegas",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Sacramento",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Long Beach",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Oakland",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Bakersfield",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Anaheim",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Santa Ana",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Riverside",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Stockton",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Irvine",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Chula Vista",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Fremont",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "San Bernardino",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Modesto",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Fontana",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Moreno Valley",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Santa Clarita",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Glendale",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Huntington Beach",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Ontario",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Santa Rosa",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Vancouver",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Tacoma",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Eugene",
    state: "Oregon",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Salem",
    state: "Oregon",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Spokane",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Rancho Cucamonga",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Oceanside",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Garden Grove",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Santa Clara",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Elk Grove",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Corona",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Lancaster",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Palmdale",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Salinas",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Hayward",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Pomona",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Sunnyvale",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Escondido",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Torrance",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Roseville",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Pasadena",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Bellevue",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Thousand Oaks",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Vallejo",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Concord",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Visalia",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Simi Valley",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Berkeley",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Antioch",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Richmond",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Fairfield",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Murrieta",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "El Monte",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Carlsbad",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Temecula",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Clovis",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Costa Mesa",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Downey",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Westminster",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Jurupa Valley",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Norwalk",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Burbank",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "San Mateo",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "El Cajon",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Rialto",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Manteca",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Vista",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Vacaville",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "San Ramon",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Spokane Valley",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Kent",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Santa Maria",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Santa Barbara",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Redding",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Santa Monica",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "San Leandro",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Chico",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Citrus Heights",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Hawthorne",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Everett",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Mission Viejo",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Federal Way",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Carson",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Santa Cruz",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Redwood City",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Yakima",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Livermore",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Newport Beach",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "San Marcos",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Lakewood",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Folsom",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Pleasanton",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Merced",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Lynwood",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Union City",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Redlands",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Turlock",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Perris",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Mountain View",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Alameda",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Upland",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "San Buenaventura",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Napa",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Tustin",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Bellflower",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Pittsburg",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Watsonville",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Camarillo",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Redondo Beach",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Cupertino",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "San Rafael",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Lake Forest",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "La Habra",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Davis",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  // Alaska Time Zone
  {
    city: "Anchorage",
    state: "Alaska",
    timezone: "America/Anchorage"
  },
  {
    city: "Juneau",
    state: "Alaska",
    timezone: "America/Juneau"
  },
  {
    city: "Fairbanks",
    state: "Alaska",
    timezone: "America/Anchorage"
  },
  // Hawaii-Aleutian Time Zone
  {
    city: "Honolulu",
    state: "Hawaii",
    timezone: "Pacific/Honolulu"
  },
  {
    city: "Pearl City",
    state: "Hawaii",
    timezone: "Pacific/Honolulu"
  },
  {
    city: "Hilo",
    state: "Hawaii",
    timezone: "Pacific/Honolulu"
  }
];
var STATE_CITIES_TIMEZONES = [
  // Alabama
  {
    city: "Birmingham",
    state: "Alabama",
    timezone: "America/Chicago"
  },
  {
    city: "Huntsville",
    state: "Alabama",
    timezone: "America/Chicago"
  },
  {
    city: "Mobile",
    state: "Alabama",
    timezone: "America/Chicago"
  },
  {
    city: "Montgomery",
    state: "Alabama",
    timezone: "America/Chicago"
  },
  {
    city: "Tuscaloosa",
    state: "Alabama",
    timezone: "America/Chicago"
  },
  // Alaska
  {
    city: "Anchorage",
    state: "Alaska",
    timezone: "America/Anchorage"
  },
  {
    city: "Fairbanks",
    state: "Alaska",
    timezone: "America/Anchorage"
  },
  {
    city: "Juneau",
    state: "Alaska",
    timezone: "America/Juneau"
  },
  {
    city: "Sitka",
    state: "Alaska",
    timezone: "America/Sitka"
  },
  {
    city: "Wasilla",
    state: "Alaska",
    timezone: "America/Anchorage"
  },
  // Arizona
  {
    city: "Phoenix",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Tucson",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Mesa",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Chandler",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  {
    city: "Scottsdale",
    state: "Arizona",
    timezone: "America/Phoenix"
  },
  // Arkansas
  {
    city: "Little Rock",
    state: "Arkansas",
    timezone: "America/Chicago"
  },
  {
    city: "Fort Smith",
    state: "Arkansas",
    timezone: "America/Chicago"
  },
  {
    city: "Fayetteville",
    state: "Arkansas",
    timezone: "America/Chicago"
  },
  {
    city: "Springdale",
    state: "Arkansas",
    timezone: "America/Chicago"
  },
  {
    city: "Jonesboro",
    state: "Arkansas",
    timezone: "America/Chicago"
  },
  // California
  {
    city: "Los Angeles",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "San Diego",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "San Jose",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "San Francisco",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Fresno",
    state: "California",
    timezone: "America/Los_Angeles"
  },
  // Colorado
  {
    city: "Denver",
    state: "Colorado",
    timezone: "America/Denver"
  },
  {
    city: "Colorado Springs",
    state: "Colorado",
    timezone: "America/Denver"
  },
  {
    city: "Aurora",
    state: "Colorado",
    timezone: "America/Denver"
  },
  {
    city: "Fort Collins",
    state: "Colorado",
    timezone: "America/Denver"
  },
  {
    city: "Lakewood",
    state: "Colorado",
    timezone: "America/Denver"
  },
  // Connecticut
  {
    city: "Bridgeport",
    state: "Connecticut",
    timezone: "America/New_York"
  },
  {
    city: "New Haven",
    state: "Connecticut",
    timezone: "America/New_York"
  },
  {
    city: "Stamford",
    state: "Connecticut",
    timezone: "America/New_York"
  },
  {
    city: "Hartford",
    state: "Connecticut",
    timezone: "America/New_York"
  },
  {
    city: "Waterbury",
    state: "Connecticut",
    timezone: "America/New_York"
  },
  // Delaware
  {
    city: "Wilmington",
    state: "Delaware",
    timezone: "America/New_York"
  },
  {
    city: "Dover",
    state: "Delaware",
    timezone: "America/New_York"
  },
  {
    city: "Newark",
    state: "Delaware",
    timezone: "America/New_York"
  },
  {
    city: "Middletown",
    state: "Delaware",
    timezone: "America/New_York"
  },
  {
    city: "Smyrna",
    state: "Delaware",
    timezone: "America/New_York"
  },
  // Florida
  {
    city: "Jacksonville",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Miami",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Tampa",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Orlando",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "St. Petersburg",
    state: "Florida",
    timezone: "America/New_York"
  },
  // Georgia
  {
    city: "Atlanta",
    state: "Georgia",
    timezone: "America/New_York"
  },
  {
    city: "Augusta",
    state: "Georgia",
    timezone: "America/New_York"
  },
  {
    city: "Columbus",
    state: "Georgia",
    timezone: "America/New_York"
  },
  {
    city: "Macon",
    state: "Georgia",
    timezone: "America/New_York"
  },
  {
    city: "Savannah",
    state: "Georgia",
    timezone: "America/New_York"
  },
  // Hawaii
  {
    city: "Honolulu",
    state: "Hawaii",
    timezone: "Pacific/Honolulu"
  },
  {
    city: "Pearl City",
    state: "Hawaii",
    timezone: "Pacific/Honolulu"
  },
  {
    city: "Hilo",
    state: "Hawaii",
    timezone: "Pacific/Honolulu"
  },
  {
    city: "Kailua",
    state: "Hawaii",
    timezone: "Pacific/Honolulu"
  },
  {
    city: "Waipahu",
    state: "Hawaii",
    timezone: "Pacific/Honolulu"
  },
  // Illinois
  {
    city: "Chicago",
    state: "Illinois",
    timezone: "America/Chicago"
  },
  {
    city: "Aurora",
    state: "Illinois",
    timezone: "America/Chicago"
  },
  {
    city: "Joliet",
    state: "Illinois",
    timezone: "America/Chicago"
  },
  {
    city: "Naperville",
    state: "Illinois",
    timezone: "America/Chicago"
  },
  {
    city: "Rockford",
    state: "Illinois",
    timezone: "America/Chicago"
  },
  // Indiana
  {
    city: "Indianapolis",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Fort Wayne",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Evansville",
    state: "Indiana",
    timezone: "America/Chicago"
  },
  {
    city: "South Bend",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Carmel",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  // Iowa
  {
    city: "Des Moines",
    state: "Iowa",
    timezone: "America/Chicago"
  },
  {
    city: "Cedar Rapids",
    state: "Iowa",
    timezone: "America/Chicago"
  },
  {
    city: "Davenport",
    state: "Iowa",
    timezone: "America/Chicago"
  },
  {
    city: "Sioux City",
    state: "Iowa",
    timezone: "America/Chicago"
  },
  {
    city: "Iowa City",
    state: "Iowa",
    timezone: "America/Chicago"
  },
  // Kansas
  {
    city: "Wichita",
    state: "Kansas",
    timezone: "America/Chicago"
  },
  {
    city: "Overland Park",
    state: "Kansas",
    timezone: "America/Chicago"
  },
  {
    city: "Kansas City",
    state: "Kansas",
    timezone: "America/Chicago"
  },
  {
    city: "Olathe",
    state: "Kansas",
    timezone: "America/Chicago"
  },
  {
    city: "Topeka",
    state: "Kansas",
    timezone: "America/Chicago"
  },
  // Kentucky
  {
    city: "Louisville",
    state: "Kentucky",
    timezone: "America/Kentucky/Louisville"
  },
  {
    city: "Lexington",
    state: "Kentucky",
    timezone: "America/New_York"
  },
  {
    city: "Bowling Green",
    state: "Kentucky",
    timezone: "America/Chicago"
  },
  {
    city: "Owensboro",
    state: "Kentucky",
    timezone: "America/Chicago"
  },
  {
    city: "Covington",
    state: "Kentucky",
    timezone: "America/New_York"
  },
  // Louisiana
  {
    city: "New Orleans",
    state: "Louisiana",
    timezone: "America/Chicago"
  },
  {
    city: "Baton Rouge",
    state: "Louisiana",
    timezone: "America/Chicago"
  },
  {
    city: "Shreveport",
    state: "Louisiana",
    timezone: "America/Chicago"
  },
  {
    city: "Lafayette",
    state: "Louisiana",
    timezone: "America/Chicago"
  },
  {
    city: "Lake Charles",
    state: "Louisiana",
    timezone: "America/Chicago"
  },
  // Maine
  {
    city: "Portland",
    state: "Maine",
    timezone: "America/New_York"
  },
  {
    city: "Lewiston",
    state: "Maine",
    timezone: "America/New_York"
  },
  {
    city: "Bangor",
    state: "Maine",
    timezone: "America/New_York"
  },
  {
    city: "South Portland",
    state: "Maine",
    timezone: "America/New_York"
  },
  {
    city: "Auburn",
    state: "Maine",
    timezone: "America/New_York"
  },
  // Maryland
  {
    city: "Baltimore",
    state: "Maryland",
    timezone: "America/New_York"
  },
  {
    city: "Frederick",
    state: "Maryland",
    timezone: "America/New_York"
  },
  {
    city: "Rockville",
    state: "Maryland",
    timezone: "America/New_York"
  },
  {
    city: "Gaithersburg",
    state: "Maryland",
    timezone: "America/New_York"
  },
  {
    city: "Bowie",
    state: "Maryland",
    timezone: "America/New_York"
  },
  // Massachusetts
  {
    city: "Boston",
    state: "Massachusetts",
    timezone: "America/New_York"
  },
  {
    city: "Worcester",
    state: "Massachusetts",
    timezone: "America/New_York"
  },
  {
    city: "Springfield",
    state: "Massachusetts",
    timezone: "America/New_York"
  },
  {
    city: "Cambridge",
    state: "Massachusetts",
    timezone: "America/New_York"
  },
  {
    city: "Lowell",
    state: "Massachusetts",
    timezone: "America/New_York"
  },
  // Michigan
  {
    city: "Detroit",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Grand Rapids",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Warren",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Sterling Heights",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Ann Arbor",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  // Minnesota
  {
    city: "Minneapolis",
    state: "Minnesota",
    timezone: "America/Chicago"
  },
  {
    city: "St. Paul",
    state: "Minnesota",
    timezone: "America/Chicago"
  },
  {
    city: "Rochester",
    state: "Minnesota",
    timezone: "America/Chicago"
  },
  {
    city: "Duluth",
    state: "Minnesota",
    timezone: "America/Chicago"
  },
  {
    city: "Bloomington",
    state: "Minnesota",
    timezone: "America/Chicago"
  },
  // Mississippi
  {
    city: "Jackson",
    state: "Mississippi",
    timezone: "America/Chicago"
  },
  {
    city: "Gulfport",
    state: "Mississippi",
    timezone: "America/Chicago"
  },
  {
    city: "Southaven",
    state: "Mississippi",
    timezone: "America/Chicago"
  },
  {
    city: "Biloxi",
    state: "Mississippi",
    timezone: "America/Chicago"
  },
  {
    city: "Hattiesburg",
    state: "Mississippi",
    timezone: "America/Chicago"
  },
  // Missouri
  {
    city: "Kansas City",
    state: "Missouri",
    timezone: "America/Chicago"
  },
  {
    city: "St. Louis",
    state: "Missouri",
    timezone: "America/Chicago"
  },
  {
    city: "Springfield",
    state: "Missouri",
    timezone: "America/Chicago"
  },
  {
    city: "Columbia",
    state: "Missouri",
    timezone: "America/Chicago"
  },
  {
    city: "Independence",
    state: "Missouri",
    timezone: "America/Chicago"
  },
  // Montana
  {
    city: "Billings",
    state: "Montana",
    timezone: "America/Denver"
  },
  {
    city: "Missoula",
    state: "Montana",
    timezone: "America/Denver"
  },
  {
    city: "Great Falls",
    state: "Montana",
    timezone: "America/Denver"
  },
  {
    city: "Bozeman",
    state: "Montana",
    timezone: "America/Denver"
  },
  {
    city: "Helena",
    state: "Montana",
    timezone: "America/Denver"
  },
  // Nebraska
  {
    city: "Omaha",
    state: "Nebraska",
    timezone: "America/Chicago"
  },
  {
    city: "Lincoln",
    state: "Nebraska",
    timezone: "America/Chicago"
  },
  {
    city: "Bellevue",
    state: "Nebraska",
    timezone: "America/Chicago"
  },
  {
    city: "Grand Island",
    state: "Nebraska",
    timezone: "America/Chicago"
  },
  {
    city: "Kearney",
    state: "Nebraska",
    timezone: "America/Chicago"
  },
  // Nevada
  {
    city: "Las Vegas",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Henderson",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Reno",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  {
    city: "North Las Vegas",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Sparks",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  // New Hampshire
  {
    city: "Manchester",
    state: "New Hampshire",
    timezone: "America/New_York"
  },
  {
    city: "Nashua",
    state: "New Hampshire",
    timezone: "America/New_York"
  },
  {
    city: "Concord",
    state: "New Hampshire",
    timezone: "America/New_York"
  },
  {
    city: "Dover",
    state: "New Hampshire",
    timezone: "America/New_York"
  },
  {
    city: "Rochester",
    state: "New Hampshire",
    timezone: "America/New_York"
  },
  // New Jersey
  {
    city: "Newark",
    state: "New Jersey",
    timezone: "America/New_York"
  },
  {
    city: "Jersey City",
    state: "New Jersey",
    timezone: "America/New_York"
  },
  {
    city: "Paterson",
    state: "New Jersey",
    timezone: "America/New_York"
  },
  {
    city: "Elizabeth",
    state: "New Jersey",
    timezone: "America/New_York"
  },
  {
    city: "Edison",
    state: "New Jersey",
    timezone: "America/New_York"
  },
  // New Mexico
  {
    city: "Albuquerque",
    state: "New Mexico",
    timezone: "America/Denver"
  },
  {
    city: "Las Cruces",
    state: "New Mexico",
    timezone: "America/Denver"
  },
  {
    city: "Rio Rancho",
    state: "New Mexico",
    timezone: "America/Denver"
  },
  {
    city: "Santa Fe",
    state: "New Mexico",
    timezone: "America/Denver"
  },
  {
    city: "Roswell",
    state: "New Mexico",
    timezone: "America/Denver"
  },
  // New York
  {
    city: "New York City",
    state: "New York",
    timezone: "America/New_York"
  },
  {
    city: "Buffalo",
    state: "New York",
    timezone: "America/New_York"
  },
  {
    city: "Rochester",
    state: "New York",
    timezone: "America/New_York"
  },
  {
    city: "Yonkers",
    state: "New York",
    timezone: "America/New_York"
  },
  {
    city: "Syracuse",
    state: "New York",
    timezone: "America/New_York"
  },
  // North Carolina
  {
    city: "Charlotte",
    state: "North Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Raleigh",
    state: "North Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Greensboro",
    state: "North Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Durham",
    state: "North Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Winston-Salem",
    state: "North Carolina",
    timezone: "America/New_York"
  },
  // North Dakota
  {
    city: "Fargo",
    state: "North Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Bismarck",
    state: "North Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Grand Forks",
    state: "North Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Minot",
    state: "North Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "West Fargo",
    state: "North Dakota",
    timezone: "America/Chicago"
  },
  // Ohio
  {
    city: "Columbus",
    state: "Ohio",
    timezone: "America/New_York"
  },
  {
    city: "Cleveland",
    state: "Ohio",
    timezone: "America/New_York"
  },
  {
    city: "Cincinnati",
    state: "Ohio",
    timezone: "America/New_York"
  },
  {
    city: "Toledo",
    state: "Ohio",
    timezone: "America/New_York"
  },
  {
    city: "Akron",
    state: "Ohio",
    timezone: "America/New_York"
  },
  // Oklahoma
  {
    city: "Oklahoma City",
    state: "Oklahoma",
    timezone: "America/Chicago"
  },
  {
    city: "Tulsa",
    state: "Oklahoma",
    timezone: "America/Chicago"
  },
  {
    city: "Norman",
    state: "Oklahoma",
    timezone: "America/Chicago"
  },
  {
    city: "Broken Arrow",
    state: "Oklahoma",
    timezone: "America/Chicago"
  },
  {
    city: "Edmond",
    state: "Oklahoma",
    timezone: "America/Chicago"
  },
  // Oregon
  {
    city: "Portland",
    state: "Oregon",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Salem",
    state: "Oregon",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Eugene",
    state: "Oregon",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Gresham",
    state: "Oregon",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Hillsboro",
    state: "Oregon",
    timezone: "America/Los_Angeles"
  },
  // Pennsylvania
  {
    city: "Philadelphia",
    state: "Pennsylvania",
    timezone: "America/New_York"
  },
  {
    city: "Pittsburgh",
    state: "Pennsylvania",
    timezone: "America/New_York"
  },
  {
    city: "Allentown",
    state: "Pennsylvania",
    timezone: "America/New_York"
  },
  {
    city: "Erie",
    state: "Pennsylvania",
    timezone: "America/New_York"
  },
  {
    city: "Reading",
    state: "Pennsylvania",
    timezone: "America/New_York"
  },
  // Rhode Island
  {
    city: "Providence",
    state: "Rhode Island",
    timezone: "America/New_York"
  },
  {
    city: "Warwick",
    state: "Rhode Island",
    timezone: "America/New_York"
  },
  {
    city: "Cranston",
    state: "Rhode Island",
    timezone: "America/New_York"
  },
  {
    city: "Pawtucket",
    state: "Rhode Island",
    timezone: "America/New_York"
  },
  {
    city: "East Providence",
    state: "Rhode Island",
    timezone: "America/New_York"
  },
  // South Carolina
  {
    city: "Columbia",
    state: "South Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Charleston",
    state: "South Carolina",
    timezone: "America/New_York"
  },
  {
    city: "North Charleston",
    state: "South Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Mount Pleasant",
    state: "South Carolina",
    timezone: "America/New_York"
  },
  {
    city: "Rock Hill",
    state: "South Carolina",
    timezone: "America/New_York"
  },
  // South Dakota
  {
    city: "Sioux Falls",
    state: "South Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Rapid City",
    state: "South Dakota",
    timezone: "America/Denver"
  },
  {
    city: "Aberdeen",
    state: "South Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Brookings",
    state: "South Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Watertown",
    state: "South Dakota",
    timezone: "America/Chicago"
  },
  // Tennessee
  {
    city: "Nashville",
    state: "Tennessee",
    timezone: "America/Chicago"
  },
  {
    city: "Memphis",
    state: "Tennessee",
    timezone: "America/Chicago"
  },
  {
    city: "Knoxville",
    state: "Tennessee",
    timezone: "America/New_York"
  },
  {
    city: "Chattanooga",
    state: "Tennessee",
    timezone: "America/New_York"
  },
  {
    city: "Clarksville",
    state: "Tennessee",
    timezone: "America/Chicago"
  },
  // Texas
  {
    city: "Houston",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "San Antonio",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Dallas",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Austin",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Fort Worth",
    state: "Texas",
    timezone: "America/Chicago"
  },
  // Utah
  {
    city: "Salt Lake City",
    state: "Utah",
    timezone: "America/Denver"
  },
  {
    city: "West Valley City",
    state: "Utah",
    timezone: "America/Denver"
  },
  {
    city: "Provo",
    state: "Utah",
    timezone: "America/Denver"
  },
  {
    city: "West Jordan",
    state: "Utah",
    timezone: "America/Denver"
  },
  {
    city: "Orem",
    state: "Utah",
    timezone: "America/Denver"
  },
  // Vermont
  {
    city: "Burlington",
    state: "Vermont",
    timezone: "America/New_York"
  },
  {
    city: "South Burlington",
    state: "Vermont",
    timezone: "America/New_York"
  },
  {
    city: "Rutland",
    state: "Vermont",
    timezone: "America/New_York"
  },
  {
    city: "Essex Junction",
    state: "Vermont",
    timezone: "America/New_York"
  },
  {
    city: "Bennington",
    state: "Vermont",
    timezone: "America/New_York"
  },
  // Virginia
  {
    city: "Virginia Beach",
    state: "Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Norfolk",
    state: "Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Chesapeake",
    state: "Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Richmond",
    state: "Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Newport News",
    state: "Virginia",
    timezone: "America/New_York"
  },
  // Washington
  {
    city: "Seattle",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Spokane",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Tacoma",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Vancouver",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Bellevue",
    state: "Washington",
    timezone: "America/Los_Angeles"
  },
  // Washington D.C.
  {
    city: "Washington",
    state: "District of Columbia",
    timezone: "America/New_York"
  },
  // West Virginia
  {
    city: "Charleston",
    state: "West Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Huntington",
    state: "West Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Parkersburg",
    state: "West Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Morgantown",
    state: "West Virginia",
    timezone: "America/New_York"
  },
  {
    city: "Wheeling",
    state: "West Virginia",
    timezone: "America/New_York"
  },
  // Wisconsin
  {
    city: "Milwaukee",
    state: "Wisconsin",
    timezone: "America/Chicago"
  },
  {
    city: "Madison",
    state: "Wisconsin",
    timezone: "America/Chicago"
  },
  {
    city: "Green Bay",
    state: "Wisconsin",
    timezone: "America/Chicago"
  },
  {
    city: "Kenosha",
    state: "Wisconsin",
    timezone: "America/Chicago"
  },
  {
    city: "Racine",
    state: "Wisconsin",
    timezone: "America/Chicago"
  },
  // Wyoming
  {
    city: "Cheyenne",
    state: "Wyoming",
    timezone: "America/Denver"
  },
  {
    city: "Casper",
    state: "Wyoming",
    timezone: "America/Denver"
  },
  {
    city: "Laramie",
    state: "Wyoming",
    timezone: "America/Denver"
  },
  {
    city: "Gillette",
    state: "Wyoming",
    timezone: "America/Denver"
  },
  {
    city: "Rock Springs",
    state: "Wyoming",
    timezone: "America/Denver"
  },
  // States with multiple timezones
  // Idaho
  {
    city: "Boise",
    state: "Idaho",
    timezone: "America/Boise"
  },
  {
    city: "Meridian",
    state: "Idaho",
    timezone: "America/Boise"
  },
  {
    city: "Nampa",
    state: "Idaho",
    timezone: "America/Boise"
  },
  {
    city: "Idaho Falls",
    state: "Idaho",
    timezone: "America/Boise"
  },
  {
    city: "Coeur d'Alene",
    state: "Idaho",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Lewiston",
    state: "Idaho",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Moscow",
    state: "Idaho",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Post Falls",
    state: "Idaho",
    timezone: "America/Los_Angeles"
  },
  // Alaska
  {
    city: "Anchorage",
    state: "Alaska",
    timezone: "America/Anchorage"
  },
  {
    city: "Fairbanks",
    state: "Alaska",
    timezone: "America/Anchorage"
  },
  {
    city: "Eagle River",
    state: "Alaska",
    timezone: "America/Anchorage"
  },
  {
    city: "Wasilla",
    state: "Alaska",
    timezone: "America/Anchorage"
  },
  {
    city: "Palmer",
    state: "Alaska",
    timezone: "America/Anchorage"
  },
  {
    city: "Juneau",
    state: "Alaska",
    timezone: "America/Juneau"
  },
  {
    city: "Ketchikan",
    state: "Alaska",
    timezone: "America/Juneau"
  },
  {
    city: "Sitka",
    state: "Alaska",
    timezone: "America/Sitka"
  },
  {
    city: "Unalaska",
    state: "Alaska",
    timezone: "America/Adak"
  },
  {
    city: "Nome",
    state: "Alaska",
    timezone: "America/Nome"
  },
  // Florida
  // Eastern Time
  {
    city: "Miami",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Jacksonville",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Tampa",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "Orlando",
    state: "Florida",
    timezone: "America/New_York"
  },
  {
    city: "St. Petersburg",
    state: "Florida",
    timezone: "America/New_York"
  },
  // Central Time
  {
    city: "Pensacola",
    state: "Florida",
    timezone: "America/Chicago"
  },
  {
    city: "Panama City",
    state: "Florida",
    timezone: "America/Chicago"
  },
  {
    city: "Fort Walton Beach",
    state: "Florida",
    timezone: "America/Chicago"
  },
  {
    city: "Tallahassee",
    state: "Florida",
    timezone: "America/Chicago"
  },
  {
    city: "Milton",
    state: "Florida",
    timezone: "America/Chicago"
  },
  // Indiana
  // Eastern Time
  {
    city: "Indianapolis",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Fort Wayne",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "South Bend",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Carmel",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    city: "Bloomington",
    state: "Indiana",
    timezone: "America/Indiana/Indianapolis"
  },
  // Central Time
  {
    city: "Evansville",
    state: "Indiana",
    timezone: "America/Chicago"
  },
  {
    city: "Gary",
    state: "Indiana",
    timezone: "America/Chicago"
  },
  {
    city: "Hammond",
    state: "Indiana",
    timezone: "America/Chicago"
  },
  {
    city: "Michigan City",
    state: "Indiana",
    timezone: "America/Chicago"
  },
  {
    city: "Valparaiso",
    state: "Indiana",
    timezone: "America/Chicago"
  },
  // Kansas
  // Central Time
  {
    city: "Wichita",
    state: "Kansas",
    timezone: "America/Chicago"
  },
  {
    city: "Overland Park",
    state: "Kansas",
    timezone: "America/Chicago"
  },
  {
    city: "Kansas City",
    state: "Kansas",
    timezone: "America/Chicago"
  },
  {
    city: "Olathe",
    state: "Kansas",
    timezone: "America/Chicago"
  },
  {
    city: "Topeka",
    state: "Kansas",
    timezone: "America/Chicago"
  },
  // Mountain Time
  {
    city: "Goodland",
    state: "Kansas",
    timezone: "America/Denver"
  },
  {
    city: "Sharon Springs",
    state: "Kansas",
    timezone: "America/Denver"
  },
  {
    city: "Tribune",
    state: "Kansas",
    timezone: "America/Denver"
  },
  {
    city: "Wallace",
    state: "Kansas",
    timezone: "America/Denver"
  },
  {
    city: "Syracuse",
    state: "Kansas",
    timezone: "America/Denver"
  },
  // Kentucky
  // Eastern Time
  {
    city: "Lexington",
    state: "Kentucky",
    timezone: "America/New_York"
  },
  {
    city: "Louisville",
    state: "Kentucky",
    timezone: "America/Kentucky/Louisville"
  },
  {
    city: "Covington",
    state: "Kentucky",
    timezone: "America/New_York"
  },
  {
    city: "Richmond",
    state: "Kentucky",
    timezone: "America/New_York"
  },
  {
    city: "Georgetown",
    state: "Kentucky",
    timezone: "America/New_York"
  },
  // Central Time
  {
    city: "Bowling Green",
    state: "Kentucky",
    timezone: "America/Chicago"
  },
  {
    city: "Owensboro",
    state: "Kentucky",
    timezone: "America/Chicago"
  },
  {
    city: "Hopkinsville",
    state: "Kentucky",
    timezone: "America/Chicago"
  },
  {
    city: "Paducah",
    state: "Kentucky",
    timezone: "America/Chicago"
  },
  {
    city: "Henderson",
    state: "Kentucky",
    timezone: "America/Chicago"
  },
  // Michigan
  // Eastern Time
  {
    city: "Detroit",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Grand Rapids",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Warren",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Sterling Heights",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  {
    city: "Ann Arbor",
    state: "Michigan",
    timezone: "America/Detroit"
  },
  // Central Time
  {
    city: "Iron Mountain",
    state: "Michigan",
    timezone: "America/Chicago"
  },
  {
    city: "Menominee",
    state: "Michigan",
    timezone: "America/Chicago"
  },
  {
    city: "Iron River",
    state: "Michigan",
    timezone: "America/Chicago"
  },
  {
    city: "Norway",
    state: "Michigan",
    timezone: "America/Chicago"
  },
  {
    city: "Crystal Falls",
    state: "Michigan",
    timezone: "America/Chicago"
  },
  // Nebraska
  // Central Time
  {
    city: "Omaha",
    state: "Nebraska",
    timezone: "America/Chicago"
  },
  {
    city: "Lincoln",
    state: "Nebraska",
    timezone: "America/Chicago"
  },
  {
    city: "Bellevue",
    state: "Nebraska",
    timezone: "America/Chicago"
  },
  {
    city: "Grand Island",
    state: "Nebraska",
    timezone: "America/Chicago"
  },
  {
    city: "Kearney",
    state: "Nebraska",
    timezone: "America/Chicago"
  },
  // Mountain Time
  {
    city: "Scottsbluff",
    state: "Nebraska",
    timezone: "America/Denver"
  },
  {
    city: "Gering",
    state: "Nebraska",
    timezone: "America/Denver"
  },
  {
    city: "Alliance",
    state: "Nebraska",
    timezone: "America/Denver"
  },
  {
    city: "Chadron",
    state: "Nebraska",
    timezone: "America/Denver"
  },
  {
    city: "Sidney",
    state: "Nebraska",
    timezone: "America/Denver"
  },
  // Nevada
  // Pacific Time
  {
    city: "Las Vegas",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Henderson",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Reno",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  {
    city: "North Las Vegas",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Sparks",
    state: "Nevada",
    timezone: "America/Los_Angeles"
  },
  // Mountain Time
  {
    city: "West Wendover",
    state: "Nevada",
    timezone: "America/Denver"
  },
  // North Dakota
  // Central Time
  {
    city: "Fargo",
    state: "North Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Bismarck",
    state: "North Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Grand Forks",
    state: "North Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Minot",
    state: "North Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "West Fargo",
    state: "North Dakota",
    timezone: "America/Chicago"
  },
  // Mountain Time
  {
    city: "Dickinson",
    state: "North Dakota",
    timezone: "America/Denver"
  },
  {
    city: "Beach",
    state: "North Dakota",
    timezone: "America/Denver"
  },
  {
    city: "Belfield",
    state: "North Dakota",
    timezone: "America/Denver"
  },
  {
    city: "Medora",
    state: "North Dakota",
    timezone: "America/Denver"
  },
  {
    city: "Bowman",
    state: "North Dakota",
    timezone: "America/Denver"
  },
  // Oregon
  // Pacific Time
  {
    city: "Portland",
    state: "Oregon",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Salem",
    state: "Oregon",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Eugene",
    state: "Oregon",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Gresham",
    state: "Oregon",
    timezone: "America/Los_Angeles"
  },
  {
    city: "Hillsboro",
    state: "Oregon",
    timezone: "America/Los_Angeles"
  },
  // Mountain Time
  {
    city: "Ontario",
    state: "Oregon",
    timezone: "America/Boise"
  },
  {
    city: "Vale",
    state: "Oregon",
    timezone: "America/Boise"
  },
  {
    city: "Nyssa",
    state: "Oregon",
    timezone: "America/Boise"
  },
  {
    city: "Jordan Valley",
    state: "Oregon",
    timezone: "America/Boise"
  },
  {
    city: "Adrian",
    state: "Oregon",
    timezone: "America/Boise"
  },
  // South Dakota
  // Central Time
  {
    city: "Sioux Falls",
    state: "South Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Aberdeen",
    state: "South Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Watertown",
    state: "South Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Brookings",
    state: "South Dakota",
    timezone: "America/Chicago"
  },
  {
    city: "Mitchell",
    state: "South Dakota",
    timezone: "America/Chicago"
  },
  // Mountain Time
  {
    city: "Rapid City",
    state: "South Dakota",
    timezone: "America/Denver"
  },
  {
    city: "Spearfish",
    state: "South Dakota",
    timezone: "America/Denver"
  },
  {
    city: "Sturgis",
    state: "South Dakota",
    timezone: "America/Denver"
  },
  {
    city: "Hot Springs",
    state: "South Dakota",
    timezone: "America/Denver"
  },
  {
    city: "Belle Fourche",
    state: "South Dakota",
    timezone: "America/Denver"
  },
  // Tennessee
  // Central Time
  {
    city: "Nashville",
    state: "Tennessee",
    timezone: "America/Chicago"
  },
  {
    city: "Memphis",
    state: "Tennessee",
    timezone: "America/Chicago"
  },
  {
    city: "Clarksville",
    state: "Tennessee",
    timezone: "America/Chicago"
  },
  {
    city: "Murfreesboro",
    state: "Tennessee",
    timezone: "America/Chicago"
  },
  {
    city: "Franklin",
    state: "Tennessee",
    timezone: "America/Chicago"
  },
  // Eastern Time
  {
    city: "Knoxville",
    state: "Tennessee",
    timezone: "America/New_York"
  },
  {
    city: "Chattanooga",
    state: "Tennessee",
    timezone: "America/New_York"
  },
  {
    city: "Johnson City",
    state: "Tennessee",
    timezone: "America/New_York"
  },
  {
    city: "Kingsport",
    state: "Tennessee",
    timezone: "America/New_York"
  },
  {
    city: "Oak Ridge",
    state: "Tennessee",
    timezone: "America/New_York"
  },
  // Texas
  // Central Time
  {
    city: "Houston",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "San Antonio",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Dallas",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Austin",
    state: "Texas",
    timezone: "America/Chicago"
  },
  {
    city: "Fort Worth",
    state: "Texas",
    timezone: "America/Chicago"
  },
  // Mountain Time
  {
    city: "El Paso",
    state: "Texas",
    timezone: "America/Denver"
  },
  {
    city: "Socorro",
    state: "Texas",
    timezone: "America/Denver"
  },
  {
    city: "Horizon City",
    state: "Texas",
    timezone: "America/Denver"
  },
  {
    city: "Fort Bliss",
    state: "Texas",
    timezone: "America/Denver"
  },
  {
    city: "San Elizario",
    state: "Texas",
    timezone: "America/Denver"
  }
];
var allCities = [
  ...MAJOR_CITIES_TIMEZONES,
  ...STATE_CITIES_TIMEZONES
];
var uniqCities = (0, import_lodash.uniqBy)(allCities, JSON.stringify);
var US_MAJOR_CITY_TIMEZONES = (0, import_lodash.sortBy)(uniqCities, [
  "state",
  "city"
]);

// src/date/dayjs/m7DayJs.ts
var import_dayjs = __toESM(require("dayjs"));
var import_advancedFormat = __toESM(require("dayjs/plugin/advancedFormat"));
var import_calendar = __toESM(require("dayjs/plugin/calendar"));
var import_customParseFormat = __toESM(require("dayjs/plugin/customParseFormat"));
var import_duration = __toESM(require("dayjs/plugin/duration"));
var import_isBetween = __toESM(require("dayjs/plugin/isBetween"));
var import_isSameOrAfter = __toESM(require("dayjs/plugin/isSameOrAfter"));
var import_isSameOrBefore = __toESM(require("dayjs/plugin/isSameOrBefore"));
var import_isoWeek = __toESM(require("dayjs/plugin/isoWeek"));
var import_localeData = __toESM(require("dayjs/plugin/localeData"));
var import_localizedFormat = __toESM(require("dayjs/plugin/localizedFormat"));
var import_minMax = __toESM(require("dayjs/plugin/minMax"));
var import_relativeTime = __toESM(require("dayjs/plugin/relativeTime"));
var import_utc = __toESM(require("dayjs/plugin/utc"));
var import_weekOfYear = __toESM(require("dayjs/plugin/weekOfYear"));

// src/date/dayjs/addInTz.ts
var tzAddPlugin = /* @__PURE__ */ __name((_, dayjsClass, dayjsObject) => {
  dayjsClass.prototype.addInTz = function(...args) {
    const timezone = this.$x.$timezone;
    if (!timezone) {
      throw new Error("No timezone set");
    }
    return dayjsObject.tz(dayjsObject(this.toDate()).tz(timezone).add(...args).format("YYYY-MM-DD HH:mm:ss"), timezone);
  };
  dayjsClass.prototype.subtractInTz = function(...args) {
    const timezone = this.$x.$timezone;
    if (!timezone) {
      throw new Error("No timezone set");
    }
    return dayjsObject.tz(dayjsObject(this.toDate()).tz(timezone).subtract(...args).format("YYYY-MM-DD HH:mm:ss"), timezone);
  };
}, "tzAddPlugin");

// src/date/dayjs/performanceTimezone.ts
var SECONDS_A_MINUTE = 60;
var MILLISECONDS_A_SECOND = 1e3;
var MILLISECONDS_A_MINUTE = SECONDS_A_MINUTE * MILLISECONDS_A_SECOND;
var MS = "millisecond";
var MIN = "minute";
var performanceTimezone_default = /* @__PURE__ */ __name((o, c, d) => {
  let defaultTimezone;
  const proto = c.prototype;
  const dtfCache = {
    __proto: null
  };
  const getDateTimeFormat = /* @__PURE__ */ __name((timezone, timeZoneName) => {
    const key = `${timezone}|${timeZoneName}`;
    let dtf = dtfCache[key];
    if (!dtf) {
      dtf = new Intl.DateTimeFormat("en-US", {
        day: "numeric",
        hour: "numeric",
        hourCycle: "h23",
        minute: "numeric",
        month: "numeric",
        second: "numeric",
        timeZone: timezone,
        timeZoneName,
        year: "numeric"
      });
      dtfCache[key] = dtf;
    }
    return dtf;
  }, "getDateTimeFormat");
  const makeFormatParts = /* @__PURE__ */ __name((timestamp, timezone, timeZoneName) => {
    const date = new Date(timestamp);
    const dtf = getDateTimeFormat(timezone, timeZoneName);
    const formatResult = dtf.formatToParts(date);
    return formatResult;
  }, "makeFormatParts");
  const tzOffset = /* @__PURE__ */ __name((timestamp, timezone) => {
    const formatResult = makeFormatParts(timestamp, timezone);
    let Y;
    let M;
    let D;
    let h;
    let m;
    let s;
    formatResult.forEach((r) => {
      switch (r.type) {
        case "year":
          Y = r.value;
          break;
        case "month":
          M = r.value - 1;
          break;
        case "day":
          D = r.value;
          break;
        case "hour":
          h = r.value;
          break;
        case "minute":
          m = r.value;
          break;
        case "second":
          s = r.value;
          break;
        default:
          break;
      }
    });
    const utcTs = Date.UTC(Y, M, D, h, m, s);
    const asTS = timestamp;
    const over = asTS % MILLISECONDS_A_SECOND;
    return (utcTs - (asTS - over)) / MILLISECONDS_A_MINUTE;
  }, "tzOffset");
  const tzToFirstOffsetCache = {
    __proto__: null
  };
  const initialValue = +d();
  const tzToFirstOffset = /* @__PURE__ */ __name((timezone) => {
    let offset = tzToFirstOffsetCache[timezone];
    if (offset == null) {
      offset = tzOffset(initialValue, timezone);
      tzToFirstOffsetCache[timezone] = offset;
    }
    return offset;
  }, "tzToFirstOffset");
  const fixOffset = /* @__PURE__ */ __name((localTS, tz) => {
    let o0 = tzToFirstOffset(tz);
    let utcGuess;
    let o2;
    utcGuess = localTS - o0 * MILLISECONDS_A_MINUTE;
    o2 = tzOffset(utcGuess, tz);
    if (o0 !== o2) {
      o0 = o2;
      utcGuess = localTS - o0 * MILLISECONDS_A_MINUTE;
      o2 = tzOffset(utcGuess, tz);
      if (o0 > o2) {
        utcGuess = o0;
        o0 = o2;
        o2 = utcGuess;
        utcGuess = localTS - o0 * MILLISECONDS_A_MINUTE;
      }
    }
    return d(utcGuess).utcOffset(o2);
  }, "fixOffset");
  proto.tz = function(timezone = defaultTimezone, keepLocalTime) {
    const date = this.toDate();
    const target = this.isValid() ? new Date(getDateTimeFormat(timezone).format(date)) : NaN;
    const diff = Math.round((date - target) / MILLISECONDS_A_MINUTE);
    const offset = -Math.round(date.getTimezoneOffset() / 15) * 15 - diff;
    const isUTC = !offset;
    let ins;
    if (isUTC) {
      ins = this.utcOffset(0, keepLocalTime);
    } else {
      ins = d(target, {
        locale: this.$L
      }).$set(MS, this.$ms).utcOffset(offset, true);
      if (keepLocalTime) {
        const oldOffset = this.utcOffset();
        const newOffset = ins.utcOffset();
        ins = ins.add(oldOffset - newOffset, MIN);
      }
    }
    ins.$x.$timezone = timezone;
    return ins;
  };
  proto.offsetName = function(type) {
    const zone = this.$x.$timezone || d.tz.guess();
    const result = makeFormatParts(+this, zone, type || "short").find((i) => i.type === "timeZoneName").value;
    return result;
  };
  const oldStartOf = proto.startOf;
  proto.startOf = function(units, startOf) {
    if (!this.$x || !this.$x.$timezone) {
      return oldStartOf.call(this, units, startOf);
    }
    const withoutTz = d(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
      locale: this.$L
    });
    const startOfWithoutTz = oldStartOf.call(withoutTz, units, startOf);
    return startOfWithoutTz.tz(this.$x.$timezone, true);
  };
  d.tz = function(input, arg1, arg2) {
    const timezone = arg2 || arg1 || defaultTimezone;
    if (typeof input !== "string") {
      return d(input).tz(timezone);
    }
    const parseFormat = arg2 && arg1;
    const localTs = +d.utc(input, parseFormat);
    const ins = fixOffset(localTs, timezone);
    ins.$x.$timezone = timezone;
    return ins;
  };
  d.tz.guess = function() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };
  d.tz.setDefault = function(timezone) {
    defaultTimezone = timezone;
  };
}, "default");

// src/date/dayjs/m7DayJs.ts
import_dayjs.default.extend(import_calendar.default);
import_dayjs.default.extend(import_localeData.default);
import_dayjs.default.extend(import_isoWeek.default);
import_dayjs.default.extend(performanceTimezone_default);
import_dayjs.default.extend(import_duration.default);
import_dayjs.default.extend(import_localizedFormat.default);
import_dayjs.default.extend(import_utc.default);
import_dayjs.default.extend(import_relativeTime.default);
import_dayjs.default.extend(import_isBetween.default);
import_dayjs.default.extend(import_customParseFormat.default);
import_dayjs.default.extend(import_isSameOrAfter.default);
import_dayjs.default.extend(import_isSameOrBefore.default);
import_dayjs.default.extend(import_advancedFormat.default);
import_dayjs.default.extend(import_minMax.default);
import_dayjs.default.extend(tzAddPlugin);
import_dayjs.default.extend(import_weekOfYear.default);
var m7DayJs = import_dayjs.default;
var _now = (0, import_dayjs.default)();

// src/date/dayjs/public_types.ts
var import_advancedFormat2 = __toESM(require("dayjs/plugin/advancedFormat"));
var import_calendar2 = __toESM(require("dayjs/plugin/calendar"));
var import_customParseFormat2 = __toESM(require("dayjs/plugin/customParseFormat"));
var import_duration2 = __toESM(require("dayjs/plugin/duration"));
var import_isBetween2 = __toESM(require("dayjs/plugin/isBetween"));
var import_isoWeek2 = __toESM(require("dayjs/plugin/isoWeek"));
var import_isSameOrAfter2 = __toESM(require("dayjs/plugin/isSameOrAfter"));
var import_isSameOrBefore2 = __toESM(require("dayjs/plugin/isSameOrBefore"));
var import_localeData2 = __toESM(require("dayjs/plugin/localeData"));
var import_localizedFormat2 = __toESM(require("dayjs/plugin/localizedFormat"));
var import_minMax2 = __toESM(require("dayjs/plugin/minMax"));
var import_relativeTime2 = __toESM(require("dayjs/plugin/relativeTime"));
var import_timezone = __toESM(require("dayjs/plugin/timezone"));
var import_utc2 = __toESM(require("dayjs/plugin/utc"));
var import_weekOfYear2 = __toESM(require("dayjs/plugin/weekOfYear"));
var import_dayjs2 = require("dayjs");

// src/date/types.ts
var EWeekDay = /* @__PURE__ */ function(EWeekDay2) {
  EWeekDay2[EWeekDay2["sunday"] = 0] = "sunday";
  EWeekDay2[EWeekDay2["monday"] = 1] = "monday";
  EWeekDay2[EWeekDay2["tuesday"] = 2] = "tuesday";
  EWeekDay2[EWeekDay2["wednesday"] = 3] = "wednesday";
  EWeekDay2[EWeekDay2["thursday"] = 4] = "thursday";
  EWeekDay2[EWeekDay2["friday"] = 5] = "friday";
  EWeekDay2[EWeekDay2["saturday"] = 6] = "saturday";
  return EWeekDay2;
}({});

// src/date/utils/toISO.ts
var import_luxon = require("luxon");
var toISO = /* @__PURE__ */ __name((date) => {
  if (import_luxon.DateTime.isDateTime(date)) date = date.toJSDate();
  return date.toISOString();
}, "toISO");

// src/date/utils/beforeAfterChecks.ts
var isAfter = /* @__PURE__ */ __name((date1, date2) => toISO(date1) > toISO(date2), "isAfter");
var isBefore = /* @__PURE__ */ __name((date1, date2) => toISO(date1) < toISO(date2), "isBefore");
var isEqual = /* @__PURE__ */ __name((date1, date2) => toISO(date1) === toISO(date2), "isEqual");
var isAfterOrEqual = /* @__PURE__ */ __name((date1, date2) => isAfter(date1, date2) || isEqual(date1, date2), "isAfterOrEqual");
var isBeforeOrEqual = /* @__PURE__ */ __name((date1, date2) => isBefore(date1, date2) || isEqual(date1, date2), "isBeforeOrEqual");
var DateCmp = {
  isAfter,
  isAfterOrEqual,
  isBefore,
  isBeforeOrEqual,
  isEqual
};

// src/date/utils/getTzDayjs.ts
var import_lodash2 = __toESM(require_lodash());

// src/date/utils/datesCache.ts
var import_luxon2 = require("luxon");
var timeoutId;
var cacheExpiration = 0;
var enableDateCacheTimeout = /* @__PURE__ */ __name((tls) => {
  cacheExpiration = tls;
  resetDateCaches();
}, "enableDateCacheTimeout");
var datesCaches;
var resetDateCaches = /* @__PURE__ */ __name(() => {
  datesCaches = {
    dateTimeAndTimeStringToDateTime: {},
    getShiftRange: {},
    getTzDate: {},
    getTzDayjs: {},
    getTzFormattedDate: {},
    getTzFormattedTime: {},
    isWeekendTime: {},
    timeInTzToDayjs: {},
    timeStringToDayjs: {}
  };
  if (cacheExpiration) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(resetDateCaches, cacheExpiration);
  }
}, "resetDateCaches");
resetDateCaches();
var useCacheFor = /* @__PURE__ */ __name((methodKey) => ({
  get: /* @__PURE__ */ __name((date, stringParams) => {
    const dateKey = getDateKey(date, stringParams);
    return datesCaches[methodKey][dateKey];
  }, "get"),
  getOrSet: /* @__PURE__ */ __name((date, params, getValueCallback) => {
    const stringParams = typeof params === "string" ? params : JSON.stringify(params);
    const dateKey = getDateKey(date, stringParams);
    const cachedValue = datesCaches[methodKey][dateKey];
    if (cachedValue) return cachedValue;
    const value = getValueCallback();
    datesCaches[methodKey][dateKey] = value;
    return value;
  }, "getOrSet"),
  keys: /* @__PURE__ */ __name(() => Object.keys(datesCaches[methodKey]), "keys"),
  reset: /* @__PURE__ */ __name(() => {
    datesCaches[methodKey] = {};
  }, "reset"),
  set: /* @__PURE__ */ __name((date, stringParams, value) => {
    const dateKey = getDateKey(date, stringParams);
    datesCaches[methodKey][dateKey] = value;
    return value;
  }, "set")
}), "useCacheFor");
var closeDateCache = /* @__PURE__ */ __name(() => clearTimeout(timeoutId), "closeDateCache");
var getDateKey = /* @__PURE__ */ __name((date, stringParams) => {
  const dateLib = import_luxon2.DateTime.isDateTime(date) ? "-luxon" : "";
  return `v${VERSION}-${date == null ? void 0 : date.toString()}-${stringParams || "_NO_TIMEZONE_"}${dateLib}`;
}, "getDateKey");

// src/date/utils/getTzDayjs.ts
var { get: getFromCache, set: setToCache, reset: resetCache } = useCacheFor("getTzDayjs");
function getTzDayjs(date, timezone) {
  let dateJs;
  if (date === null) date = void 0;
  timezone || (timezone = (0, import_lodash2.get)(date, "$x.$timezone"));
  if (date) {
    const cachedValue = getFromCache(date, timezone);
    if (cachedValue) return cachedValue;
    const trimmedDateString = typeof date === "string" && date.trim();
    if (trimmedDateString && (trimmedDateString.endsWith("Z") || trimmedDateString.includes("GMT"))) {
      dateJs = m7DayJs(date).tz(timezone);
    } else {
      dateJs = m7DayJs.tz(date, timezone);
    }
  } else {
    dateJs = m7DayJs.tz(date, timezone);
  }
  if (!timezone && !(0, import_lodash2.get)(dateJs, "$x.$timezone")) throw new Error("Timezone must be provided");
  if (date) setToCache(date, timezone, dateJs);
  return dateJs;
}
__name(getTzDayjs, "getTzDayjs");
getTzDayjs.clearCache = resetCache;

// src/date/utils/dateAndTimeStringsToDateTime.ts
function dateAndTimeStringsToDateTime(date, time, timezone) {
  return getTzDayjs(`${date}T${time}`, timezone);
}
__name(dateAndTimeStringsToDateTime, "dateAndTimeStringsToDateTime");

// src/date/utils/timeStringToDate.ts
var import_luxon3 = require("luxon");
var timeStringToDate = /* @__PURE__ */ __name((time, timezone) => {
  const [hours, minutes, secondsAndMs] = time.split(":");
  const [seconds, milliseconds] = (secondsAndMs == null ? void 0 : secondsAndMs.split(".")) || [
    0,
    0
  ];
  let result = m7DayJs();
  if (timezone) result = result.tz(timezone);
  return result.set("hour", Number(hours)).set("minute", Number(minutes)).set("seconds", Number(seconds)).set("milliseconds", Number(milliseconds || "000"));
}, "timeStringToDate");
var timeStringToDateTime = /* @__PURE__ */ __name((time, timezone) => {
  const [hours, minutes, secondsAndMs] = time.split(":");
  const [seconds, milliseconds] = (secondsAndMs == null ? void 0 : secondsAndMs.split(".")) || [
    0,
    0
  ];
  let result = import_luxon3.DateTime.fromObject({
    hour: Number(hours),
    millisecond: Number(milliseconds || "000"),
    minute: Number(minutes),
    second: Number(seconds)
  });
  if (timezone) result = result.setZone(timezone, {
    keepLocalTime: true
  });
  return result;
}, "timeStringToDateTime");

// src/date/utils/dateTimeAndTimeStringToDateTime.ts
var { get: getFromCache2, set: setToCache2, reset: resetCache2 } = useCacheFor("dateTimeAndTimeStringToDateTime");
function dateTimeAndTimeStringToDateTime(date, time) {
  const cachedValue = getFromCache2(date, time);
  if (cachedValue) return cachedValue;
  const customStartTime = timeStringToDateTime(time);
  const result = date.set({
    hour: customStartTime.hour,
    minute: customStartTime.minute,
    second: customStartTime.second
  });
  setToCache2(date, time, result);
  return result;
}
__name(dateTimeAndTimeStringToDateTime, "dateTimeAndTimeStringToDateTime");
dateTimeAndTimeStringToDateTime.clearCache = resetCache2;

// src/date/utils/getTzDate.ts
var import_lodash3 = __toESM(require_lodash());
var import_luxon4 = require("luxon");
var { get: getFromCache3, set: setToCache3, reset: resetCache3 } = useCacheFor("getTzDate");
function getTzDate(date, timezone) {
  timezone || (timezone = (0, import_lodash3.get)(date, "zoneName"));
  timezone || (timezone = (0, import_lodash3.get)(date, "$x.$timezone"));
  if (date) {
    const cachedValue = getFromCache3(date, timezone);
    if (cachedValue) return cachedValue;
  }
  const result = (() => {
    if (date instanceof m7DayJs) date = toISO(date);
    if (!date) return import_luxon4.DateTime.now().setZone(timezone);
    if (import_luxon4.DateTime.isDateTime(date)) return date.setZone(timezone);
    if (typeof date === "string" && !timezone) throw new Error("Timezone must be provided");
    const trimmedDateString = typeof date === "string" && date.trim();
    if (trimmedDateString && (trimmedDateString.endsWith("Z") || trimmedDateString.includes("GMT"))) return import_luxon4.DateTime.fromISO(trimmedDateString).setZone(timezone);
    if (trimmedDateString) {
      if (trimmedDateString.match(/^\d{4}-\d{2}-\d{2}$/)) return import_luxon4.DateTime.fromFormat(`${trimmedDateString} ${timezone || ""}`, "yyyy-MM-dd z", {
        setZone: true
      });
      else if (trimmedDateString.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?$/)) {
        return import_luxon4.DateTime.fromISO(trimmedDateString, {
          setZone: true,
          zone: timezone
        });
      }
      throw new Error(`Unknown string date format: ${date.toString()}`);
    }
    if (date instanceof Date) return import_luxon4.DateTime.fromJSDate(date).setZone(timezone);
    const undefinedDate = date || "undefined";
    throw new Error(`Unknown date: ${undefinedDate}`);
  })();
  if (!timezone && !(0, import_lodash3.get)(result, "zoneName")) throw new Error("Timezone must be provided");
  if (!result.isValid) throw new Error(`Invalid date: ${result.invalidExplanation || "unknown"}`);
  setToCache3(date, timezone, result);
  return result;
}
__name(getTzDate, "getTzDate");
getTzDate.clearCache = resetCache3;

// src/date/utils/dateToTimeString.ts
function dateToTimeString(date, timezone) {
  if (typeof date === "string" || date instanceof Date) {
    date = getTzDate(date, timezone);
  }
  return date.toFormat("HH:mm:ss.SSS");
}
__name(dateToTimeString, "dateToTimeString");

// src/date/utils/diffDateTimeRange.ts
function diffDateTimeRange(range1, range2) {
  var _a, _b, _c, _d, _e, _f;
  const range1Start = range1.startTime;
  const range1End = (_a = range1.endTime) != null ? _a : range1.startTime.plus({
    seconds: range1.durationSeconds
  });
  const range1ShiftTypeKey = range1.shiftTypeKey;
  const range2Start = range2.startTime;
  const range2End = (_b = range2.endTime) != null ? _b : range2.startTime.plus({
    seconds: range2.durationSeconds
  });
  const range2ShiftTypeKey = range2.shiftTypeKey;
  if (range1Start >= range2End || range1End <= range2Start) return {
    overlapSeconds: 0,
    range1Diff: [
      range1
    ],
    range2Diff: [
      range2
    ]
  };
  const range1Duration = range1.durationSeconds;
  if (range2End >= range1End && range2Start <= range1Start) {
    const result = {
      overlapSeconds: range1.durationSeconds,
      range1Diff: [],
      range2Diff: []
    };
    if (range2Start < range1Start) {
      (_c = result.range2Diff) == null ? void 0 : _c.push({
        durationSeconds: range1Start.diff(range2Start, "seconds").seconds,
        endTime: range1Start,
        shiftTypeKey: range2ShiftTypeKey,
        staffCategoryKey: range2.staffCategoryKey,
        startTime: range2Start
      });
    }
    if (range2End > range1End) {
      (_d = result.range2Diff) == null ? void 0 : _d.push({
        durationSeconds: range2End.diff(range1End, "seconds").seconds,
        endTime: range2End,
        shiftTypeKey: range2ShiftTypeKey,
        staffCategoryKey: range2.staffCategoryKey,
        startTime: range1End
      });
    }
    return result;
  }
  if (range2Start <= range1Start) {
    const result = {
      overlapSeconds: range1Duration - range1End.diff(range2End, "seconds").seconds,
      range1Diff: [
        {
          durationSeconds: range1End.diff(range2End, "seconds").seconds,
          endTime: range1End,
          shiftTypeKey: range1ShiftTypeKey,
          staffCategoryKey: range1.staffCategoryKey,
          startTime: range2End
        }
      ],
      range2Diff: []
    };
    if (range2Start < range1Start) {
      (_e = result.range2Diff) == null ? void 0 : _e.push({
        durationSeconds: range1Start.diff(range2Start, "seconds").seconds,
        endTime: range1Start,
        shiftTypeKey: range2ShiftTypeKey,
        staffCategoryKey: range2.staffCategoryKey,
        startTime: range2Start
      });
    }
    return result;
  }
  if (range2End >= range1End) {
    const result = {
      overlapSeconds: range1Duration - range2Start.diff(range1Start, "seconds").seconds,
      range1Diff: [
        {
          durationSeconds: range2Start.diff(range1Start, "seconds").seconds,
          endTime: range2Start,
          shiftTypeKey: range1ShiftTypeKey,
          staffCategoryKey: range1.staffCategoryKey,
          startTime: range1Start
        }
      ],
      range2Diff: []
    };
    if (range2End > range1End) {
      (_f = result.range2Diff) == null ? void 0 : _f.push({
        durationSeconds: range2End.diff(range1End, "seconds").seconds,
        endTime: range2End,
        shiftTypeKey: range2ShiftTypeKey,
        staffCategoryKey: range2.staffCategoryKey,
        startTime: range1End
      });
    }
    return result;
  }
  const range1Diff = [
    {
      durationSeconds: range2Start.diff(range1Start, "seconds").seconds,
      endTime: range2Start,
      shiftTypeKey: range1ShiftTypeKey,
      staffCategoryKey: range1.staffCategoryKey,
      startTime: range1Start
    },
    {
      durationSeconds: range1End.diff(range2End, "seconds").seconds,
      endTime: range1End,
      shiftTypeKey: range1ShiftTypeKey,
      staffCategoryKey: range1.staffCategoryKey,
      startTime: range2End
    }
  ];
  return {
    overlapSeconds: range2.durationSeconds,
    range1Diff
  };
}
__name(diffDateTimeRange, "diffDateTimeRange");

// src/date/utils/getDatesInRange.ts
var legacyGetDatesInRange = /* @__PURE__ */ __name((startDate, endDate) => {
  try {
    return Array(endDate.diff(startDate, "day", false) + 1).fill(startDate).map((date, index) => date.addInTz(index, "days").startOf("day"));
  } catch (_error) {
    const error = _error;
    console.warn("dates don't have timezone info, falling back to local timezone", error.stack);
    return Array(endDate.diff(startDate, "day", false) + 1).fill(startDate).map((date, index) => date.add(index, "days").startOf("day"));
  }
}, "legacyGetDatesInRange");
var getDatesInRange = /* @__PURE__ */ __name((startDate, endDate) => {
  let dayDiff = endDate.diff(startDate, "days").days;
  let startFrom = startDate;
  if (dayDiff % 1 !== 0) {
    startFrom = startDate.startOf("day");
    dayDiff = endDate.startOf("day").diff(startFrom, "days").days;
  }
  return Array(dayDiff + 1).fill(startFrom).map((date, index) => date.plus({
    days: index
  }));
}, "getDatesInRange");

// src/date/utils/getTotalOverlapTimeInSeconds.ts
function getTotalOverlapTimeInSeconds(ranges) {
  var _a, _b, _c, _d;
  let overlapTime = 0;
  const originalRanges = ranges.map((range) => __spreadValues({}, range));
  const outerRanges = ranges.map((range) => __spreadValues({}, range));
  for (let outerIndex = 0; outerIndex < outerRanges.length; outerIndex++) {
    const innerRanges = originalRanges.map((range) => __spreadValues({}, range)).slice(0, outerIndex);
    for (let innerIndex = 0; innerIndex < innerRanges.length; innerIndex++) {
      if (innerIndex === outerIndex) continue;
      const diff = diffDateTimeRange(outerRanges[outerIndex], innerRanges[innerIndex]);
      if (!diff.overlapSeconds) continue;
      if ((_a = diff.range1Diff) == null ? void 0 : _a.length) {
        outerRanges[outerIndex] = (_b = diff.range1Diff) == null ? void 0 : _b[0];
        if (diff.range1Diff.length > 1) {
          outerRanges.push(diff.range1Diff[1]);
        }
      } else {
        outerRanges[outerIndex].endTime = outerRanges[outerIndex].startTime;
        outerRanges[outerIndex].durationSeconds = 0;
      }
      if ((_c = diff.range2Diff) == null ? void 0 : _c.length) {
        innerRanges[innerIndex] = (_d = diff.range2Diff) == null ? void 0 : _d[0];
        if (diff.range2Diff.length > 1) {
          outerRanges.push(diff.range2Diff[1]);
        }
      } else {
        innerRanges[innerIndex].endTime = innerRanges[innerIndex].startTime;
        innerRanges[innerIndex].durationSeconds = 0;
      }
      overlapTime += diff.overlapSeconds;
    }
  }
  return overlapTime;
}
__name(getTotalOverlapTimeInSeconds, "getTotalOverlapTimeInSeconds");

// src/date/utils/getTzFormattedDate.ts
var import_luxon5 = require("luxon");
var { get: getFromCache4, set: setToCache4, reset: resetCache4 } = useCacheFor("getTzFormattedDate");
function getTzFormattedDate(date, timezone) {
  const cachedValue = getFromCache4(date, timezone);
  if (cachedValue) return cachedValue;
  if (import_luxon5.DateTime.isDateTime(date)) {
    const formatted2 = date.toFormat("yyyy-LL-dd");
    setToCache4(date, timezone, formatted2);
    return formatted2;
  }
  const dayjsDate = getTzDayjs(date, timezone);
  const formatted = dayjsDate.format("YYYY-MM-DD");
  setToCache4(date, timezone, formatted);
  return formatted;
}
__name(getTzFormattedDate, "getTzFormattedDate");
getTzFormattedDate.clearCache = resetCache4;

// src/date/utils/getTzFormattedTime.ts
var { get: getFromCache5, set: setToCache5, reset: resetCache5 } = useCacheFor("getTzFormattedTime");
function getTzFormattedTime(date, timezone) {
  const cachedValue = getFromCache5(date, timezone);
  if (cachedValue) return cachedValue;
  const dayjsDate = getTzDayjs(date, timezone);
  const formatted = dayjsDate.format("HH:mm:ss");
  setToCache5(date, timezone, formatted);
  return formatted;
}
__name(getTzFormattedTime, "getTzFormattedTime");
getTzFormattedTime.clearCache = resetCache5;

// src/date/utils/getWeekDay.ts
var import_luxon6 = require("luxon");
function getWeekDay(date, timezone) {
  let dateTime;
  if (!import_luxon6.DateTime.isDateTime(date)) {
    dateTime = getTzDate(date, timezone);
  } else dateTime = date;
  const luxonWeekDay = dateTime.weekday;
  if (luxonWeekDay === 7) return EWeekDay.sunday;
  return luxonWeekDay;
}
__name(getWeekDay, "getWeekDay");

// src/date/utils/isWeekendTime.ts
var { get: getFromCache6, set: setToCache6, reset: resetCache6 } = useCacheFor("isWeekendTime");
var isWeekendTime = /* @__PURE__ */ __name(({ shiftDateTime, weekendSettings }) => {
  var _a;
  const paramsToString = JSON.stringify(weekendSettings);
  const cachedValue = getFromCache6(shiftDateTime, paramsToString);
  if (cachedValue !== void 0) return cachedValue;
  const { days: weekendDays, timeBoundaries: weekendTimeBoundaries } = weekendSettings;
  const shiftDay = shiftDateTime.day();
  const isWeekendDay = weekendDays.includes(shiftDay);
  if (!isWeekendDay) return false;
  const [firstWeekendDay, ...rest] = Array.from(weekendDays);
  const lastWeekendDay = (_a = rest.pop()) != null ? _a : firstWeekendDay;
  const shiftStartTime = getTzFormattedTime(shiftDateTime);
  let result;
  if (lastWeekendDay === firstWeekendDay) result = shiftStartTime >= weekendTimeBoundaries.startTime && shiftStartTime < weekendTimeBoundaries.endTime;
  else if (shiftDay === lastWeekendDay) result = shiftStartTime < weekendTimeBoundaries.endTime;
  else if (shiftDay === firstWeekendDay) result = weekendTimeBoundaries.startTime <= shiftStartTime;
  else result = true;
  setToCache6(shiftDateTime, paramsToString, result);
  return result;
}, "isWeekendTime");
isWeekendTime.clearCache = resetCache6;

// src/date/utils/mergeDateTimeRanges.ts
var import_lodash4 = __toESM(require_lodash());
function mergeDateTimeRanges(ranges, fullStartTime, fullDurationSeconds) {
  var _a, _b;
  if (!(ranges == null ? void 0 : ranges.length)) return {
    fullRangeCount: 0,
    mergedRanges: [],
    totalRangeCount: 0
  };
  const fullRange = __spreadProps(__spreadValues({}, ranges[0]), {
    durationSeconds: fullDurationSeconds,
    endTime: fullStartTime.plus({
      seconds: fullDurationSeconds
    }),
    startTime: fullStartTime
  });
  const combinedFullRanges = [];
  const gaps = [
    __spreadValues({}, fullRange)
  ];
  let remainingFullRanges = [];
  let currentlyAppliedRanges = [];
  let remainingRanges = [
    ...ranges
  ];
  for (const gap of gaps) {
    const updatedRanges = [];
    if (!remainingFullRanges.length) remainingFullRanges = [
      gap
    ];
    for (const range of remainingRanges) {
      const diff = diffDateTimeRange(remainingFullRanges[0], range);
      if (diff.overlapSeconds) {
        currentlyAppliedRanges.push(range);
      }
      if ((_a = diff.range2Diff) == null ? void 0 : _a.length) {
        updatedRanges.push(...diff.range2Diff);
      }
      if ((_b = diff.range1Diff) == null ? void 0 : _b.length) {
        remainingFullRanges.shift();
        remainingFullRanges.push(...diff.range1Diff);
      } else if (remainingFullRanges.length < 2) {
        currentlyAppliedRanges = [];
        remainingFullRanges = [
          __spreadValues({}, fullRange)
        ];
        combinedFullRanges.push(fullRange);
      } else {
        remainingFullRanges.shift();
      }
    }
    if ((0, import_lodash4.isEqual)(updatedRanges, remainingRanges)) {
      continue;
    }
    remainingRanges = updatedRanges;
    if (!updatedRanges.length) break;
    gaps.push(...remainingFullRanges);
  }
  if (remainingFullRanges) {
    remainingRanges.push(...currentlyAppliedRanges);
  }
  let totalRangeCount = combinedFullRanges.length;
  if (remainingRanges.length) {
    const overlapSeconds = getTotalOverlapTimeInSeconds(remainingRanges);
    const adjustedPartialFullRangeCoverage = (0, import_lodash4.sum)(remainingRanges.map((rem) => rem.durationSeconds)) - overlapSeconds;
    const partialFullRangeCoverage = adjustedPartialFullRangeCoverage / fullDurationSeconds;
    totalRangeCount += partialFullRangeCoverage;
  }
  return {
    fullRangeCount: combinedFullRanges.length,
    mergedRanges: [
      ...combinedFullRanges,
      ...remainingRanges
    ],
    totalRangeCount
  };
}
__name(mergeDateTimeRanges, "mergeDateTimeRanges");

// src/date/utils/nextWeekDay.ts
var nextWeekday = /* @__PURE__ */ __name((date, weekDay) => {
  const dateWeekDay = getWeekDay(date);
  const daysToAdd = (7 - dateWeekDay + weekDay) % 7;
  return date.plus({
    day: daysToAdd === 0 ? 7 : daysToAdd
  });
}, "nextWeekday");
var prevWeekday = /* @__PURE__ */ __name((date, weekDay) => {
  const dateWeekDay = getWeekDay(date);
  const daysToSubtract = dateWeekDay > weekDay ? dateWeekDay - weekDay : 7 - weekDay + dateWeekDay;
  return date.minus({
    day: daysToSubtract
  });
}, "prevWeekday");
var endOfWeek = /* @__PURE__ */ __name((date) => {
  if (getWeekDay(date) === EWeekDay.saturday) return date.endOf("day");
  return nextWeekday(date, EWeekDay.saturday).endOf("day");
}, "endOfWeek");
var startOfWeek = /* @__PURE__ */ __name((date) => {
  if (getWeekDay(date) === EWeekDay.sunday) return date.startOf("day");
  return prevWeekday(date, EWeekDay.sunday).startOf("day");
}, "startOfWeek");

// src/date/utils/timeAdd.ts
var import_luxon7 = require("luxon");
var timeAdd = /* @__PURE__ */ __name((time, secondsToAdd) => {
  const formatFrom = time.includes(".") ? "HH:mm:ss.SSS" : "HH:mm:ss";
  const date = import_luxon7.DateTime.fromFormat("01-01-2000 " + time, "dd-MM-yyyy " + formatFrom);
  if (!date.isValid) throw new Error("Invalid time string");
  return date.plus({
    seconds: secondsToAdd
  }).toFormat(formatFrom);
}, "timeAdd");

// src/date/utils/timeInTzToDayjs.ts
var { get: getFromCache7, set: setToCache7, reset: resetCache7 } = useCacheFor("timeInTzToDayjs");
var timeInTzToDayjs = /* @__PURE__ */ __name((date, timezone) => {
  if (!date.endsWith("Z")) date += "Z";
  const valueFromCache = getFromCache7(date, timezone);
  if (valueFromCache) return valueFromCache;
  const dateJs = m7DayJs(date).tz(timezone);
  setToCache7(date, timezone, dateJs);
  return dateJs;
}, "timeInTzToDayjs");
timeInTzToDayjs.clearCache = resetCache7;

// src/date/utils/add24hours.ts
var add24Hours = /* @__PURE__ */ __name((time) => {
  const currentHours = Number(time.split(":")[0]);
  return (currentHours + 24).toString() + time.slice(2);
}, "add24Hours");

// src/date/utils/trimMs.ts
var trimMs = /* @__PURE__ */ __name((time) => time.split(".")[0], "trimMs");

// src/date/utils/timeOverlap.ts
var timeOverlap = /* @__PURE__ */ __name((time1, time2) => {
  let [from1, to1, originalFrom1] = [
    trimMs(time1.from),
    trimMs(time1.to),
    trimMs(time1.originalFrom || time1.from)
  ];
  let [from2, to2, originalFrom2] = [
    trimMs(time2.from),
    trimMs(time2.to),
    trimMs(time2.originalFrom || time2.from)
  ];
  if (originalFrom1 > from1) from1 = add24Hours(from1);
  if (originalFrom2 > from2) from2 = add24Hours(from2);
  if (from1 >= to1) to1 = add24Hours(to1);
  if (from2 >= to2) to2 = add24Hours(to2);
  const [start1, end1, start2, end2] = [
    from1,
    to1,
    from2,
    to2
  ].map((time) => timeStringToDate(time).unix());
  const overlapStart = Math.max(start1, start2);
  const overlapEnd = Math.min(end1, end2);
  const overlapDurationSeconds = Math.max(0, overlapEnd - overlapStart);
  return Math.abs(overlapDurationSeconds);
}, "timeOverlap");
var buildOverlapItem = /* @__PURE__ */ __name(({ originalFrom, from, duration: duration2, timezone }) => {
  const fromTimeString = timeFromAnyDate(from, timezone);
  const originalFromTimeString = originalFrom ? timeFromAnyDate(originalFrom, timezone) : void 0;
  const toTimeString = timeAdd(fromTimeString, duration2);
  return {
    from: trimMs(fromTimeString),
    originalFrom: originalFromTimeString ? trimMs(originalFromTimeString) : void 0,
    to: trimMs(toTimeString)
  };
}, "buildOverlapItem");
var timeFromAnyDate = /* @__PURE__ */ __name((dateOrTime, timezone) => {
  if (typeof dateOrTime === "string" && !dateOrTime.includes("T")) {
    return dateOrTime;
  }
  const date = dateOrTime;
  const tzDate = getTzDate(date, timezone);
  return dateToTimeString(tzDate);
}, "timeFromAnyDate");

// src/date/utils/timeStringToDayjs.ts
var { getOrSet, reset: resetCache8 } = useCacheFor("timeStringToDayjs");
var timeStringToDayjs = /* @__PURE__ */ __name((time, timezone) => getOrSet(time, timezone, () => {
  const [hours, minutes, secondsAndMs] = time.split(":");
  const [seconds, ms] = (secondsAndMs == null ? void 0 : secondsAndMs.split(".")) || [
    0,
    0
  ];
  let result = m7DayJs();
  if (timezone) result = result.tz(timezone);
  result = result.set("hour", Number(hours)).set("minute", Number(minutes)).set("seconds", Number(seconds)).set("milliseconds", Number(ms || "000"));
  return result;
}), "timeStringToDayjs");
timeStringToDayjs.clearCache = resetCache8;

// src/common/utils/isWeekendShift.ts
var isWeekendShift = /* @__PURE__ */ __name(({ date, shiftType, settings }) => {
  if (!date || !shiftType) {
    return false;
  }
  const removeMs = /* @__PURE__ */ __name((time) => time.split(".")[0], "removeMs");
  const dayOfShift = m7DayJs.utc(date).day();
  const isConsideredWeekendDay = settings.weekendDays.includes(dayOfShift);
  if (!isConsideredWeekendDay) return false;
  let isConsideredWeekendHours = true;
  const startTime = removeMs(shiftType.startTime);
  const isFirstDayOfWeekend = settings.weekendDays[0] === dayOfShift;
  isConsideredWeekendHours && (isConsideredWeekendHours = isFirstDayOfWeekend ? startTime >= removeMs(settings.startTime) : true);
  const isLastDayOfWeekend = settings.weekendDays[settings.weekendDays.length - 1] === dayOfShift;
  isConsideredWeekendHours && (isConsideredWeekendHours = isLastDayOfWeekend ? startTime < removeMs(settings.endTime) : true);
  return isConsideredWeekendHours;
}, "isWeekendShift");

// src/dto/_shared/sharedEnums.ts
var ECommunicationMethod = /* @__PURE__ */ function(ECommunicationMethod2) {
  ECommunicationMethod2["sms"] = "sms";
  ECommunicationMethod2["email"] = "email";
  return ECommunicationMethod2;
}({});
var ELoginCommunicationType = /* @__PURE__ */ function(ELoginCommunicationType2) {
  ELoginCommunicationType2["m7Invite"] = "m7-invite";
  ELoginCommunicationType2["passwordReset"] = "password-reset";
  return ELoginCommunicationType2;
}({});

// src/dto/facility/types.ts
(function(Facility2) {
  (function(Config) {
    const unCheckedDefaultValues = {
      data: {
        facilityTimeTargetLevelsByStaff: {}
      },
      settings: {
        houseViewTimeRanges: [],
        showSixWeekViewTotalCount: false,
        useExternalUserIntegration: false,
        useHouseViewAllTab: false
      }
    };
    const checkDefaultValues = /* @__PURE__ */ __name((values) => values, "checkDefaultValues");
    Config.defaultValues = checkDefaultValues(unCheckedDefaultValues);
  })(Facility2.Config || (Facility2.Config = {}));
})(Facility || (Facility = {}));
var Facility;

// src/dto/permission/types.ts
var EPermissionVerbs = /* @__PURE__ */ function(EPermissionVerbs2) {
  EPermissionVerbs2["readOnly"] = "readOnly";
  EPermissionVerbs2["manage"] = "manage";
  return EPermissionVerbs2;
}({});
var EUnitPermissionAreas = /* @__PURE__ */ function(EUnitPermissionAreas2) {
  EUnitPermissionAreas2["scheduleGrid"] = "scheduleGrid";
  EUnitPermissionAreas2["fairness"] = "fairness";
  EUnitPermissionAreas2["approvals"] = "approvals";
  EUnitPermissionAreas2["staffRoster"] = "staffRoster";
  EUnitPermissionAreas2["dailyReport"] = "dailyReport";
  EUnitPermissionAreas2["openShifts"] = "openShifts";
  EUnitPermissionAreas2["unitSettings"] = "unitSettings";
  EUnitPermissionAreas2["houseView"] = "houseView";
  EUnitPermissionAreas2["schedulerRoster"] = "schedulerRoster";
  EUnitPermissionAreas2["shiftReports"] = "shiftReports";
  return EUnitPermissionAreas2;
}({});

// src/dto/preferenceRequirementRuleSet/types.ts
(function(PreferenceRequirementRuleSet2) {
  (function(ERuleSetOperator) {
    ERuleSetOperator["and"] = "AND";
    ERuleSetOperator["or"] = "OR";
  })(PreferenceRequirementRuleSet2.ERuleSetOperator || (PreferenceRequirementRuleSet2.ERuleSetOperator = {}));
  (function(EFrequencyStep) {
    EFrequencyStep["weekly"] = "weekly";
    EFrequencyStep["payPeriod"] = "payPeriod";
    EFrequencyStep["schedule"] = "schedule";
  })(PreferenceRequirementRuleSet2.EFrequencyStep || (PreferenceRequirementRuleSet2.EFrequencyStep = {}));
  (function(EFrequencyOperator) {
    EFrequencyOperator["eq"] = "eq";
    EFrequencyOperator["gt"] = "gt";
    EFrequencyOperator["gte"] = "gte";
    EFrequencyOperator["lt"] = "lt";
    EFrequencyOperator["lte"] = "lte";
  })(PreferenceRequirementRuleSet2.EFrequencyOperator || (PreferenceRequirementRuleSet2.EFrequencyOperator = {}));
  (function(ETargetType) {
    ETargetType["shiftCount"] = "shiftCount";
    ETargetType["hours"] = "hours";
  })(PreferenceRequirementRuleSet2.ETargetType || (PreferenceRequirementRuleSet2.ETargetType = {}));
})(PreferenceRequirementRuleSet || (PreferenceRequirementRuleSet = {}));
var PreferenceRequirementRuleSet;

// src/dto/role/types.ts
var import_lodash5 = __toESM(require_lodash());
(function(Role2) {
  (function(EType) {
    EType["admin"] = "admin";
    EType["scheduler"] = "scheduler";
    EType["staff"] = "staff";
    EType["kiosk"] = "kiosk";
  })(Role2.EType || (Role2.EType = {}));
  Role2.NameById = {
    1: "admin",
    2: "scheduler",
    3: "staff",
    4: "kiosk"
  };
  Role2.IdByName = (0, import_lodash5.entries)(Role2.NameById).reduce((acc, [id, name]) => {
    acc[name] = Number(id);
    return acc;
  }, {});
})(Role || (Role = {}));
var Role;

// src/dto/schedule/types.ts
(function(Schedule2) {
  (function(EStatus) {
    EStatus["collecting"] = "sent_out";
    EStatus["balancing"] = "in_review";
    EStatus["published"] = "published";
    EStatus["completed"] = "completed";
    EStatus["current"] = "current";
    EStatus["future"] = "future";
  })(Schedule2.EStatus || (Schedule2.EStatus = {}));
})(Schedule || (Schedule = {}));
var Schedule;

// src/dto/shiftType/types.ts
(function(ShiftType2) {
  (function(EDisplayableFor) {
    EDisplayableFor["schedulerGrid"] = "schedulerGrid";
    EDisplayableFor["dailyReport"] = "dailyReport";
    EDisplayableFor["schedulerGridQuickAction"] = "schedulerGridQuickAction";
  })(ShiftType2.EDisplayableFor || (ShiftType2.EDisplayableFor = {}));
})(ShiftType || (ShiftType = {}));
var ShiftType;

// src/dto/staffDetails/types.ts
(function(StaffDetails2) {
  (function(EEmploymentType) {
    EEmploymentType["fullTime"] = "Full time";
    EEmploymentType["partTime"] = "Part time";
    EEmploymentType["perDiem"] = "Per diem";
    EEmploymentType["travelStaff"] = "Travel staff";
    EEmploymentType["inHouseContract"] = "In-house contract";
    EEmploymentType["flex"] = "Flex";
    EEmploymentType["contract"] = "Contract";
  })(StaffDetails2.EEmploymentType || (StaffDetails2.EEmploymentType = {}));
  (function(EPreferredWorkingHours) {
    EPreferredWorkingHours["day7A7P"] = "day7A7P";
    EPreferredWorkingHours["night7P7A"] = "night7P7A";
  })(StaffDetails2.EPreferredWorkingHours || (StaffDetails2.EPreferredWorkingHours = {}));
  (function(EStaffStatus) {
    EStaffStatus["active"] = "active";
    EStaffStatus["inactive"] = "inactive";
  })(StaffDetails2.EStaffStatus || (StaffDetails2.EStaffStatus = {}));
})(StaffDetails || (StaffDetails = {}));
var StaffDetails;

// src/dto/staffShift/types.ts
(function(StaffShift2) {
  (function(EShiftStatus) {
    EShiftStatus["calledIn"] = "Called In";
    EShiftStatus["onCall"] = "On Call";
    EShiftStatus["cancelled"] = "Cancelled";
    EShiftStatus["floated"] = "Floated";
    EShiftStatus["flexed"] = "Flexed";
    EShiftStatus["requestOnCall"] = "On Call (ROC)";
    EShiftStatus["onCall4h"] = "On Call (< 4H)";
  })(StaffShift2.EShiftStatus || (StaffShift2.EShiftStatus = {}));
  (function(EScheduleType) {
    EScheduleType["m7"] = "m7";
    EScheduleType["draft"] = "draft";
  })(StaffShift2.EScheduleType || (StaffShift2.EScheduleType = {}));
  (function(EStatus) {
    EStatus["calledIn"] = "Called In";
    EStatus["onCall"] = "On Call";
    EStatus["cancelled"] = "Cancelled";
    EStatus["floated"] = "Floated";
    EStatus["flexed"] = "Flexed";
    EStatus["requestOnCall"] = "On Call (ROC)";
    EStatus["onCall4h"] = "On Call (< 4H)";
  })(StaffShift2.EStatus || (StaffShift2.EStatus = {}));
  (function(EReportColumnForCsv) {
    EReportColumnForCsv["date"] = "date";
    EReportColumnForCsv["firstName"] = "firstName";
    EReportColumnForCsv["lastName"] = "lastName";
    EReportColumnForCsv["fullName"] = "fullName";
    EReportColumnForCsv["email"] = "email";
    EReportColumnForCsv["staffStatus"] = "staffStatus";
    EReportColumnForCsv["homeUnit"] = "homeUnit";
    EReportColumnForCsv["shiftStatus"] = "shiftStatus";
    EReportColumnForCsv["note"] = "note";
    EReportColumnForCsv["shiftUnit"] = "shiftUnit";
    EReportColumnForCsv["shiftType"] = "shiftType";
    EReportColumnForCsv["shiftTypeKey"] = "shiftTypeKey";
    EReportColumnForCsv["shiftStartTime"] = "shiftStartTime";
    EReportColumnForCsv["shiftEndTime"] = "shiftEndTime";
    EReportColumnForCsv["shiftStartDateTime"] = "shiftStartDateTime";
    EReportColumnForCsv["shiftEndDateTime"] = "shiftEndDateTime";
    EReportColumnForCsv["shiftDurationInHours"] = "shiftDurationInHours";
    EReportColumnForCsv["shiftAttributeKeys"] = "shiftAttributeKeys";
    EReportColumnForCsv["shiftAttributeTitles"] = "shiftAttributeTitles";
    EReportColumnForCsv["shiftIncentiveLevel"] = "shiftIncentiveLevel";
    EReportColumnForCsv["staffCategory"] = "staffCategory";
  })(StaffShift2.EReportColumnForCsv || (StaffShift2.EReportColumnForCsv = {}));
})(StaffShift || (StaffShift = {}));
var StaffShift;

// src/dto/unit/types.ts
(function(Unit2) {
  (function(Config) {
    (function(EHVTimeRange) {
      EHVTimeRange["all"] = "all";
      EHVTimeRange["day7A7P"] = "day7A7P";
      EHVTimeRange["night7P7A"] = "night7P7A";
    })(Config.EHVTimeRange || (Config.EHVTimeRange = {}));
    (function(EHVEmploymentTypeFilter) {
      EHVEmploymentTypeFilter["perDiem"] = "Per diem";
      EHVEmploymentTypeFilter["travelStaff"] = "Travel staff";
      EHVEmploymentTypeFilter["other"] = "Other";
    })(Config.EHVEmploymentTypeFilter || (Config.EHVEmploymentTypeFilter = {}));
    const unCheckedDefaultValues = {
      data: {
        messageToSchedulerUsers: "",
        messageToStaffUsers: "",
        messageToUsers: "",
        shiftStatusData: {
          [StaffShift.EShiftStatus.calledIn]: {
            label: "Called In",
            showStatusForUnit: true
          },
          [StaffShift.EShiftStatus.floated]: {
            label: "Floated",
            showStatusForUnit: true
          },
          [StaffShift.EShiftStatus.onCall]: {
            label: "On Call",
            showStatusForUnit: true
          },
          [StaffShift.EShiftStatus.cancelled]: {
            label: "Cancelled",
            showStatusForUnit: true
          },
          [StaffShift.EShiftStatus.flexed]: {
            label: "Flexed",
            showStatusForUnit: false
          },
          [StaffShift.EShiftStatus.requestOnCall]: {
            label: "On Call (ROC)",
            showStatusForUnit: false
          },
          [StaffShift.EShiftStatus.onCall4h]: {
            label: "On Call (< 4H)",
            showStatusForUnit: false
          }
        },
        shiftStatusLabels: {
          [StaffShift.EShiftStatus.calledIn]: "Called In",
          [StaffShift.EShiftStatus.floated]: "Floated",
          [StaffShift.EShiftStatus.onCall]: "On Call",
          [StaffShift.EShiftStatus.cancelled]: "Cancelled",
          [StaffShift.EShiftStatus.flexed]: "Flexed",
          [StaffShift.EShiftStatus.requestOnCall]: "On Call (ROC)",
          [StaffShift.EShiftStatus.onCall4h]: "On Call (< 4H)"
        },
        timeTargetLevels: {
          Nurse: [],
          Tech: []
        }
      },
      defaults: {
        houseView: {
          filters: {
            employmentTypes: [],
            hideOvertime: false,
            modalIsOpen: false,
            preferredWorkingHours: [],
            shiftTypeKeys: [],
            staffCategories: [],
            unit: []
          }
        },
        schedulerGrid: {
          filters: {
            attributes: [],
            showAssigned: false,
            showEligible: true,
            showOpenShiftsSummaryRows: true,
            showShiftTargetLevels: true,
            showTargetLevel: true,
            showTimeTargetLevels: false
          }
        }
      },
      settings: {
        notifications: {
          skipStaffNotificationOnOpsIfNotReady: true
        },
        schedulerApp: {
          autoApproveOpenShifts: false,
          showAutoApproveOpenShifts: false,
          showContactInfoInDailyReport: false,
          sortStaffByPrimaryShiftTypeInSchedulerGrid: false,
          unitGroupName: void 0,
          useAutoBalance: true,
          useFlexedUpdate: false,
          useOnCall4h: false,
          useRequestOnCall: false,
          useStaffTypeSummaryRows: true
        },
        staffApp: {
          allowSwapShiftsPastOneWeek: false,
          showAllDropShifts: false
        },
        weekendTimeBoundaries: {
          endTime: "23:59:59",
          startTime: "07:00:00"
        }
      }
    };
    const checkDefaultValues = /* @__PURE__ */ __name((values) => values, "checkDefaultValues");
    Config.defaultValues = checkDefaultValues(unCheckedDefaultValues);
  })(Unit2.Config || (Unit2.Config = {}));
})(Unit || (Unit = {}));
var Unit;

// src/dto/user/types.ts
(function(User2) {
  (function(EReasonForSuspension) {
    EReasonForSuspension["terminated"] = "Terminated";
    EReasonForSuspension["resigned"] = "Resigned";
    EReasonForSuspension["createdInError"] = "Created in error";
    EReasonForSuspension["other"] = "Other";
  })(User2.EReasonForSuspension || (User2.EReasonForSuspension = {}));
  (function(ERole) {
    ERole["admin"] = "admin";
    ERole["scheduler"] = "scheduler";
    ERole["staff"] = "staff";
    ERole["kiosk"] = "kiosk";
  })(User2.ERole || (User2.ERole = {}));
  (function(EOnboardingStatus) {
    EOnboardingStatus["pending"] = "pending";
    EOnboardingStatus["completed"] = "completed";
  })(User2.EOnboardingStatus || (User2.EOnboardingStatus = {}));
})(User || (User = {}));
var User;

// src/featureFlags/types.ts
(function(FeatureFlags2) {
  (function(EKeys) {
    EKeys["platformUpdatesInProgress"] = "platform-updates-in-progress";
    EKeys["disableTypeToConfirmModals"] = "disable-type-to-confirm-modals";
    EKeys["showFlagFab"] = "show-flag-fab";
    EKeys["hvPositionAsTab"] = "hv-position-as-tab";
    EKeys["showUserFlow"] = "show-user-flow";
    EKeys["adminActAsAnyUser"] = "admin-act-as-any-user";
    EKeys["staffJobOnShift"] = "staff-job-on-shift";
    EKeys["appConfigV2"] = "app-config-v2";
    EKeys["staffShiftSaveOrchestrator"] = "staff-shift-save-orchestrator";
    EKeys["openShiftV2"] = "open-shift-v2";
    EKeys["houseViewAllTab"] = "house-view-all-tab";
    EKeys["workdayIntegration"] = "workday-integration";
    EKeys["useOneWeekView"] = "use-one-week-view";
    EKeys["useNewSingleDayMobileView"] = "use-new-single-day-mobile-view";
    EKeys["showChangeReportSidebar"] = "show-change-report-sidebar";
    EKeys["staffTypeTargetLevelRowsSchedulerGrid"] = "staff-type-target-level-rRemove FF ticket: https://linear.app/m7-health/issue/M7-5597ows-scheduler-grid";
    EKeys["schedulerGridVisibilityIntoPreferencesAndRequirementsImprovements"] = "scheduler-grid-visibility-into-preferences-and-requirements-improvements";
    EKeys["supportingNewDataHierarchy"] = "supporting-new-data-hierarchy";
    EKeys["preferencesLinkedToTemplates"] = "preferences-linked-to-templates";
    EKeys["timeOffRequestDeadlines"] = "time-off-request-deadlines";
    EKeys["ochsnerKronosIntegration"] = "ochsner-integration";
    EKeys["allowSwapRequestsWithDifferentShiftTypes"] = "allow-swap-requests-with-different-shift-types";
    EKeys["questionnairesV1"] = "questionnaires-v1";
    EKeys["useHouseviewUnitConfigDefaultFilters"] = "use-houseview-unit-config-default-filters";
    EKeys["staffingTargetLevelModalQueuesToInputPatientCount"] = "staffing-target-level-modal-queues-to-input-patient-count";
    EKeys["holidaySchedule"] = "holiday-schedule";
    EKeys["schedulerStaffProfileExtraFeatures"] = "scheduler-staff-profile-extra-features";
  })(FeatureFlags2.EKeys || (FeatureFlags2.EKeys = {}));
})(FeatureFlags || (FeatureFlags = {}));
var FeatureFlags;

// src/preferenceRequirement/engine/periodsBuilders/payPeriods.ts
var _PayPeriods = class _PayPeriods {
  constructor(schedule) {
    __publicField(this, "schedule");
    __publicField(this, "payPeriodPerDate");
    __publicField(this, "payPeriods");
    this.schedule = schedule;
    this.payPeriodPerDate = {};
    this.payPeriods = this.buildPayPeriods();
  }
  /**
  * @param dayjsDate
  * @returns Pay period index of the given date within the schedule
  */
  getPayPeriodForDate(dayjsDate) {
    var _a;
    const isoKey = toISO(dayjsDate);
    return (_a = this.payPeriodPerDate)[isoKey] || (_a[isoKey] = (() => {
      const payPeriod = this.payPeriods.find((period) => dayjsDate.isBetween(period.from, period.to, "day", "[]"));
      return payPeriod;
    })());
  }
  /**
  * @description Builds pay periods for a schedule, assuming a 2-week pay period
  *   starting from the schedule's start time.
  * @param schedule
  * @returns an array of pay periods
  */
  buildPayPeriods() {
    let starts = getTzDayjs(this.schedule.startTime, this.schedule.timezone);
    const ends = getTzDayjs(this.schedule.endTime, this.schedule.timezone);
    const results = [];
    let index = 0;
    while (DateCmp.isBefore(starts.startOf("day"), ends.startOf("day"))) {
      let complete = true;
      let to;
      if (DateCmp.isBefore(starts.startOf("week"), starts)) complete = false;
      if (!complete) to = starts.endOf("week");
      else to = starts.addInTz(8, "days").endOf("week");
      if (DateCmp.isAfter(to, ends)) {
        to = ends;
        complete = false;
      }
      results.push({
        complete,
        from: starts,
        to,
        value: index.toString()
      });
      index++;
      starts = to.addInTz(12, "hours").startOf("day");
      if (index >= 500) throw new Error("Pay periods looped too many times");
    }
    return results;
  }
};
__name(_PayPeriods, "PayPeriods");
var PayPeriods = _PayPeriods;

// src/preferenceRequirement/engine/periodsBuilders/weekPeriods.ts
var _WeekPeriods = class _WeekPeriods {
  constructor(schedule) {
    __publicField(this, "schedule");
    __publicField(this, "weekPeriodPerDate");
    __publicField(this, "weekPeriods");
    this.schedule = schedule;
    this.weekPeriodPerDate = {};
    this.weekPeriods = this.buildWeekPeriods();
  }
  /**
  * @param dayjsDate
  * @returns Week index of the given date within the schedule
  */
  getWeekForDate(dayjsDate) {
    var _a;
    const isoKey = toISO(dayjsDate);
    const week = dayjsDate.week().toString();
    return (_a = this.weekPeriodPerDate)[isoKey] || (_a[isoKey] = (() => {
      const weekPeriod = this.weekPeriods.find((period) => week === period.value);
      return weekPeriod;
    })());
  }
  /**
  * @description Builds week periods for a schedule, assuming a 1-week period
  *   starting from the schedule's start time.
  * @param schedule
  * @returns an array of pay periods
  */
  buildWeekPeriods() {
    let starts = getTzDayjs(this.schedule.startTime, this.schedule.timezone);
    const ends = getTzDayjs(this.schedule.endTime, this.schedule.timezone);
    const results = [];
    let index = 0;
    while (DateCmp.isBefore(starts.startOf("day"), ends.startOf("day"))) {
      index++;
      let complete = true;
      if (DateCmp.isBefore(starts.startOf("week"), starts)) complete = false;
      const to = starts.endOf("week");
      if (DateCmp.isAfter(to, ends)) complete = false;
      results.push({
        complete,
        from: starts,
        to,
        value: starts.week().toString()
      });
      starts = to.addInTz(12, "hours").startOf("day");
      if (index >= 500) throw new Error("Week periods looped too many times");
    }
    return results;
  }
};
__name(_WeekPeriods, "WeekPeriods");
var WeekPeriods = _WeekPeriods;

// src/preferenceRequirement/engine/types.ts
(function(RuleSetChecks2) {
  RuleSetChecks2.Periods = {
    PayPeriods,
    WeekPeriods
  };
})(RuleSetChecks || (RuleSetChecks = {}));
var RuleSetChecks;

// src/preferenceRequirement/engine/main.ts
var import_lodash7 = __toESM(require_lodash());

// src/preferenceRequirement/engine/evaluator/rule.ts
var import_lodash6 = __toESM(require_lodash());
var _Rule = class _Rule {
  constructor(rule, evaluator) {
    __publicField(this, "rule");
    __publicField(this, "evaluator");
    this.rule = rule;
    this.evaluator = evaluator;
  }
  check(itemsToCheck, scheduleDays) {
    const { frequencyValueMin, frequencyValueMax, targetShiftTypeKeys, targetIsWeekend } = this.rule;
    const scheduleDaysByStep = (0, import_lodash6.groupBy)(scheduleDays, (scheduleDay) => {
      var _a;
      return ((_a = scheduleDay.steps[this.rule.frequencyStep]) == null ? void 0 : _a.value) || "";
    });
    const availableSteps = (0, import_lodash6.uniqBy)((0, import_lodash6.map)(scheduleDays, (scheduleDay) => scheduleDay.steps[this.rule.frequencyStep]), "value");
    const itemsByStep = (0, import_lodash6.groupBy)(itemsToCheck, (item) => item.steps[this.rule.frequencyStep]);
    const checks = [];
    availableSteps.forEach((fullStep) => {
      if (!fullStep) return;
      const step = fullStep.value;
      const filteredItems = (0, import_lodash6.filter)(itemsByStep[step], (item) => {
        if (!targetShiftTypeKeys.includes(item.shiftTypeKey)) return false;
        if (targetIsWeekend && !item.isWeekend) return false;
        return true;
      });
      const weight = (0, import_lodash6.sumBy)(filteredItems, (item) => {
        return this.rule.targetType === PreferenceRequirementRuleSet.ETargetType.hours ? item.weight.minutes / 60 : item.weight.shiftCount;
      });
      const isValid = !fullStep.complete ? void 0 : weight >= frequencyValueMin && weight <= frequencyValueMax;
      const rangeStatus = !fullStep.complete ? void 0 : isValid ? "within" : weight < frequencyValueMin ? "under" : "over";
      checks.push({
        frequency: {
          key: this.rule.frequencyStep,
          range: {
            from: scheduleDaysByStep[step][0].dayjsDate,
            to: scheduleDaysByStep[step][scheduleDaysByStep[step].length - 1].dayjsDate
          },
          value: step
        },
        isValid,
        matchingItems: filteredItems,
        providedItems: itemsByStep[step],
        rangeStatus,
        reason: this.formatReason(step, isValid, weight),
        value: weight
      });
    });
    return checks;
  }
  // Returns a string representation of the shift types and weekend status
  shiftTypesString() {
    const weekend = this.rule.targetIsWeekend;
    return `(${this.rule.targetShiftTypeKeys.map((key) => {
      var _a;
      return ((_a = this.evaluator.shiftTypes[key]) == null ? void 0 : _a.name) || key;
    }).join(", ")})${weekend ? " weekend" : ""}`;
  }
  // Human format for the reason of the check result
  formatReason(stepIndex, isValid, weight) {
    const { frequencyValueMin, frequencyValueMax } = this.rule;
    const ruleTypeLabel = ruleTypeLabels[this.rule.frequencyStep](stepIndex);
    const rangeStatus = isValid ? "within" : weight < frequencyValueMin ? "under" : "over";
    return [
      ruleTypeLabel,
      "has",
      (0, import_lodash6.round)(weight, 1),
      this.shiftTypesString(),
      targetTypeLabels[this.rule.targetType] + ",",
      rangeStatus,
      isValid === void 0 ? "and the range is" : "the range of",
      `${frequencyValueMin} to ${frequencyValueMax}`,
      isValid === void 0 ? "but the observing period overlaps multiple schedules" : ""
    ].join(" ").trimEnd() + ".";
  }
};
__name(_Rule, "Rule");
var Rule = _Rule;
var ruleTypeLabels = {
  payPeriod: /* @__PURE__ */ __name((payPeriodIndex) => `Pay Period ${Number(payPeriodIndex) + 1})`, "payPeriod"),
  schedule: /* @__PURE__ */ __name(() => "Schedule", "schedule"),
  weekly: /* @__PURE__ */ __name((weekNumberInYear) => `Week ${weekNumberInYear}`, "weekly")
};
var targetTypeLabels = {
  [PreferenceRequirementRuleSet.ETargetType.hours]: "hours",
  [PreferenceRequirementRuleSet.ETargetType.shiftCount]: "shifts"
};

// src/preferenceRequirement/engine/evaluator/evaluator.ts
var _Evaluator = class _Evaluator {
  constructor({ periods, ruleSet, weekendSettings, schedule, shiftTypes, timezone }) {
    // Constructor properties
    __publicField(this, "ruleSet");
    __publicField(this, "weekendSettings");
    __publicField(this, "schedule");
    __publicField(this, "shiftTypes");
    __publicField(this, "periods");
    // Calculated properties
    __publicField(this, "timezone");
    __publicField(this, "scheduleDays");
    this.periods = periods;
    this.ruleSet = ruleSet;
    this.weekendSettings = weekendSettings;
    this.schedule = schedule;
    this.shiftTypes = shiftTypes;
    this.timezone = timezone;
    this.scheduleDays = this.buildScheduleDays();
  }
  runChecks(itemsToCheck) {
    const validityCheckResults = {
      [this.ruleSet.id]: {
        checks: {},
        isValid: true
      }
    };
    const ruleSetCheckResults = validityCheckResults[this.ruleSet.id].checks;
    this.ruleSet.preferenceRequirementRules.forEach((rule) => {
      const ruleChecker = new Rule(rule, this);
      ruleSetCheckResults[rule.id] = ruleChecker.check(itemsToCheck, this.scheduleDays);
    });
    this.computeValidityCheckResults(validityCheckResults);
    return validityCheckResults;
  }
  buildScheduleDays() {
    const [fromYyyyMmDd, toYyyyMmDd] = [
      this.schedule.startDay,
      this.schedule.endDay
    ];
    const [fromDayjs, toDayjs] = [
      getTzDayjs(fromYyyyMmDd, this.timezone),
      getTzDayjs(toYyyyMmDd, this.timezone)
    ];
    const days = [];
    for (let day = fromDayjs; day <= toDayjs; day = getTzDayjs(day, this.timezone).addInTz(1, "day")) {
      const formattedDay = day.format("YYYY-MM-DD");
      days.push({
        dateYyyyMmDd: formattedDay,
        dayjsDate: day,
        scheduleId: this.schedule.id,
        steps: {
          payPeriod: this.periods.payPeriods.getPayPeriodForDate(day),
          schedule: {
            complete: true,
            from: fromDayjs,
            to: toDayjs,
            value: this.schedule.id
          },
          weekly: this.periods.weekPeriods.getWeekForDate(day)
        }
      });
    }
    return days;
  }
  /**
  * Checks overall validity of the rule set
  *  - if empty results: valid
  *  - if at least one invalid: invalid
  *  - if no invalid and at least one valid: valid
  *  - else undefined (some results, but no valid nor invalid results)
  *
  * An undefined invididual result  can happen when a period is not complete
  *  with a per/week rule and a schedule that starts in the middle of a week.
  * In that case the first partial week will not have a valid or invalid result.
  *
  * @param validityCheckResults
  */
  computeValidityCheckResults(validityCheckResults) {
    const ruleSetCheckResults = validityCheckResults[this.ruleSet.id].checks;
    const noInvalid = Object.values(ruleSetCheckResults).every((checkResult) => checkResult.every((result) => result.isValid !== false));
    const atLeastOneValid = Object.values(ruleSetCheckResults).some((checkResult) => checkResult.some((result) => result.isValid === true));
    const emptyResults = Object.values(ruleSetCheckResults).length === 0;
    let computedResult = void 0;
    if (noInvalid && atLeastOneValid || emptyResults) computedResult = true;
    else if (!noInvalid) computedResult = false;
    validityCheckResults[this.ruleSet.id].isValid = computedResult;
  }
};
__name(_Evaluator, "Evaluator");
var Evaluator = _Evaluator;

// src/preferenceRequirement/engine/helpers.ts
var buildWeekendSettings = /* @__PURE__ */ __name((unit) => {
  var _a, _b;
  const weekendDefaults = Unit.Config.defaultValues.settings.weekendTimeBoundaries;
  const weekendConfig = (_b = (_a = unit.configuration) == null ? void 0 : _a.settings) == null ? void 0 : _b.weekendTimeBoundaries;
  return {
    days: unit.weekendDays,
    timeBoundaries: {
      endTime: (weekendConfig == null ? void 0 : weekendConfig.endTime) || weekendDefaults.endTime,
      startTime: (weekendConfig == null ? void 0 : weekendConfig.startTime) || weekendDefaults.startTime
    }
  };
}, "buildWeekendSettings");

// src/preferenceRequirement/engine/main.ts
var _PreferenceRequirementRuleSetEngine = class _PreferenceRequirementRuleSetEngine {
  constructor(params) {
    __publicField(this, "VERSION", _PreferenceRequirementRuleSetEngine.VERSION);
    __publicField(this, "ruleSet");
    __publicField(this, "weekendSettings");
    __publicField(this, "timezone");
    __publicField(this, "schedule");
    __publicField(this, "shiftTypes");
    __publicField(this, "evaluator");
    __publicField(this, "periods");
    this.ruleSet = params.ruleSet;
    this.weekendSettings = buildWeekendSettings(params.unit);
    this.timezone = params.unit.timezone;
    this.schedule = params.schedule;
    this.shiftTypes = (0, import_lodash7.keyBy)(params.shiftTypes, "key");
    this.periods = {
      payPeriods: new PayPeriods(this.schedule),
      weekPeriods: new WeekPeriods(this.schedule)
    };
    this.evaluator = new Evaluator({
      periods: this.periods,
      ruleSet: this.ruleSet,
      schedule: this.schedule,
      shiftTypes: this.shiftTypes,
      timezone: this.timezone,
      weekendSettings: this.weekendSettings
    });
  }
  evaluate({ preferenceRequests, staffShifts, verbose = false }) {
    if (verbose)
      console.log("Evaluating preferences against rule set", {
        preferences: preferenceRequests,
        ruleSet: this.ruleSet,
        schedule: this.schedule,
        shiftTypes: this.shiftTypes,
        staffShifts
      });
    let itemsToEvaluate;
    if (staffShifts) itemsToEvaluate = this.buildShiftItems(staffShifts);
    else itemsToEvaluate = this.buildPreferenceItems(preferenceRequests);
    return this.evaluator.runChecks(itemsToEvaluate);
  }
  // Transform preference requests into items that can be checked against the rules
  buildPreferenceItems(preferenceRequests) {
    const items = preferenceRequests.map((preferenceRequest) => {
      const shiftType = this.shiftTypes[preferenceRequest.shiftTypeKey];
      if (!shiftType) return;
      return this.buildItem({
        date: {
          time: shiftType.startTime,
          yyyyMmDd: preferenceRequest.date
        },
        item: preferenceRequest,
        type: "preference",
        weight: {
          minutes: shiftType.durationSeconds / 60,
          shiftCount: 1
        }
      });
    });
    return (0, import_lodash7.compact)(items);
  }
  // Transform staff shifts into items that can be checked against the rules
  buildShiftItems(staffShifts) {
    const items = staffShifts.map((staffShift) => {
      const shiftType = this.shiftTypes[staffShift.shiftTypeKey];
      if (!shiftType) return;
      const dateYyyyMmDd = getTzFormattedDate(staffShift.date, this.timezone);
      const duration2 = staffShift.customDuration || shiftType.durationSeconds;
      return this.buildItem({
        date: {
          add24hours: staffShift.customStartTime && staffShift.customStartTime < shiftType.startTime,
          time: staffShift.customStartTime || shiftType.startTime,
          yyyyMmDd: dateYyyyMmDd
        },
        item: staffShift,
        type: "staffShift",
        weight: {
          minutes: duration2 / 60,
          shiftCount: duration2 / shiftType.durationSeconds
        }
      });
    });
    return (0, import_lodash7.compact)(items);
  }
  buildItem({ date, item, type, weight }) {
    var _a, _b;
    const [fromYyyyMmDd, toYyyyMmDd] = [
      this.schedule.startDay,
      this.schedule.endDay
    ];
    if (date.yyyyMmDd < fromYyyyMmDd || date.yyyyMmDd > toYyyyMmDd) return;
    const [hour, minute, second, _maybeMs] = date.time.split(":");
    if (!hour || !minute || !second) throw new Error("Invalid time string");
    const dayjsDate = getTzDayjs(`${date.yyyyMmDd}T${hour}:${minute}:${second}`, this.timezone);
    if (date.add24hours) dayjsDate.addInTz(1, "day");
    return {
      dateYyyyMmDd: date.yyyyMmDd,
      dayjsDate,
      id: item.id,
      isWeekend: isWeekendTime({
        shiftDateTime: dayjsDate,
        weekendSettings: this.weekendSettings
      }),
      scheduleId: this.schedule.id,
      shiftTypeKey: item.shiftTypeKey,
      steps: {
        payPeriod: ((_a = this.periods.payPeriods.getPayPeriodForDate(dayjsDate)) == null ? void 0 : _a.value) || "",
        schedule: this.schedule.id,
        weekly: ((_b = this.periods.weekPeriods.getWeekForDate(dayjsDate)) == null ? void 0 : _b.value) || ""
      },
      type,
      weight
    };
  }
};
__name(_PreferenceRequirementRuleSetEngine, "PreferenceRequirementRuleSetEngine");
__publicField(_PreferenceRequirementRuleSetEngine, "VERSION", "0.0.3");
var PreferenceRequirementRuleSetEngine = _PreferenceRequirementRuleSetEngine;

// src/schedule/utils/getShiftRange.ts
var getShiftRangeCache = useCacheFor("getShiftRange");
function getShiftRange(date, shiftTypeStartTime, shiftTypeDuration, shift) {
  var _a, _b;
  const startTime = (_a = shift == null ? void 0 : shift.customStartTime) != null ? _a : shiftTypeStartTime;
  const duration2 = (_b = shift == null ? void 0 : shift.customDuration) != null ? _b : shiftTypeDuration;
  return getShiftRangeCache.getOrSet(date, {
    customDuration: shift == null ? void 0 : shift.customDuration,
    customStartTime: shift == null ? void 0 : shift.customStartTime,
    duration: duration2,
    startTime
  }, () => {
    let partialStartDateTime = dateTimeAndTimeStringToDateTime(date, startTime);
    if ((shift == null ? void 0 : shift.customStartTime) && (shift == null ? void 0 : shift.customStartTime) < shiftTypeStartTime) {
      partialStartDateTime = partialStartDateTime.plus({
        days: 1
      });
    }
    let partialEndDateTime = partialStartDateTime.plus({
      seconds: duration2
    });
    if (partialStartDateTime.offset !== partialEndDateTime.offset) {
      partialEndDateTime = partialEndDateTime.minus({
        minutes: partialEndDateTime.offset - partialStartDateTime.offset
      });
    }
    return {
      durationSeconds: partialEndDateTime.diff(partialStartDateTime, "seconds").seconds,
      endTime: partialEndDateTime,
      shiftTypeKey: shift == null ? void 0 : shift.shiftTypeKey,
      startTime: partialStartDateTime
    };
  });
}
__name(getShiftRange, "getShiftRange");
getShiftRange.cache = getShiftRangeCache;

// src/schedule/utils/findScheduleDateGaps.ts
function findScheduleDateGaps(date, shiftType, staffShifts, targetLevel, staffCategoryKey) {
  const dateShiftTypeGaps = [];
  const shiftTypeKey = shiftType.key;
  const fullOverages = [];
  const fullShifts = staffShifts == null ? void 0 : staffShifts.filter((shift) => !shift.customDuration && !shift.customStartTime);
  const { startTime: shiftStartDateTime, endTime: shiftTypeEndDateTime } = getShiftRange(date, shiftType.startTime, shiftType.durationSeconds);
  for (let i = 0; i < targetLevel - fullShifts.length; i++) {
    dateShiftTypeGaps.push({
      durationSeconds: shiftType.durationSeconds,
      endTime: shiftTypeEndDateTime,
      shiftTypeKey,
      staffCategoryKey,
      startTime: shiftStartDateTime
    });
  }
  if ((fullShifts == null ? void 0 : fullShifts.length) >= targetLevel) {
    for (let i = 0; i < fullShifts.length - targetLevel; i++) {
      fullOverages.push({
        durationSeconds: shiftType.durationSeconds,
        endTime: shiftTypeEndDateTime,
        shiftTypeKey,
        staffCategoryKey,
        startTime: shiftStartDateTime
      });
    }
  }
  const partialShifts = staffShifts == null ? void 0 : staffShifts.filter((shift) => shift.customDuration && shift.customStartTime);
  const { gaps, partialOverages } = fillGapsWithPartialShifts(date, partialShifts, dateShiftTypeGaps, staffCategoryKey, shiftType);
  let mergedPartialOverages = partialOverages;
  if (partialOverages.length) {
    const mergeResult = mergeDateTimeRanges(partialOverages, shiftStartDateTime, shiftType.durationSeconds);
    mergedPartialOverages = mergeResult.mergedRanges;
  }
  return {
    gaps,
    overages: [
      ...mergedPartialOverages,
      ...fullOverages
    ]
  };
}
__name(findScheduleDateGaps, "findScheduleDateGaps");
function fillGapsWithPartialShifts(date, partialShifts, dateShiftTypeGaps, staffCategoryKey, shiftType) {
  const overages = [];
  const { startTime: shiftTypeStartTime, endTime: shiftTypeEndTime } = getShiftRange(date, shiftType.startTime, shiftType.durationSeconds);
  for (const shift of partialShifts != null ? partialShifts : []) {
    if (!(shift == null ? void 0 : shift.customStartTime) || !(shift == null ? void 0 : shift.customDuration)) continue;
    const updatedGaps = [];
    let fillingShift = shift;
    for (const gap of dateShiftTypeGaps) {
      if (!fillingShift) {
        updatedGaps.push(gap);
        continue;
      }
      if (!(fillingShift == null ? void 0 : fillingShift.customStartTime) || !fillingShift.customDuration) continue;
      const { startTime: customStartDateTime, endTime: customEndDateTime } = getShiftRange(date, shiftType.startTime, shiftType.durationSeconds, fillingShift);
      const result = diffDateTimeRange(gap, {
        durationSeconds: fillingShift.customDuration,
        endTime: customEndDateTime,
        shiftTypeKey: shift.shiftTypeKey,
        staffCategoryKey,
        startTime: customStartDateTime
      });
      if ((result == null ? void 0 : result.range1Diff) && result.range1Diff.length > 0) {
        updatedGaps.push(...result.range1Diff);
      }
      if ((result == null ? void 0 : result.range2Diff) && result.range2Diff.length > 0) {
        fillingShift = {
          customDuration: result.range2Diff[0].durationSeconds,
          customStartTime: dateToTimeString(result.range2Diff[0].startTime),
          date: shift.date,
          shiftTypeKey: shift.shiftTypeKey
        };
        if (result.range2Diff.length > 1) {
          partialShifts.push({
            customDuration: result.range2Diff[1].durationSeconds,
            customStartTime: dateToTimeString(result.range2Diff[1].startTime),
            date: shift.date,
            shiftTypeKey: shift.shiftTypeKey
          });
        }
      } else {
        fillingShift = void 0;
      }
    }
    dateShiftTypeGaps = updatedGaps;
    if (fillingShift) {
      const { startTime: fillingStartDateTime, endTime: fillingEndDateTime } = getShiftRange(date, shiftType.startTime, shiftType.durationSeconds, fillingShift);
      const overlapStart = fillingStartDateTime > shiftTypeStartTime ? fillingStartDateTime : shiftTypeStartTime;
      const overlapEnd = fillingEndDateTime < shiftTypeEndTime ? fillingEndDateTime : shiftTypeEndTime;
      if (overlapStart < overlapEnd) {
        overages.push({
          durationSeconds: fillingShift == null ? void 0 : fillingShift.customDuration,
          endTime: overlapEnd,
          shiftTypeKey: shift.shiftTypeKey,
          staffCategoryKey,
          startTime: overlapStart
        });
      }
    }
  }
  return {
    gaps: dateShiftTypeGaps,
    partialOverages: overages
  };
}
__name(fillGapsWithPartialShifts, "fillGapsWithPartialShifts");

// src/schedule/utils/findScheduleGaps.ts
var import_lodash8 = __toESM(require_lodash());

// src/schedule/utils/helpers.ts
var getShiftCategory = /* @__PURE__ */ __name((shift, staffCategoryById, staffTypeByStaffJobId) => {
  var _a;
  return shift.staffJobId && ((_a = staffTypeByStaffJobId == null ? void 0 : staffTypeByStaffJobId[shift.staffJobId]) == null ? void 0 : _a.staffCategoryKey) || staffCategoryById.get(shift.staffId);
}, "getShiftCategory");

// src/schedule/utils/findScheduleGaps.ts
function findScheduleGaps(schedule, staffShifts, scheduleShiftTypes, timeTargetLevels, unitTypeTargetLevels, staffCategoryById, staffTypeByStaffJobId) {
  const shiftsByDate = groupStaffShiftsByDate(staffShifts, scheduleShiftTypes, schedule.timezone);
  const targetLevelsByDate = groupTargetLevelsByDate(timeTargetLevels, schedule.timezone);
  const scheduleDates = getDatesInRange(getTzDate(schedule.startDay, schedule.timezone), getTzDate(schedule.endDay, schedule.timezone));
  let allGapsByDate = /* @__PURE__ */ new Map();
  let allOveragesByDate = /* @__PURE__ */ new Map();
  scheduleDates.forEach((date) => {
    var _a;
    for (const shiftType of scheduleShiftTypes != null ? scheduleShiftTypes : []) {
      const fullDate = dateTimeAndTimeStringToDateTime(date, shiftType.startTime);
      const dateString = getTzFormattedDate(fullDate, schedule.timezone);
      const categoryTargets = resolveTargetLevelForDate(dateString, shiftType.key, targetLevelsByDate, unitTypeTargetLevels);
      for (const categoryTarget of categoryTargets) {
        const shifts = shiftsByDate.get(dateString);
        const shiftsOfType = shifts == null ? void 0 : shifts.filter((shift) => shift.shiftTypeKey === shiftType.key && getShiftCategory(shift, staffCategoryById, staffTypeByStaffJobId) === categoryTarget.staffCategoryKey && // exclude called in, cancelled, flexed and on call shifts
        shift.status !== StaffShift.EStatus.calledIn && shift.status !== StaffShift.EStatus.cancelled && shift.status !== StaffShift.EStatus.flexed && shift.status !== StaffShift.EStatus.onCall);
        const dateShiftTypeGaps = findScheduleDateGaps(date, shiftType, shiftsOfType != null ? shiftsOfType : [], categoryTarget.targetLevel, (_a = categoryTarget.staffCategoryKey) != null ? _a : "");
        const { gapsByDate, overagesByDate } = addGapsAndOveragesToMaps(dateShiftTypeGaps, dateString, allGapsByDate, allOveragesByDate);
        allGapsByDate = gapsByDate;
        allOveragesByDate = overagesByDate;
      }
    }
  });
  return {
    gapsByDate: allGapsByDate,
    overagesByDate: allOveragesByDate
  };
}
__name(findScheduleGaps, "findScheduleGaps");
function groupStaffShiftsByDate(staffShifts, scheduleShiftTypes, timezone) {
  const shiftsByDate = /* @__PURE__ */ new Map();
  staffShifts.forEach((shift) => {
    const shiftType = scheduleShiftTypes == null ? void 0 : scheduleShiftTypes.find((shty) => shty.key === shift.shiftTypeKey);
    if (!shiftType) return;
    const fullDate = dateTimeAndTimeStringToDateTime(getTzDate(shift.date, timezone), shiftType.startTime);
    const shifts = shiftsByDate.get(getTzFormattedDate(fullDate));
    if (shifts) {
      shifts.push(shift);
    } else {
      shiftsByDate.set(getTzFormattedDate(fullDate), [
        shift
      ]);
    }
  });
  return shiftsByDate;
}
__name(groupStaffShiftsByDate, "groupStaffShiftsByDate");
function groupTargetLevelsByDate(targetLevels, _timezone) {
  const timeTargetLevelsByDate = /* @__PURE__ */ new Map();
  targetLevels.forEach((targetLevel) => {
    if (!targetLevel.date) return;
    const dateKey = getTzFormattedDate(getTzDate(targetLevel.date, "UTC"), "UTC");
    const levels = timeTargetLevelsByDate.get(dateKey);
    if (levels) {
      levels.push(targetLevel);
    } else {
      timeTargetLevelsByDate.set(dateKey, [
        targetLevel
      ]);
    }
  });
  return timeTargetLevelsByDate;
}
__name(groupTargetLevelsByDate, "groupTargetLevelsByDate");
function resolveTargetLevelForDate(dateString, shiftTypeKey, targetLevelsByDate, unitTargetLevels) {
  var _a;
  const shiftTypeUnitTargets = unitTargetLevels.filter((target) => (0, import_lodash8.isEqual)(target.shiftTypeKeys, [
    shiftTypeKey
  ]));
  const categoryTargetLevels = shiftTypeUnitTargets.map((target) => ({
    shiftTypeKey,
    staffCategoryKey: target.staffCategoryKey,
    targetLevel: target.min
  }));
  const dateTargetLevels = (_a = targetLevelsByDate.get(dateString)) == null ? void 0 : _a.filter((target) => target.shiftTypeKey === shiftTypeKey);
  if (dateTargetLevels && dateTargetLevels.length > 0) {
    for (const target of dateTargetLevels) {
      const categoryTargetIndex = categoryTargetLevels.findIndex((categoryTarget) => categoryTarget.staffCategoryKey === target.staffCategoryKey);
      if (categoryTargetIndex >= 0) {
        categoryTargetLevels[categoryTargetIndex].targetLevel = target.min;
      } else {
        categoryTargetLevels.push({
          shiftTypeKey,
          staffCategoryKey: target.staffCategoryKey,
          targetLevel: target.min
        });
      }
    }
  }
  return categoryTargetLevels;
}
__name(resolveTargetLevelForDate, "resolveTargetLevelForDate");
function addGapsAndOveragesToMaps(dateShiftTypeGaps, dateString, gapsByDate, overagesByDate) {
  var _a;
  if (!gapsByDate.has(dateString)) {
    gapsByDate.set(dateString, []);
  }
  (_a = gapsByDate.get(dateString)) == null ? void 0 : _a.push(...dateShiftTypeGaps.gaps);
  const overages = overagesByDate.get(dateString);
  if (overages) {
    overages.push(...dateShiftTypeGaps.overages);
  } else {
    overagesByDate.set(dateString, dateShiftTypeGaps.overages);
  }
  return {
    gapsByDate,
    overagesByDate
  };
}
__name(addGapsAndOveragesToMaps, "addGapsAndOveragesToMaps");

// src/schedule/utils/getScheduleCoverage.ts
var import_lodash10 = __toESM(require_lodash());

// src/schedule/utils/getScheduleDateCoverage.ts
var import_lodash9 = __toESM(require_lodash());
function getScheduleDateCoverage(date, shiftType, staffShifts, staffCategoryKey) {
  const shiftTypeKey = shiftType.key;
  const fullShifts = staffShifts == null ? void 0 : staffShifts.filter((shift) => !shift.customDuration && !shift.customStartTime);
  const partialShifts = staffShifts == null ? void 0 : staffShifts.filter((shift) => shift.customDuration && shift.customStartTime);
  const { startTime: shiftStartDateTime } = getShiftRange(date, shiftType.startTime, shiftType.durationSeconds);
  let fullShiftCount = fullShifts.length;
  let mergedTotalShiftCount = fullShiftCount;
  const partialShiftRanges = partialShifts.map((shift) => {
    var _a;
    const { startTime, endTime } = getShiftRange(date, shiftType.startTime, shiftType.durationSeconds, shift);
    return {
      durationSeconds: (_a = shift.customDuration) != null ? _a : shiftType.durationSeconds,
      endTime,
      startTime
    };
  });
  const mergeResult = mergeDateTimeRanges(partialShiftRanges, shiftStartDateTime, shiftType.durationSeconds);
  mergedTotalShiftCount += mergeResult.totalRangeCount;
  fullShiftCount += mergeResult.fullRangeCount;
  const actualCoverageSeconds = fullShifts.length * shiftType.durationSeconds + (0, import_lodash9.sum)(mergeResult.mergedRanges.map((range) => range.durationSeconds));
  return {
    coverageSeconds: actualCoverageSeconds,
    date: getTzFormattedDate(date),
    fullShiftCount,
    shiftTypeKey,
    staffCategoryKey,
    totalShiftCount: mergedTotalShiftCount
  };
}
__name(getScheduleDateCoverage, "getScheduleDateCoverage");

// src/schedule/utils/getScheduleCoverage.ts
function getScheduleCoverage(schedule, staffShifts, scheduleShiftTypes, staffCategoryById, staffTypeByStaffJobId) {
  const shiftsByDate = groupStaffShiftsByDate2(staffShifts, scheduleShiftTypes, schedule.timezone);
  const scheduleDates = getDatesInRange(getTzDate(schedule.startDay, schedule.timezone), getTzDate(schedule.endDay, schedule.timezone));
  const shiftStaffCategories = (0, import_lodash10.compact)((0, import_lodash10.uniq)(staffShifts == null ? void 0 : staffShifts.flatMap((shift) => {
    var _a;
    return [
      staffCategoryById.get(shift.staffId),
      shift.staffJobId && ((_a = staffTypeByStaffJobId == null ? void 0 : staffTypeByStaffJobId[shift.staffJobId]) == null ? void 0 : _a.staffCategoryKey)
    ];
  })));
  let allCoverageByDate = /* @__PURE__ */ new Map();
  scheduleDates.forEach((date) => {
    const dateString = getTzFormattedDate(date, schedule.timezone);
    const shifts = shiftsByDate.get(dateString);
    if (!(shifts == null ? void 0 : shifts.length)) return;
    for (const shiftType of scheduleShiftTypes) {
      for (const shiftCategory of shiftStaffCategories) {
        const shiftsOfType = shifts == null ? void 0 : shifts.filter((shift) => shift.shiftTypeKey === shiftType.key && getShiftCategory(shift, staffCategoryById, staffTypeByStaffJobId) === shiftCategory && // exclude called in, cancelled, flexed and on call shifts
        shift.status !== StaffShift.EStatus.calledIn && shift.status !== StaffShift.EStatus.cancelled && shift.status !== StaffShift.EStatus.flexed && shift.status !== StaffShift.EStatus.onCall);
        const dateShiftTypeCoverage = getScheduleDateCoverage(date, shiftType, shiftsOfType != null ? shiftsOfType : [], shiftCategory != null ? shiftCategory : "");
        const coverageByDate = addCoverageToMaps(dateShiftTypeCoverage, dateString, allCoverageByDate, shiftType.key, shiftCategory != null ? shiftCategory : "");
        allCoverageByDate = coverageByDate;
      }
    }
  });
  return {
    coverageByDate: allCoverageByDate
  };
}
__name(getScheduleCoverage, "getScheduleCoverage");
function groupStaffShiftsByDate2(staffShifts, scheduleShiftTypes, timezone) {
  const shiftsByDate = /* @__PURE__ */ new Map();
  staffShifts.forEach((shift) => {
    const shiftType = scheduleShiftTypes == null ? void 0 : scheduleShiftTypes.find((shty) => shty.key === shift.shiftTypeKey);
    if (!shiftType) return;
    const fullDate = dateTimeAndTimeStringToDateTime(getTzDate(shift.date, timezone), shiftType.startTime);
    const shifts = shiftsByDate.get(getTzFormattedDate(fullDate));
    if (shifts) {
      shifts.push(shift);
    } else {
      shiftsByDate.set(getTzFormattedDate(fullDate), [
        shift
      ]);
    }
  });
  return shiftsByDate;
}
__name(groupStaffShiftsByDate2, "groupStaffShiftsByDate");
function addCoverageToMaps(dateShiftTypeCoverage, dateString, coverageByDate, shiftTypeKey, staffCategoryKey) {
  var _a;
  if (!coverageByDate.has(dateString)) {
    coverageByDate.set(dateString, []);
  }
  (_a = coverageByDate.get(dateString)) == null ? void 0 : _a.push(__spreadProps(__spreadValues({}, dateShiftTypeCoverage), {
    date: dateString,
    shiftTypeKey,
    staffCategoryKey
  }));
  return coverageByDate;
}
__name(addCoverageToMaps, "addCoverageToMaps");

// src/shared-configs/index.ts
var import_eslintConfig = __toESM(require_eslintConfig());

// src/shared-configs/luxon.ts
var import_luxon8 = require("luxon");
var setupLuxon = /* @__PURE__ */ __name(() => {
  import_luxon8.Settings.defaultWeekSettings = {
    firstDay: 7,
    minimalDays: import_luxon8.Info.getMinimumDaysInFirstWeek(),
    weekend: import_luxon8.Info.getWeekendWeekdays()
  };
}, "setupLuxon");

// src/shared-configs/index.ts
var M7ESlintConfig = import_eslintConfig.default;

// src/system-event-schemas/events/generics/DatabaseEvent.ts
var import_v422 = require("zod/v4");

// src/system-event-schemas/events/_shared/author.ts
var import_v418 = require("zod/v4");

// src/system-event-schemas/entities/schedule.ts
var import_v47 = require("zod/v4");

// src/system-event-schemas/customZodType/timeString.ts
var import_v4 = require("zod/v4");
var ZodTimeStringValidator = /* @__PURE__ */ __name((val) => {
  if (typeof val !== "string") return false;
  const [hours, minutes, seconds, maybeMs, ...rest] = val.split(":");
  if ((hours == null ? void 0 : hours.length) !== 2 || (minutes == null ? void 0 : minutes.length) !== 2 || (seconds == null ? void 0 : seconds.length) !== 2 || maybeMs && (maybeMs == null ? void 0 : maybeMs.length) >= 3 || (rest == null ? void 0 : rest.length) > 0) {
    return false;
  }
  return true;
}, "ZodTimeStringValidator");
var ZodTimeString = import_v4.z.custom(ZodTimeStringValidator);

// src/system-event-schemas/customZodType/timezone.ts
var import_v42 = require("zod/v4");
var ZodTimezone = import_v42.z.custom();

// src/system-event-schemas/customZodType/yyyyMmDd.ts
var import_v43 = require("zod/v4");
var ZodYyyyMmDdValidator = /* @__PURE__ */ __name((val) => {
  if (typeof val !== "string") return false;
  const [year, month, day, ...rest] = val.split("-");
  if ((year == null ? void 0 : year.length) !== 4 || (month == null ? void 0 : month.length) !== 2 || (day == null ? void 0 : day.length) !== 2 || (rest == null ? void 0 : rest.length) > 0) {
    return false;
  }
  return true;
}, "ZodYyyyMmDdValidator");
var ZodYyyyMmDd = import_v43.z.custom(ZodYyyyMmDdValidator);

// src/system-event-schemas/entities/shared.ts
var import_v44 = require("zod/v4");
var baseEntitySchema = import_v44.z.object({
  id: import_v44.z.uuid()
});
var entityWithTimestampsSchema = baseEntitySchema.extend({
  createdAt: import_v44.z.iso.datetime(),
  updatedAt: import_v44.z.iso.datetime()
});
var softDeletableEntitySchema = baseEntitySchema.extend({
  deletedAt: import_v44.z.iso.datetime().nullable()
});
var archivableEntitySchema = entityWithTimestampsSchema.extend({
  archivedAt: import_v44.z.iso.datetime().nullable()
});

// src/system-event-schemas/entities/unitHierarchy/healthSystem.ts
var import_v45 = require("zod/v4");
var healthSystemSchema = import_v45.z.object(__spreadProps(__spreadValues(__spreadValues(__spreadValues({}, baseEntitySchema.shape), archivableEntitySchema.shape), entityWithTimestampsSchema.shape), {
  name: import_v45.z.string()
})).meta({
  id: "entity:healthSystem"
});

// src/system-event-schemas/entities/unitHierarchy/unit.ts
var import_v46 = require("zod/v4");
var unitSchema = import_v46.z.object({}).merge(baseEntitySchema).extend({
  name: import_v46.z.string(),
  timezone: ZodTimezone,
  scheduleDurationInWeeks: import_v46.z.number(),
  weekendDays: import_v46.z.array(import_v46.z.number()),
  // TODO
  // configuration: z.object({...})
  configuration: import_v46.z.any()
}).meta({
  id: "entity:unit"
});

// src/system-event-schemas/entities/schedule.ts
var scheduleSchema = import_v47.z.object(__spreadProps(__spreadValues(__spreadValues({}, baseEntitySchema.shape), entityWithTimestampsSchema.shape), {
  unitId: unitSchema.shape.id,
  // Attributes
  timezone: ZodTimezone,
  status: import_v47.z.enum(Schedule.EStatus),
  // Date related
  startTime: import_v47.z.iso.datetime(),
  startDay: ZodYyyyMmDd,
  endTime: import_v47.z.iso.datetime(),
  endDay: ZodYyyyMmDd,
  staffsInputDeadline: ZodYyyyMmDd,
  staffsInputDeadlineTime: import_v47.z.iso.datetime(),
  targetPublishDeadline: ZodYyyyMmDd.nullable(),
  targetPublishDeadlineTime: import_v47.z.iso.datetime().nullable()
})).meta({
  id: "entity:schedule"
});

// src/system-event-schemas/entities/shiftIncentiveLevel.ts
var import_v48 = require("zod/v4");
var shiftIncentiveLevelSchema = import_v48.z.object(__spreadProps(__spreadValues(__spreadValues(__spreadValues({}, baseEntitySchema.shape), entityWithTimestampsSchema.shape), softDeletableEntitySchema.shape), {
  label: import_v48.z.string(),
  key: import_v48.z.string(),
  unitId: unitSchema.shape.id
}));

// src/system-event-schemas/entities/shiftTypes/scheduleShiftType.ts
var import_v411 = require("zod/v4");

// src/system-event-schemas/entities/shiftTypes/shiftType.ts
var import_v49 = require("zod/v4");
var shiftTypeSchema = import_v49.z.object({
  key: import_v49.z.string(),
  name: import_v49.z.string(),
  // Time related
  durationSeconds: import_v49.z.number(),
  startTime: ZodTimeString,
  // Boolean that defines the type of shift
  isHouseSupervisorShift: import_v49.z.boolean(),
  isPaidShift: import_v49.z.boolean(),
  isPatientCareShift: import_v49.z.boolean(),
  isWorkingShift: import_v49.z.boolean()
}).meta({
  id: "entity:shiftType"
});

// src/system-event-schemas/entities/shiftTypes/unitShiftType.ts
var import_v410 = require("zod/v4");
var unitShiftTypeSchema = import_v410.z.object(__spreadProps(__spreadValues(__spreadValues({}, baseEntitySchema.shape), shiftTypeSchema.shape), {
  unitId: unitSchema.shape.id
})).meta({
  id: "entity:unitShiftType"
});

// src/system-event-schemas/entities/shiftTypes/scheduleShiftType.ts
var scheduleShiftTypeSchema = import_v411.z.object(__spreadProps(__spreadValues(__spreadValues({}, baseEntitySchema.shape), shiftTypeSchema.shape), {
  scheduleId: scheduleSchema.shape.id,
  unitShiftTypeId: unitShiftTypeSchema.shape.id
})).meta({
  id: "entity:scheduleShiftType"
});

// src/system-event-schemas/entities/staffDetails.ts
var import_v416 = require("zod/v4");

// src/system-event-schemas/entities/staffJobs/staffCategory.ts
var import_v412 = require("zod/v4");
var staffCategorySchema = import_v412.z.object({
  key: import_v412.z.string(),
  name: import_v412.z.string()
}).meta({
  id: "entity:staffCategory"
});

// src/system-event-schemas/entities/staffJobs/staffJob.ts
var import_v414 = require("zod/v4");

// src/system-event-schemas/entities/staffJobs/staffType.ts
var import_v413 = require("zod/v4");
var staffTypeSchema = import_v413.z.object({
  key: import_v413.z.string(),
  name: import_v413.z.string(),
  staffCategoryKey: staffCategorySchema.shape.key,
  description: import_v413.z.string().nullable()
}).meta({
  id: "entity:staffType"
});

// src/system-event-schemas/entities/staffJobs/staffJob.ts
var staffJobSchema = import_v414.z.object(__spreadProps(__spreadValues(__spreadValues(__spreadValues({}, baseEntitySchema.shape), entityWithTimestampsSchema.shape), archivableEntitySchema.shape), {
  name: import_v414.z.string(),
  externalId: import_v414.z.string().nullable(),
  description: import_v414.z.string().nullable(),
  staffTypeKey: staffTypeSchema.shape.key,
  healthSystemId: healthSystemSchema.shape.id
})).meta({
  id: "entity:staffJob"
});

// src/system-event-schemas/entities/user.ts
var import_v415 = require("zod/v4");
var userSchema = import_v415.z.object(__spreadProps(__spreadValues({}, baseEntitySchema.shape), {
  email: import_v415.z.string(),
  firstName: import_v415.z.string(),
  lastName: import_v415.z.string(),
  unitIds: import_v415.z.array(unitSchema.shape.id),
  roles: import_v415.z.array(import_v415.z.enum(User.ERole)),
  isSoftDeleted: import_v415.z.boolean(),
  softDeletedDate: import_v415.z.iso.datetime().nullable()
})).meta({
  id: "entity:user"
});

// src/system-event-schemas/entities/staffDetails.ts
var staffDetailsSchema = import_v416.z.object(__spreadProps(__spreadValues({}, baseEntitySchema.shape), {
  homeUnitId: unitSchema.shape.id,
  userId: userSchema.shape.id,
  employmentType: import_v416.z.enum(StaffDetails.EEmploymentType),
  staffCategoryKey: import_v416.z.string(),
  staffTypeKey: import_v416.z.string(),
  principalStaffJobId: staffJobSchema.shape.id.nullable(),
  status: import_v416.z.enum(StaffDetails.EStaffStatus)
})).meta({
  id: "entity:staffDetails"
});

// src/system-event-schemas/entities/staffShift.ts
var import_v417 = require("zod/v4");
var staffShiftSchema = import_v417.z.object(__spreadProps(__spreadValues(__spreadValues(__spreadValues({}, baseEntitySchema.shape), entityWithTimestampsSchema.shape), softDeletableEntitySchema.shape), {
  scheduleId: scheduleSchema.shape.id,
  scheduleType: import_v417.z.enum(StaffShift.EScheduleType),
  shiftTypeKey: scheduleShiftTypeSchema.shape.key,
  staffId: userSchema.shape.id,
  incentiveLevelId: shiftIncentiveLevelSchema.shape.id,
  staffJobId: staffJobSchema.shape.id.nullable(),
  date: ZodYyyyMmDd,
  customDuration: import_v417.z.number().nullable(),
  customStartTime: ZodTimeString.nullable(),
  isWorkingAway: import_v417.z.boolean(),
  status: import_v417.z.enum(StaffShift.EShiftStatus).nullable(),
  attributes: import_v417.z.array(import_v417.z.string())
})).meta({
  id: "entity:staffShift"
});

// src/system-event-schemas/events/_shared/author.ts
var userAuthorSchema = import_v418.z.object(__spreadProps(__spreadValues({}, userSchema.pick({
  id: true,
  email: true,
  firstName: true,
  lastName: true,
  roles: true
}).shape), {
  type: import_v418.z.literal("user")
}));
var machineAuthorSchema = import_v418.z.object({
  id: import_v418.z.string(),
  key: import_v418.z.string(),
  name: import_v418.z.string(),
  type: import_v418.z.literal("machine")
});
var authorSchema = import_v418.z.union([
  userAuthorSchema,
  machineAuthorSchema
]).meta({
  id: "_shared:author"
});

// src/system-event-schemas/events/_shared/context.ts
var import_v419 = require("zod/v4");
var contextSchema = import_v419.z.object({
  author: authorSchema,
  facilityId: import_v419.z.uuid(),
  healthSystemId: import_v419.z.uuid(),
  unitId: import_v419.z.uuid(),
  tenant: import_v419.z.string()
}).meta({
  id: "_shared:context"
});

// src/system-event-schemas/events/_shared/eventSchema.ts
var import_v420 = require("zod/v4");
var eventSchema = /* @__PURE__ */ __name((eventType) => import_v420.z.object({
  id: import_v420.z.string(),
  origin: import_v420.z.object({
    id: import_v420.z.string().optional(),
    type: import_v420.z.string()
  }),
  timestamp: import_v420.z.number(),
  type: eventType
}), "eventSchema");

// src/system-event-schemas/events/_shared/helpers.ts
var import_v421 = require("zod/v4");
var zUpdatedField = /* @__PURE__ */ __name((schema) => import_v421.z.object({
  from: schema,
  to: schema
}).optional(), "zUpdatedField");

// src/system-event-schemas/events/generics/DatabaseEvent.ts
var databaseEventSchema = import_v422.z.looseObject({
  context: contextSchema,
  event: import_v422.z.looseObject({
    type: import_v422.z.string()
  })
});

// src/system-event-schemas/events/staffShift/created.ts
var import_v424 = require("zod/v4");

// src/system-event-schemas/events/staffShift/shared.ts
var import_v423 = require("zod/v4");
var fullShiftSchema = import_v423.z.object({
  staffShift: staffShiftSchema.omit({
    scheduleId: true,
    shiftTypeKey: true,
    staffId: true,
    incentiveLevelId: true,
    staffJobId: true
  }).extend({
    staffJob: staffJobSchema.nullable(),
    incentiveLevel: shiftIncentiveLevelSchema.nullable(),
    schedule: scheduleSchema.omit({
      unitId: true
    }).extend({
      unit: unitSchema
    }),
    shiftType: scheduleShiftTypeSchema,
    staff: userSchema.omit({
      unitIds: true,
      roles: true
    }).extend({
      staffDetails: staffDetailsSchema.omit({
        homeUnitId: true,
        staffTypeKey: true,
        staffCategoryKey: true,
        principalStaffJobId: true
      }).extend({
        homeUnit: unitSchema,
        staffType: staffTypeSchema,
        staffCategory: staffCategorySchema,
        principalStaffJob: staffJobSchema.nullable()
      })
    })
  })
}).meta({
  id: "staffShift_shared:fullShift"
});

// src/system-event-schemas/events/staffShift/created.ts
var staffShiftCreatedSchema = import_v424.z.object({
  context: contextSchema,
  event: eventSchema(import_v424.z.literal("staffShift.created")),
  resource: fullShiftSchema
}).meta({
  id: "staffShift.created"
});

// src/system-event-schemas/events/staffShift/updated.ts
var import_v425 = require("zod/v4");
var staffShiftUpdatedSchema = import_v425.z.object({
  context: contextSchema,
  event: eventSchema(import_v425.z.literal("staffShift.updated")),
  metadata: import_v425.z.object({
    updatedFields: import_v425.z.object({
      attributes: zUpdatedField(staffShiftSchema.shape.attributes),
      customDuration: zUpdatedField(staffShiftSchema.shape.customDuration),
      customStartTime: zUpdatedField(staffShiftSchema.shape.customStartTime),
      date: zUpdatedField(staffShiftSchema.shape.date),
      isWorkingAway: zUpdatedField(staffShiftSchema.shape.isWorkingAway),
      schedule: zUpdatedField(fullShiftSchema.shape.staffShift.shape.schedule),
      shiftType: zUpdatedField(fullShiftSchema.shape.staffShift.shape.shiftType),
      status: zUpdatedField(staffShiftSchema.shape.status),
      deletedAt: zUpdatedField(staffShiftSchema.shape.deletedAt),
      incentiveLevel: zUpdatedField(fullShiftSchema.shape.staffShift.shape.incentiveLevel)
    })
  }),
  resource: fullShiftSchema
}).meta({
  id: "staffShift.updated"
});

// src/system-event-schemas/events/index.ts
(function(SystemEvents2) {
  (function(ETypes) {
    ETypes["staffShiftCreated"] = "staffShift.created";
    ETypes["staffShiftUpdated"] = "staffShift.updated";
  })(SystemEvents2.ETypes || (SystemEvents2.ETypes = {}));
  SystemEvents2.databaseEventSchema = databaseEventSchema;
  SystemEvents2.staffShiftCreatedSchema = staffShiftCreatedSchema;
  SystemEvents2.staffShiftUpdatedSchema = staffShiftUpdatedSchema;
})(SystemEvents || (SystemEvents = {}));
var SystemEvents;

// src/system-event-schemas/open-api/zod4.showcase.ts
var import_v426 = require("zod/v4");
var testZodV4 = import_v426.z.object({
  age: import_v426.z.number(),
  name: import_v426.z.string()
});
var testZodV4JsonSchema = import_v426.z.toJSONSchema(testZodV4);

// src/index.ts
var VERSION = "1.1.16";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DateCmp,
  DateTime,
  DateTimeMaybeValid,
  ECommunicationMethod,
  ELoginCommunicationType,
  EPermissionVerbs,
  EUnitPermissionAreas,
  EWeekDay,
  Facility,
  FeatureFlags,
  M7ESlintConfig,
  PreferenceRequirementRuleSet,
  PreferenceRequirementRuleSetEngine,
  Role,
  RuleSetChecks,
  Schedule,
  ShiftType,
  StaffDetails,
  StaffShift,
  SystemEvents,
  TIMEZONES,
  US_MAJOR_CITY_TIMEZONES,
  Unit,
  User,
  VERSION,
  _dayjsAdvancedFormat,
  _dayjsCalendar,
  _dayjsCustomParseFormat,
  _dayjsDuration,
  _dayjsIsBetween,
  _dayjsIsSameOrAfter,
  _dayjsIsSameOrBefore,
  _dayjsIsoWeek,
  _dayjsLocaleData,
  _dayjsLocalizedFormat,
  _dayjsMinMax,
  _dayjsRelativeTime,
  _dayjsTimezone,
  _dayjsUtc,
  _dayjsWeekOfYear,
  buildOverlapItem,
  closeDateCache,
  dateAndTimeStringsToDateTime,
  dateTimeAndTimeStringToDateTime,
  dateToTimeString,
  dayjsMax,
  dayjsMin,
  diffDateTimeRange,
  enableDateCacheTimeout,
  endOfWeek,
  findScheduleDateGaps,
  findScheduleGaps,
  getDatesInRange,
  getScheduleCoverage,
  getScheduleDateCoverage,
  getShiftRange,
  getTotalOverlapTimeInSeconds,
  getTzDate,
  getTzDayjs,
  getTzFormattedDate,
  getTzFormattedTime,
  getWeekDay,
  isWeekendShift,
  isWeekendTime,
  legacyGetDatesInRange,
  m7DayJs,
  mergeDateTimeRanges,
  nextWeekday,
  prevWeekday,
  setupLuxon,
  startOfWeek,
  testZodV4,
  testZodV4JsonSchema,
  timeAdd,
  timeInTzToDayjs,
  timeOverlap,
  timeStringToDate,
  timeStringToDateTime,
  timeStringToDayjs,
  toISO,
  trimMs,
  tzAddPlugin
});
/*! Bundled license information:

lodash/lodash.js:
  (**
   * @license
   * Lodash <https://lodash.com/>
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)
*/
//# sourceMappingURL=index.js.map